import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AnyScalar: { input: any; output: any; }
  AuthProcessContentDynamicZoneInput: { input: any; output: any; }
  BasketPageContentDynamicZoneInput: { input: any; output: any; }
  BlogArticleContentDynamicZoneInput: { input: any; output: any; }
  ConfiguratorPageContentDynamicZoneInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  HomepageContentDynamicZoneInput: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JobContentDynamicZoneInput: { input: any; output: any; }
  JobOverviewContentDynamicZoneInput: { input: any; output: any; }
  ProductPageContentDynamicZoneInput: { input: any; output: any; }
  ProductSearch_PropertyValue: { input: any; output: any; }
  SearchPageContentBottomDynamicZoneInput: { input: any; output: any; }
  SearchPageContentTopDynamicZoneInput: { input: any; output: any; }
  StandardPageContentDynamicZoneInput: { input: any; output: any; }
  TenantPageContentDynamicZoneInput: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AccessoryInput = {
  identifier: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type AccessoryPrice = {
  __typename?: 'AccessoryPrice';
  identifier: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
  price: Price;
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AddOrUpdateCartItemInput = {
  item: CartItemInput;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  location?: Maybe<Location>;
  locationQuality?: Maybe<LocationQuality>;
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressDataModel = {
  __typename?: 'AddressDataModel';
  city: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export enum AddressFieldEnum {
  City = 'CITY',
  Country = 'COUNTRY',
  Street = 'STREET',
  StreetNumber = 'STREET_NUMBER',
  Zip = 'ZIP'
}

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AddressModel = {
  __typename?: 'AddressModel';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Sort Address list by */
export enum AddressSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type AdvancedCacheManagerRecord = {
  __typename?: 'AdvancedCacheManagerRecord';
  cacheType?: Maybe<Enum_Advancedcachemanagerrecord_Cachetype>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  invalidationId?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdvancedCacheManagerRecordEntity = {
  __typename?: 'AdvancedCacheManagerRecordEntity';
  attributes?: Maybe<AdvancedCacheManagerRecord>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AdvancedCacheManagerRecordEntityResponse = {
  __typename?: 'AdvancedCacheManagerRecordEntityResponse';
  data?: Maybe<AdvancedCacheManagerRecordEntity>;
};

export type AdvancedCacheManagerRecordEntityResponseCollection = {
  __typename?: 'AdvancedCacheManagerRecordEntityResponseCollection';
  data: Array<AdvancedCacheManagerRecordEntity>;
  meta: ResponseCollectionMeta;
};

export type AdvancedCacheManagerRecordFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AdvancedCacheManagerRecordFiltersInput>>>;
  cacheType?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  invalidationId?: InputMaybe<StringFilterInput>;
  items?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AdvancedCacheManagerRecordFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AdvancedCacheManagerRecordFiltersInput>>>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AdvancedCacheManagerRecordInput = {
  cacheType?: InputMaybe<Enum_Advancedcachemanagerrecord_Cachetype>;
  invalidationId?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyCouponInput = {
  couponCode: Scalars['String']['input'];
};

export type AuthProcess = {
  __typename?: 'AuthProcess';
  content?: Maybe<Array<Maybe<AuthProcessContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailVerifiedMessage?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AuthProcessRelationResponseCollection>;
  loginPageTitle?: Maybe<Scalars['String']['output']>;
  signInIntroText?: Maybe<Scalars['String']['output']>;
  signUpSuccessMessage?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthProcessContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNavigationLinkWrapper | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPopularCategories | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentSlugSelector | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type AuthProcessEntity = {
  __typename?: 'AuthProcessEntity';
  attributes?: Maybe<AuthProcess>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AuthProcessEntityResponse = {
  __typename?: 'AuthProcessEntityResponse';
  data?: Maybe<AuthProcessEntity>;
};

export type AuthProcessInput = {
  content?: InputMaybe<Array<Scalars['AuthProcessContentDynamicZoneInput']['input']>>;
  emailVerifiedMessage?: InputMaybe<Scalars['String']['input']>;
  loginPageTitle?: InputMaybe<Scalars['String']['input']>;
  signInIntroText?: InputMaybe<Scalars['String']['input']>;
  signUpSuccessMessage?: InputMaybe<Scalars['String']['input']>;
};

export type AuthProcessRelationResponseCollection = {
  __typename?: 'AuthProcessRelationResponseCollection';
  data: Array<AuthProcessEntity>;
};

export type AuthenticateInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AuthenticateResponse = {
  __typename?: 'AuthenticateResponse';
  migrated: Scalars['Boolean']['output'];
};

export type Author = {
  __typename?: 'Author';
  avatar?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AuthorRelationResponseCollection>;
  name: Scalars['String']['output'];
  prismicId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AuthorLocalizationsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AuthorEntity = {
  __typename?: 'AuthorEntity';
  attributes?: Maybe<Author>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AuthorEntityResponse = {
  __typename?: 'AuthorEntityResponse';
  data?: Maybe<AuthorEntity>;
};

export type AuthorEntityResponseCollection = {
  __typename?: 'AuthorEntityResponseCollection';
  data: Array<AuthorEntity>;
  meta: ResponseCollectionMeta;
};

export type AuthorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<AuthorFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AuthorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  prismicId?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AuthorInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prismicId?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorRelationResponseCollection = {
  __typename?: 'AuthorRelationResponseCollection';
  data: Array<AuthorEntity>;
};

export enum AutocompleteFieldEnum {
  City = 'CITY',
  Street = 'STREET',
  Zip = 'ZIP'
}

export type AutocompleteInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AutocompleteModel = {
  __typename?: 'AutocompleteModel';
  addressData: AddressDataModel;
  label: Scalars['String']['output'];
};

export type BasketPage = {
  __typename?: 'BasketPage';
  content?: Maybe<Array<Maybe<BasketPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BasketPageRelationResponseCollection>;
  seo: ComponentHelperSeo;
  snippet?: Maybe<ComponentHelperSnippet>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BasketPageContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type BasketPageEntity = {
  __typename?: 'BasketPageEntity';
  attributes?: Maybe<BasketPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BasketPageEntityResponse = {
  __typename?: 'BasketPageEntityResponse';
  data?: Maybe<BasketPageEntity>;
};

export type BasketPageInput = {
  content?: InputMaybe<Array<Scalars['BasketPageContentDynamicZoneInput']['input']>>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BasketPageRelationResponseCollection = {
  __typename?: 'BasketPageRelationResponseCollection';
  data: Array<BasketPageEntity>;
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type BlogArticle = {
  __typename?: 'BlogArticle';
  articleCreatedAt?: Maybe<Scalars['Date']['output']>;
  author?: Maybe<AuthorEntityResponse>;
  blogCategory?: Maybe<BlogCategoryEntityResponse>;
  content?: Maybe<Array<Maybe<BlogArticleContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header: ComponentHeaderImageHeader;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogArticleRelationResponseCollection>;
  prismicId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentHelperSeo>;
  slug: Scalars['String']['output'];
  snippet?: Maybe<ComponentHelperSnippet>;
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BlogArticleLocalizationsArgs = {
  filters?: InputMaybe<BlogArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogArticleContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type BlogArticleEntity = {
  __typename?: 'BlogArticleEntity';
  attributes?: Maybe<BlogArticle>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogArticleEntityResponse = {
  __typename?: 'BlogArticleEntityResponse';
  data?: Maybe<BlogArticleEntity>;
};

export type BlogArticleEntityResponseCollection = {
  __typename?: 'BlogArticleEntityResponseCollection';
  data: Array<BlogArticleEntity>;
  meta: ResponseCollectionMeta;
};

export type BlogArticleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BlogArticleFiltersInput>>>;
  articleCreatedAt?: InputMaybe<DateFilterInput>;
  author?: InputMaybe<AuthorFiltersInput>;
  blogCategory?: InputMaybe<BlogCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  header?: InputMaybe<ComponentHeaderImageHeaderFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogArticleFiltersInput>;
  not?: InputMaybe<BlogArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogArticleFiltersInput>>>;
  prismicId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentHelperSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  snippet?: InputMaybe<ComponentHelperSnippetFiltersInput>;
  teaser?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogArticleInput = {
  articleCreatedAt?: InputMaybe<Scalars['Date']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  blogCategory?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Array<Scalars['BlogArticleContentDynamicZoneInput']['input']>>;
  header?: InputMaybe<ComponentHeaderImageHeaderInput>;
  prismicId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogArticleRelationResponseCollection = {
  __typename?: 'BlogArticleRelationResponseCollection';
  data: Array<BlogArticleEntity>;
};

export type BlogCategory = {
  __typename?: 'BlogCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogCategoryRelationResponseCollection>;
  prismicId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BlogCategoryLocalizationsArgs = {
  filters?: InputMaybe<BlogCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogCategoryEntity = {
  __typename?: 'BlogCategoryEntity';
  attributes?: Maybe<BlogCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogCategoryEntityResponse = {
  __typename?: 'BlogCategoryEntityResponse';
  data?: Maybe<BlogCategoryEntity>;
};

export type BlogCategoryEntityResponseCollection = {
  __typename?: 'BlogCategoryEntityResponseCollection';
  data: Array<BlogCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type BlogCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BlogCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogCategoryFiltersInput>;
  not?: InputMaybe<BlogCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogCategoryFiltersInput>>>;
  prismicId?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogCategoryInput = {
  prismicId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogCategoryRelationResponseCollection = {
  __typename?: 'BlogCategoryRelationResponseCollection';
  data: Array<BlogCategoryEntity>;
};

export type BlogOverview = {
  __typename?: 'BlogOverview';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogOverviewRelationResponseCollection>;
  seo?: Maybe<ComponentHelperSeo>;
  snippet?: Maybe<ComponentHelperSnippet>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BlogOverviewEntity = {
  __typename?: 'BlogOverviewEntity';
  attributes?: Maybe<BlogOverview>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogOverviewEntityResponse = {
  __typename?: 'BlogOverviewEntityResponse';
  data?: Maybe<BlogOverviewEntity>;
};

export type BlogOverviewInput = {
  seo?: InputMaybe<ComponentHelperSeoInput>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogOverviewRelationResponseCollection = {
  __typename?: 'BlogOverviewRelationResponseCollection';
  data: Array<BlogOverviewEntity>;
};

export type BookCartInput = {
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type BookCartResult = {
  __typename?: 'BookCartResult';
  bookings: Array<Maybe<Scalars['String']['output']>>;
};

export type BookingAccessory = {
  __typename?: 'BookingAccessory';
  identifier: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  totalPrice: Scalars['Int']['output'];
};

export type BookingDateRangeInput = {
  /** Start date of the range */
  gte: Scalars['String']['input'];
  /** End date of the range */
  lte: Scalars['String']['input'];
};

export type BookingEquipment = {
  __typename?: 'BookingEquipment';
  key: Scalars['String']['output'];
  value: Scalars['AnyScalar']['output'];
};

export type BookingError = {
  __typename?: 'BookingError';
  message: Scalars['String']['output'];
};

export type BookingProductVariation = {
  __typename?: 'BookingProductVariation';
  key: Scalars['String']['output'];
  value: Scalars['AnyScalar']['output'];
};

export type BookingService_Actions = {
  __typename?: 'BookingService_Actions';
  canBeCanceled: Scalars['Boolean']['output'];
  canBeEnd: Scalars['Boolean']['output'];
  canBeUpdated: BookingService_Actions_CanBeUpdated;
  readOnly: Scalars['Boolean']['output'];
};

export type BookingService_Actions_CanBeUpdated = {
  __typename?: 'BookingService_Actions_CanBeUpdated';
  endDate: Scalars['Boolean']['output'];
  possible: Scalars['Boolean']['output'];
  startDate: Scalars['Boolean']['output'];
};

export type BookingService_Address = {
  __typename?: 'BookingService_Address';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  geoPoint?: Maybe<BookingService_GeoPoint>;
  name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type BookingService_Booking = {
  __typename?: 'BookingService_Booking';
  accessories: Array<BookingService_BookingAccessory>;
  actions: BookingService_Actions;
  billingAddress: BookingService_Address;
  bookingNumber: Scalars['String']['output'];
  coupons: Array<BookingService_BookingCoupon>;
  created: Scalars['String']['output'];
  dateRange: BookingService_DateRange;
  deliveryTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organization: BookingService_Organization;
  price: BookingService_Price;
  priceSnapshot: BookingService_BookingPriceSnapshot;
  product: BookingService_Product;
  productProperties: Array<BookingService_BookingProductProperty>;
  productType: BookingService_ProductType;
  project: BookingService_Project;
  rentalStation: BookingService_RentalStation;
  renter: BookingService_Renter;
  shipping: BookingService_BookingShipping;
  state: BookingStatusEnum;
  tenant: BookingService_Tenant;
};

export type BookingService_BookingAccessory = {
  __typename?: 'BookingService_BookingAccessory';
  identifier: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  totalPrice: Scalars['Float']['output'];
};

export type BookingService_BookingCoupon = {
  __typename?: 'BookingService_BookingCoupon';
  code: Scalars['String']['output'];
  discount: BookingService_BookingCouponDiscount;
};

export type BookingService_BookingCouponDiscount = {
  __typename?: 'BookingService_BookingCouponDiscount';
  amount: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
  type: DiscountTypeEnum;
};

export type BookingService_BookingEntitySimplifiedQuery = {
  __typename?: 'BookingService_BookingEntitySimplifiedQuery';
  billingAddress: Scalars['String']['output'];
  bookingNumber: Scalars['String']['output'];
  businessUnitSnapshot: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationSnapshot: Scalars['String']['output'];
  priceSnapshot: Scalars['String']['output'];
  productSnapshot: Scalars['String']['output'];
  productTypeSnapshot: Scalars['String']['output'];
  projectSnapshot: Scalars['String']['output'];
  rentalStationSnapshot: Scalars['String']['output'];
  shippingSnapshot: Scalars['String']['output'];
  statusCode: BookingStatusEnum;
  tenantSnapshot: Scalars['String']['output'];
  userSnapshot: Scalars['String']['output'];
};

export type BookingService_BookingFilterOption = {
  __typename?: 'BookingService_BookingFilterOption';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BookingService_BookingFilterOptionsQuery = {
  __typename?: 'BookingService_BookingFilterOptionsQuery';
  bookingStatus: Array<Scalars['String']['output']>;
  productTypes: Array<BookingService_BookingFilterOption>;
  projects: Array<BookingService_BookingFilterOption>;
  tenantKeys: Array<BookingService_BookingFilterOption>;
};

export type BookingService_BookingPrice = {
  __typename?: 'BookingService_BookingPrice';
  amount: Scalars['Float']['output'];
};

export type BookingService_BookingPriceSnapshot = {
  __typename?: 'BookingService_BookingPriceSnapshot';
  accessoriesPrice: BookingService_BookingPrice;
  discount: BookingService_BookingPrice;
  final: BookingService_BookingPrice;
  insurance: BookingService_BookingPrice;
  productAmount: Scalars['Float']['output'];
  serviceFees: Array<BookingService_BookingServiceFee>;
  shipping: BookingService_BookingPrice;
  tax: BookingService_BookingPrice;
  workingDays: Scalars['Float']['output'];
};

export type BookingService_BookingProductProperty = {
  __typename?: 'BookingService_BookingProductProperty';
  descriptor: BookingService_BookingProductPropertyDescriptor;
  isVariant: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  value: BookingService_BookingProductPropertyValue;
};

export type BookingService_BookingProductPropertyDescriptor = {
  __typename?: 'BookingService_BookingProductPropertyDescriptor';
  key: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type BookingService_BookingProductPropertyValue = {
  __typename?: 'BookingService_BookingProductPropertyValue';
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BookingService_BookingServiceFee = {
  __typename?: 'BookingService_BookingServiceFee';
  identifier: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type BookingService_BookingShipping = BookingService_BookingShippingDelivery | BookingService_BookingShippingPickup;

export type BookingService_BookingShippingDelivery = {
  __typename?: 'BookingService_BookingShippingDelivery';
  destination: BookingService_BookingShippingDestination;
  rentalStation: BookingService_RentalStation;
  type: ShippingOptionEnum;
};

export type BookingService_BookingShippingDestination = {
  __typename?: 'BookingService_BookingShippingDestination';
  address: BookingService_Address;
  id: Scalars['String']['output'];
};

export type BookingService_BookingShippingPickup = {
  __typename?: 'BookingService_BookingShippingPickup';
  rentalStation: BookingService_RentalStation;
  type: ShippingOptionEnum;
};

export type BookingService_BookingsFilter = {
  /** Booking number */
  bookingNumber?: InputMaybe<Scalars['String']['input']>;
  /** Booking Status */
  bookingStatus?: InputMaybe<BookingStatusEnum>;
  /** End Date of booking */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** FirstName of the renter */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** LastName of the renter */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the organization of the renter */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** ProductType of booked product */
  productType?: InputMaybe<Scalars['String']['input']>;
  /** Project the booking belongs to */
  project?: InputMaybe<Scalars['String']['input']>;
  /** RentalStation name the bookings product belongs to */
  rentalStation?: InputMaybe<Scalars['String']['input']>;
  /** Booking ShippingType */
  shippingType?: InputMaybe<ShippingOptionEnum>;
  /** Start Date of booking */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Tenant Key */
  tenantKey?: InputMaybe<Scalars['String']['input']>;
  /** VatId of the organization of the renter */
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type BookingService_BookingsQuery = {
  __typename?: 'BookingService_BookingsQuery';
  bookings: Array<BookingService_Booking>;
  total: Scalars['Float']['output'];
};

export type BookingService_DateRange = {
  __typename?: 'BookingService_DateRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type BookingService_GeoPoint = {
  __typename?: 'BookingService_GeoPoint';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type BookingService_Manufacturer = {
  __typename?: 'BookingService_Manufacturer';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type BookingService_Organization = {
  __typename?: 'BookingService_Organization';
  name: Scalars['String']['output'];
  vatId: Scalars['ID']['output'];
};

export type BookingService_PaginationArgs = {
  limit: Scalars['Float']['input'];
  offset: Scalars['Float']['input'];
};

export type BookingService_Price = {
  __typename?: 'BookingService_Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type BookingService_Product = {
  __typename?: 'BookingService_Product';
  effectiveNonWorkingDays: Array<Scalars['String']['output']>;
  minimumRentalPeriodDays: Scalars['Float']['output'];
  minimumRentalPeriodEndDate: Scalars['String']['output'];
};

export type BookingService_ProductType = {
  __typename?: 'BookingService_ProductType';
  configuratorPageUrl: Scalars['String']['output'];
  hasManagedStock: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  manufacturer: BookingService_Manufacturer;
  title: Scalars['String']['output'];
};

export type BookingService_Project = {
  __typename?: 'BookingService_Project';
  externalProjectId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BookingService_RentalStation = {
  __typename?: 'BookingService_RentalStation';
  address: BookingService_Address;
  identifier: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BookingService_Renter = {
  __typename?: 'BookingService_Renter';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type BookingService_Tenant = {
  __typename?: 'BookingService_Tenant';
  key: Scalars['String']['output'];
  logo: BookingService_TenantLogo;
  name: Scalars['String']['output'];
};

export type BookingService_TenantBookingPreviewInput = {
  /** Booking number */
  bookingNumber: Scalars['String']['input'];
  /** Booking date range */
  dateRange: BookingDateRangeInput;
};

export type BookingService_TenantBookingPreviewMutation = {
  __typename?: 'BookingService_TenantBookingPreviewMutation';
  confirmed: Scalars['Boolean']['output'];
  errorMessage: Scalars['String']['output'];
};

export type BookingService_TenantLogo = {
  __typename?: 'BookingService_TenantLogo';
  alt: Scalars['String']['output'];
  metadata: BookingService_TenantLogoMetaData;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BookingService_TenantLogoMetaData = {
  __typename?: 'BookingService_TenantLogoMetaData';
  format: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export enum BookingStatusEnum {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  End = 'END',
  Failed = 'FAILED',
  New = 'NEW',
  Returned = 'RETURNED',
  Shipped = 'SHIPPED'
}

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sort Business Unit list by */
export enum BusinessUnitSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type CmsService_RentalStationShippingOptions = {
  __typename?: 'CMSService_RentalStationShippingOptions';
  deliveryEnabled: Scalars['Boolean']['output'];
  pickupEnabled: Scalars['Boolean']['output'];
};

export type CtaLinkEntityType = {
  __typename?: 'CTALinkEntityType';
  contentType?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CancelBookingInput = {
  bookingId: Scalars['String']['input'];
  cancelNote?: InputMaybe<Scalars['String']['input']>;
};

export type CancelBookingResponse = {
  __typename?: 'CancelBookingResponse';
  id: Scalars['String']['output'];
};

export type Cart = {
  __typename?: 'Cart';
  actions: CartActions;
  coupon?: Maybe<DiscountObject>;
  deposit: Scalars['Int']['output'];
  discount: Scalars['Int']['output'];
  finalPrice: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  insurance: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  items: Array<CartItem>;
  organization?: Maybe<IdObject>;
  rentalTax: Scalars['Int']['output'];
  totalPrice: Scalars['Int']['output'];
  user?: Maybe<IdObject>;
};

export type CartAccessoryInput = {
  identifier: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type CartActions = {
  __typename?: 'CartActions';
  canBeBooked: Scalars['Boolean']['output'];
};

export type CartItem = {
  __typename?: 'CartItem';
  accessories: Array<ProductAccessory>;
  accessoriesPrice: Scalars['Int']['output'];
  attachedFileUrl?: Maybe<Scalars['String']['output']>;
  billingAddressInfo?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<DiscountObject>;
  dateRange: DateRange;
  deliveryAddressId?: Maybe<Scalars['String']['output']>;
  deliveryTime?: Maybe<Scalars['String']['output']>;
  deposit: Scalars['Int']['output'];
  discount: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  insurance: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  productAmount: Scalars['Int']['output'];
  productType: ProductType;
  projectInfo?: Maybe<Scalars['String']['output']>;
  properties: Array<Property>;
  rentalStation: RentalStation;
  serviceFees: Array<ServiceFee>;
  shipping: Shipping;
  tradeNumber?: Maybe<Scalars['String']['output']>;
  workingDays: Scalars['Int']['output'];
};

export type CartItemInput = {
  accessories?: InputMaybe<Array<CartAccessoryInput>>;
  attachedFileUrl?: InputMaybe<Scalars['String']['input']>;
  cartItemId?: InputMaybe<Scalars['String']['input']>;
  dateRange: DateRangeInput;
  deliveryAddressId?: InputMaybe<Scalars['String']['input']>;
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productAmount?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Array<PropertyInput>>;
  /** Use the uri-component of the related-product instead of the dato-id. */
  relatedTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rentalStationIdentifier: Scalars['String']['input'];
  shippingOption: ShippingOption;
  tradeNumber?: InputMaybe<Scalars['String']['input']>;
  uriComponent: Scalars['String']['input'];
};

export type CatalogSearchResult = Category | ProductType | Tenant;

export type CategoriesList = {
  __typename?: 'CategoriesList';
  data: Array<Category>;
  total: Scalars['Int']['output'];
};

/** Category is used to organize products into a hierarchical structure. */
export type Category = {
  __typename?: 'Category';
  categoryRecommended: Scalars['Boolean']['output'];
  /** The categories located in this category. */
  children?: Maybe<Array<Maybe<Category>>>;
  id: Scalars['String']['output'];
  /** The image associated with this category. */
  image?: Maybe<Image>;
  originalUriComponent?: Maybe<Scalars['String']['output']>;
  /** The category this category belongs to. */
  parent?: Maybe<Category>;
  relativeUrl: Scalars['String']['output'];
  searchTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
};

export type CategoryFilters = {
  /** Allows to filter for a specific parent or null. */
  parentEq?: InputMaybe<EqFilter>;
};

export type CategoryImage = {
  __typename?: 'CategoryImage';
  alt: Scalars['String']['output'];
  metadata: CategoryImageMetadata;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CategoryImageMetadata = {
  __typename?: 'CategoryImageMetadata';
  format: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type CategoryModel = {
  __typename?: 'CategoryModel';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type CategoryQueryParams = {
  filters?: InputMaybe<CategoryFilters>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CategorySort>;
};

export type CategorySort = {
  by: CategorySortOption;
  order: SortOrder;
};

export enum CategorySortOption {
  /** Sorts the categories by title */
  Title = 'TITLE'
}

export type CmsCategoryModel = {
  __typename?: 'CmsCategoryModel';
  categoryRecommended: Scalars['Boolean']['output'];
  childCategories: Array<CmsCategoryModel>;
  facts: Array<CmsProductPropertyModel>;
  filters: Array<CmsProductPropertyModel>;
  id: Scalars['String']['output'];
  image?: Maybe<CategoryImage>;
  originalUriComponent?: Maybe<Scalars['String']['output']>;
  parentCategory?: Maybe<CmsCategoryModel>;
  relativeUrl: Scalars['String']['output'];
  rolloverProperties: Array<CmsProductPropertyModel>;
  searchTags: Array<Scalars['String']['output']>;
  searchTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
};

export type CmsCountryModel = {
  __typename?: 'CmsCountryModel';
  iso2: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sourceReference: CountrySourceReference;
};

export type CmsGeoPointModel = {
  __typename?: 'CmsGeoPointModel';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type CmsProductPropertyEnum = {
  __typename?: 'CmsProductPropertyEnum';
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CmsProductPropertyModel = {
  __typename?: 'CmsProductPropertyModel';
  enums: Array<CmsProductPropertyEnum>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type CmsRentalStationModel = {
  __typename?: 'CmsRentalStationModel';
  additionalTimeForRentalStart: Scalars['Float']['output'];
  address: RentalStationAddress;
  contact: RentalStationContact;
  country: CmsCountryModel;
  deliveryCosts: Array<RentalStationDeliveryCost>;
  email: Scalars['String']['output'];
  externalIdentifier: Scalars['String']['output'];
  /** The internal digando id. This identifier was created by the fleetmanager. */
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** List of non working days. Includes weekends and holidays. */
  nonWorkingDays: Array<Scalars['String']['output']>;
  openingHours: Scalars['String']['output'];
  /** @deprecated Can be removed in the next version. Will always return an empty array. */
  services: Array<RentalStationService>;
  shippingOptions: CmsService_RentalStationShippingOptions;
  shortName: Scalars['String']['output'];
  sourceReference: RentalStationSourceReference;
  tenant: CmsService_TenantModel;
};

export type CmsService_GetProductTypePagesResponse = {
  __typename?: 'CmsService_GetProductTypePagesResponse';
  pages: Scalars['Float']['output'];
};

export type CmsService_Location = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radius: Scalars['Float']['input'];
};

export type CmsService_LocationModel = {
  __typename?: 'CmsService_LocationModel';
  location: CmsGeoPointModel;
  preSelectedRadius: Scalars['Float']['output'];
  sourceReference: CmsService_LocationSourceReference;
  title: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
};

export type CmsService_LocationSourceReference = {
  __typename?: 'CmsService_LocationSourceReference';
  id: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type CmsService_ManufacturerLogo = {
  __typename?: 'CmsService_ManufacturerLogo';
  alt: Scalars['String']['output'];
  metadata: CmsService_ManufacturerLogoMetaData;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CmsService_ManufacturerLogoMetaData = {
  __typename?: 'CmsService_ManufacturerLogoMetaData';
  format: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type CmsService_ManufacturerModel = {
  __typename?: 'CmsService_ManufacturerModel';
  logo?: Maybe<CmsService_ManufacturerLogo>;
  sourceReference: CmsService_ManufacturerSourceReference;
  title: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
};

export type CmsService_ManufacturerSourceReference = {
  __typename?: 'CmsService_ManufacturerSourceReference';
  id: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type CmsService_NonWorkingDaysBlockModel = {
  __typename?: 'CmsService_NonWorkingDaysBlockModel';
  dates: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceReference: CmsService_NonWorkingDaysBlockSourceReference;
};

export type CmsService_NonWorkingDaysBlockSourceReference = {
  __typename?: 'CmsService_NonWorkingDaysBlockSourceReference';
  id: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type CmsService_ProductProperty = {
  __typename?: 'CmsService_ProductProperty';
  defaultValue?: Maybe<Scalars['String']['output']>;
  descriptor: CmsProductPropertyModel;
  factPosition: Scalars['Float']['output'];
  isEquipment: Scalars['Boolean']['output'];
  isFact: Scalars['Boolean']['output'];
  isRolloverProperty: Scalars['Boolean']['output'];
  isVariant: Scalars['Boolean']['output'];
  rolloverPropertyPosition: Scalars['Float']['output'];
};

export type CmsService_ProductTypeImage = {
  __typename?: 'CmsService_ProductTypeImage';
  alt: Scalars['String']['output'];
  metadata: CmsService_ProductTypeImageMetadata;
  tenantKey?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CmsService_ProductTypeImageMetadata = {
  __typename?: 'CmsService_ProductTypeImageMetadata';
  format: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type CmsService_ProductTypeModel = {
  __typename?: 'CmsService_ProductTypeModel';
  accessoryOnly: Scalars['Boolean']['output'];
  category: CmsCategoryModel;
  configuratorPageUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  equipments: Array<CmsService_ProductProperty>;
  facts: Array<CmsService_ProductProperty>;
  firstPublicationDate: Scalars['DateTime']['output'];
  fullTitle: Scalars['String']['output'];
  hasManagedStock: Scalars['Boolean']['output'];
  images: Array<CmsService_ProductTypeImage>;
  importAsUriComponent?: Maybe<Scalars['String']['output']>;
  isTopSuggestion: Scalars['Boolean']['output'];
  manufacturer: CmsService_ManufacturerModel;
  palletSpaces?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Float']['output'];
  productPageUrl: Scalars['String']['output'];
  productProperties: Array<CmsService_ProductProperty>;
  relatedProductTypes: Array<RelatedProductTypes>;
  searchTags: Array<Scalars['String']['output']>;
  sourceReference: SourceReference;
  sourceServiceName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
  variant?: Maybe<CmsService_ProductProperty>;
};

export type CmsService_TenantLogo = {
  __typename?: 'CmsService_TenantLogo';
  alt: Scalars['String']['output'];
  metadata: CmsService_TenantLogoMetadata;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CmsService_TenantLogoMetadata = {
  __typename?: 'CmsService_TenantLogoMetadata';
  format: Scalars['String']['output'];
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type CmsService_TenantModel = {
  __typename?: 'CmsService_TenantModel';
  contractPercentage: Scalars['Float']['output'];
  digandoUrl: Scalars['String']['output'];
  hiddenPrices: Scalars['Boolean']['output'];
  insuranceMode: InsuranceTypeEnum;
  insurancePercentage: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  logo?: Maybe<CmsService_TenantLogo>;
  minimumRentalPeriod: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  notificationEmails: Array<Scalars['String']['output']>;
  rentalPeriodMode: RentalPeriodModeEnum;
  sourceReference: CmsService_TenantSourceReference;
  testingMode: Scalars['Boolean']['output'];
};

export type CmsService_TenantSourceReference = {
  __typename?: 'CmsService_TenantSourceReference';
  id: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type ComponentContentActionButton = {
  __typename?: 'ComponentContentActionButton';
  actionType: Enum_Componentcontentactionbutton_Actiontype;
  buttonText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentContentCallToAction = {
  __typename?: 'ComponentContentCallToAction';
  cta?: Maybe<ComponentHelperCallToAction>;
  description?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentContentCategoryOverview = {
  __typename?: 'ComponentContentCategoryOverview';
  description?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentContentContactSection = {
  __typename?: 'ComponentContentContactSection';
  contacts?: Maybe<ContactRelationResponseCollection>;
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentContentContactSectionContactsArgs = {
  filters?: InputMaybe<ContactFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentFaq = {
  __typename?: 'ComponentContentFaq';
  faqs?: Maybe<FaqRelationResponseCollection>;
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentContentFaqFaqsArgs = {
  filters?: InputMaybe<FaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentHubspotForm = {
  __typename?: 'ComponentContentHubspotForm';
  heading?: Maybe<Scalars['JSON']['output']>;
  hubspotFormId?: Maybe<Scalars['String']['output']>;
  hubspotPortalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentContentImagePresentation = {
  __typename?: 'ComponentContentImagePresentation';
  id: Scalars['ID']['output'];
  images: Array<Maybe<ComponentHelperImagePresentation>>;
};


export type ComponentContentImagePresentationImagesArgs = {
  filters?: InputMaybe<ComponentHelperImagePresentationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentInternalLinks = {
  __typename?: 'ComponentContentInternalLinks';
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  internalLinks?: Maybe<Array<Maybe<ComponentHelperInternalLink>>>;
};


export type ComponentContentInternalLinksInternalLinksArgs = {
  filters?: InputMaybe<ComponentHelperInternalLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentNavigationLinkWrapper = {
  __typename?: 'ComponentContentNavigationLinkWrapper';
  id: Scalars['ID']['output'];
  navigationLinks?: Maybe<Array<Maybe<ComponentHelperNavigationLink>>>;
  text?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentNavigationLinkWrapperNavigationLinksArgs = {
  filters?: InputMaybe<ComponentHelperNavigationLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentNavigationLinkWrapperFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentContentNavigationLinkWrapperFiltersInput>>>;
  navigationLinks?: InputMaybe<ComponentHelperNavigationLinkFiltersInput>;
  not?: InputMaybe<ComponentContentNavigationLinkWrapperFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentContentNavigationLinkWrapperFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentContentNavigationLinkWrapperInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  navigationLinks?: InputMaybe<Array<InputMaybe<ComponentHelperNavigationLinkInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentContentNewsletterSubscription = {
  __typename?: 'ComponentContentNewsletterSubscription';
  description?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentContentOnBoarding = {
  __typename?: 'ComponentContentOnBoarding';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentHelperOnBoarding>>>;
};


export type ComponentContentOnBoardingItemsArgs = {
  filters?: InputMaybe<ComponentHelperOnBoardingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentPopularCategories = {
  __typename?: 'ComponentContentPopularCategories';
  categories?: Maybe<Array<Maybe<ComponentHelperDigandoCategorySelector>>>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentPopularCategoriesCategoriesArgs = {
  filters?: InputMaybe<ComponentHelperDigandoCategorySelectorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentPopularCategoriesInput = {
  categories?: InputMaybe<Array<InputMaybe<ComponentHelperDigandoCategorySelectorInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentContentPrivacySettings = {
  __typename?: 'ComponentContentPrivacySettings';
  id: Scalars['ID']['output'];
};

export type ComponentContentQuoteBlock = {
  __typename?: 'ComponentContentQuoteBlock';
  author?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quote?: Maybe<Scalars['String']['output']>;
};

export type ComponentContentRecommendedCategories = {
  __typename?: 'ComponentContentRecommendedCategories';
  categories: Array<Maybe<ComponentHelperRecommendedCategory>>;
  id: Scalars['ID']['output'];
  recommendedCategoryTitle?: Maybe<Scalars['String']['output']>;
  tenantKey?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentRecommendedCategoriesCategoriesArgs = {
  filters?: InputMaybe<ComponentHelperRecommendedCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentRentalStations = {
  __typename?: 'ComponentContentRentalStations';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  tenantKey?: Maybe<Scalars['String']['output']>;
};

export type ComponentContentSearchBox = {
  __typename?: 'ComponentContentSearchBox';
  id: Scalars['ID']['output'];
  tenantKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentContentSearchBoxFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentContentSearchBoxFiltersInput>>>;
  not?: InputMaybe<ComponentContentSearchBoxFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentContentSearchBoxFiltersInput>>>;
  tenantKey?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentContentSearchBoxInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tenantKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentContentSlugSelector = {
  __typename?: 'ComponentContentSlugSelector';
  id: Scalars['ID']['output'];
  slug?: Maybe<Array<Maybe<ComponentHelperDigandoCategorySelector>>>;
};


export type ComponentContentSlugSelectorSlugArgs = {
  filters?: InputMaybe<ComponentHelperDigandoCategorySelectorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentTenantLogos = {
  __typename?: 'ComponentContentTenantLogos';
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  tenants?: Maybe<Array<Maybe<ComponentHelperTenantLogo>>>;
};


export type ComponentContentTenantLogosTenantsArgs = {
  filters?: InputMaybe<ComponentHelperTenantLogoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentTestimonials = {
  __typename?: 'ComponentContentTestimonials';
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  testimonials?: Maybe<Array<Maybe<ComponentHelperTestimonial>>>;
};


export type ComponentContentTestimonialsTestimonialsArgs = {
  filters?: InputMaybe<ComponentHelperTestimonialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentTextWithBlock = {
  __typename?: 'ComponentContentTextWithBlock';
  factBox?: Maybe<Array<Maybe<ComponentHelperFactBox>>>;
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentTextWithBlockFactBoxArgs = {
  filters?: InputMaybe<ComponentHelperFactBoxFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentTextWithImage = {
  __typename?: 'ComponentContentTextWithImage';
  cta?: Maybe<ComponentHelperCallToAction>;
  description?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  imagePosition?: Maybe<Enum_Componentcontenttextwithimage_Imageposition>;
  transparentBackground?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentContentTextWithLink = {
  __typename?: 'ComponentContentTextWithLink';
  description?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  linkText?: Maybe<Scalars['String']['output']>;
  page?: Maybe<StandardPageEntityResponse>;
};

export type ComponentContentUspCards = {
  __typename?: 'ComponentContentUspCards';
  heading?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  usps?: Maybe<Array<Maybe<ComponentHelperUspCard>>>;
};


export type ComponentContentUspCardsUspsArgs = {
  filters?: InputMaybe<ComponentHelperUspCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentUspDigando = {
  __typename?: 'ComponentContentUspDigando';
  id: Scalars['ID']['output'];
  usps?: Maybe<Array<Maybe<ComponentHelperUspDigandoItem>>>;
};


export type ComponentContentUspDigandoUspsArgs = {
  filters?: InputMaybe<ComponentHelperUspDigandoItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentUspProduct = {
  __typename?: 'ComponentContentUspProduct';
  id: Scalars['ID']['output'];
  usps?: Maybe<Array<Maybe<ComponentHelperUspDigandoItem>>>;
};


export type ComponentContentUspProductUspsArgs = {
  filters?: InputMaybe<ComponentHelperUspDigandoItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentYoutubeVideo = {
  __typename?: 'ComponentContentYoutubeVideo';
  id: Scalars['ID']['output'];
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type ComponentHeaderHeader = {
  __typename?: 'ComponentHeaderHeader';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentHeaderHomepageHeader = {
  __typename?: 'ComponentHeaderHomepageHeader';
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  maxBrowserWidth: Scalars['String']['output'];
};

export type ComponentHeaderHomepageHeaderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHeaderHomepageHeaderFiltersInput>>>;
  maxBrowserWidth?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHeaderHomepageHeaderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHeaderHomepageHeaderFiltersInput>>>;
};

export type ComponentHeaderHomepageHeaderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  maxBrowserWidth?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHeaderImageHeader = {
  __typename?: 'ComponentHeaderImageHeader';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentHeaderImageHeaderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHeaderImageHeaderFiltersInput>>>;
  not?: InputMaybe<ComponentHeaderImageHeaderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHeaderImageHeaderFiltersInput>>>;
};

export type ComponentHeaderImageHeaderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentHeaderTenantHeader = {
  __typename?: 'ComponentHeaderTenantHeader';
  description?: Maybe<Scalars['String']['output']>;
  facts: Array<Maybe<ComponentHelperLabelValue>>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentHeaderTenantHeaderFactsArgs = {
  filters?: InputMaybe<ComponentHelperLabelValueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHeaderTenantHeaderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHeaderTenantHeaderFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  facts?: InputMaybe<ComponentHelperLabelValueFiltersInput>;
  not?: InputMaybe<ComponentHeaderTenantHeaderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHeaderTenantHeaderFiltersInput>>>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHeaderTenantHeaderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facts?: InputMaybe<Array<InputMaybe<ComponentHelperLabelValueInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHelperBenefits = {
  __typename?: 'ComponentHelperBenefits';
  benefit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentHelperBenefitsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperBenefitsFiltersInput>>>;
  benefit?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperBenefitsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperBenefitsFiltersInput>>>;
};

export type ComponentHelperBenefitsInput = {
  benefit?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentHelperCallToAction = {
  __typename?: 'ComponentHelperCallToAction';
  ctaLinkPage?: Maybe<CtaLinkEntityType>;
  id: Scalars['ID']['output'];
  internalLinkSelector?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperCallToActionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperCallToActionFiltersInput>>>;
  internalLinkSelector?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperCallToActionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperCallToActionFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperDigandoCategorySelector = {
  __typename?: 'ComponentHelperDigandoCategorySelector';
  id: Scalars['ID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperDigandoCategorySelectorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperDigandoCategorySelectorFiltersInput>>>;
  not?: InputMaybe<ComponentHelperDigandoCategorySelectorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperDigandoCategorySelectorFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperDigandoCategorySelectorInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHelperFactBox = {
  __typename?: 'ComponentHelperFactBox';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperFactBoxFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperFactBoxFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperFactBoxFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperFactBoxFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperImagePresentation = {
  __typename?: 'ComponentHelperImagePresentation';
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperImagePresentationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperImagePresentationFiltersInput>>>;
  not?: InputMaybe<ComponentHelperImagePresentationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperImagePresentationFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperInternalLink = {
  __typename?: 'ComponentHelperInternalLink';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  internalLinkPage?: Maybe<InternalLinkEntityType>;
  internalLinkSelector?: Maybe<Scalars['String']['output']>;
  readMoreLinkText?: Maybe<Scalars['String']['output']>;
  readMoreLinkTitle?: Maybe<Scalars['String']['output']>;
  tenantKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperInternalLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperInternalLinkFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  internalLinkSelector?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperInternalLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperInternalLinkFiltersInput>>>;
  readMoreLinkText?: InputMaybe<StringFilterInput>;
  readMoreLinkTitle?: InputMaybe<StringFilterInput>;
  tenantKey?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperLabelValue = {
  __typename?: 'ComponentHelperLabelValue';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ComponentHelperLabelValueFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperLabelValueFiltersInput>>>;
  key?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperLabelValueFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperLabelValueFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperLabelValueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHelperNavigationLink = {
  __typename?: 'ComponentHelperNavigationLink';
  id: Scalars['ID']['output'];
  internalLinkSelector?: Maybe<Scalars['String']['output']>;
  navigationLinkPage?: Maybe<NavigationLinkEntityType>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperNavigationLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperNavigationLinkFiltersInput>>>;
  internalLinkSelector?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperNavigationLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperNavigationLinkFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperNavigationLinkInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  internalLinkSelector?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHelperOnBoarding = {
  __typename?: 'ComponentHelperOnBoarding';
  cta?: Maybe<ComponentHelperCallToAction>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalLinks?: Maybe<Array<Maybe<ComponentHelperInternalLink>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentHelperOnBoardingInternalLinksArgs = {
  filters?: InputMaybe<ComponentHelperInternalLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHelperOnBoardingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperOnBoardingFiltersInput>>>;
  cta?: InputMaybe<ComponentHelperCallToActionFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  internalLinks?: InputMaybe<ComponentHelperInternalLinkFiltersInput>;
  not?: InputMaybe<ComponentHelperOnBoardingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperOnBoardingFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperProducts = {
  __typename?: 'ComponentHelperProducts';
  id: Scalars['ID']['output'];
  uriComponent: Scalars['String']['output'];
};

export type ComponentHelperProductsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperProductsFiltersInput>>>;
  not?: InputMaybe<ComponentHelperProductsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperProductsFiltersInput>>>;
  uriComponent?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperProductsList = {
  __typename?: 'ComponentHelperProductsList';
  id: Scalars['ID']['output'];
  uriComponent?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperRecommendedCategory = {
  __typename?: 'ComponentHelperRecommendedCategory';
  id: Scalars['ID']['output'];
  products: Array<Maybe<ComponentHelperProducts>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentHelperRecommendedCategoryProductsArgs = {
  filters?: InputMaybe<ComponentHelperProductsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHelperRecommendedCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperRecommendedCategoryFiltersInput>>>;
  not?: InputMaybe<ComponentHelperRecommendedCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperRecommendedCategoryFiltersInput>>>;
  products?: InputMaybe<ComponentHelperProductsFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperSeo = {
  __typename?: 'ComponentHelperSeo';
  description?: Maybe<Scalars['String']['output']>;
  hideFromSidebarAndIndex?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperSeoFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  hideFromSidebarAndIndex?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentHelperSeoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperSeoFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperSeoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hideFromSidebarAndIndex?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHelperSnippet = {
  __typename?: 'ComponentHelperSnippet';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperSnippetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperSnippetFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperSnippetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperSnippetFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperSnippetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHelperTenantLogo = {
  __typename?: 'ComponentHelperTenantLogo';
  id: Scalars['ID']['output'];
  logo?: Maybe<UploadFileEntityResponse>;
  tenant?: Maybe<TenantPageEntityResponse>;
};

export type ComponentHelperTenantLogoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperTenantLogoFiltersInput>>>;
  not?: InputMaybe<ComponentHelperTenantLogoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperTenantLogoFiltersInput>>>;
  tenant?: InputMaybe<TenantPageFiltersInput>;
};

export type ComponentHelperTest = {
  __typename?: 'ComponentHelperTest';
  id: Scalars['ID']['output'];
  test?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperTestimonial = {
  __typename?: 'ComponentHelperTestimonial';
  authorCompany?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  authorRole?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperTestimonialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperTestimonialFiltersInput>>>;
  authorCompany?: InputMaybe<StringFilterInput>;
  authorName?: InputMaybe<StringFilterInput>;
  authorRole?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperTestimonialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperTestimonialFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperUspCard = {
  __typename?: 'ComponentHelperUspCard';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentHelperUspCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHelperUspCardFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHelperUspCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperUspCardFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentHelperUspDigandoItem = {
  __typename?: 'ComponentHelperUspDigandoItem';
  advantage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentHelperUspDigandoItemFiltersInput = {
  advantage?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentHelperUspDigandoItemFiltersInput>>>;
  not?: InputMaybe<ComponentHelperUspDigandoItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHelperUspDigandoItemFiltersInput>>>;
};

export type ConfiguratorPage = {
  __typename?: 'ConfiguratorPage';
  content?: Maybe<Array<Maybe<ConfiguratorPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConfiguratorPageContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | Error;

export type ConfiguratorPageEntity = {
  __typename?: 'ConfiguratorPageEntity';
  attributes?: Maybe<ConfiguratorPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ConfiguratorPageEntityResponse = {
  __typename?: 'ConfiguratorPageEntityResponse';
  data?: Maybe<ConfiguratorPageEntity>;
};

export type ConfiguratorPageInput = {
  content?: InputMaybe<Array<Scalars['ConfiguratorPageContentDynamicZoneInput']['input']>>;
};

export type Contact = {
  __typename?: 'Contact';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<UploadFileEntityResponse>;
  position: Scalars['String']['output'];
  prismicId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactEntity = {
  __typename?: 'ContactEntity';
  attributes?: Maybe<Contact>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ContactEntityResponse = {
  __typename?: 'ContactEntityResponse';
  data?: Maybe<ContactEntity>;
};

export type ContactEntityResponseCollection = {
  __typename?: 'ContactEntityResponseCollection';
  data: Array<ContactEntity>;
  meta: ResponseCollectionMeta;
};

export type ContactFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ContactFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContactFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ContactFiltersInput>>>;
  phone?: InputMaybe<StringFilterInput>;
  position?: InputMaybe<StringFilterInput>;
  prismicId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  prismicId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactRelationResponseCollection = {
  __typename?: 'ContactRelationResponseCollection';
  data: Array<ContactEntity>;
};

export type ContentReleasesRelease = {
  __typename?: 'ContentReleasesRelease';
  actions?: Maybe<ContentReleasesReleaseActionRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ContentReleasesReleaseActionsArgs = {
  filters?: InputMaybe<ContentReleasesReleaseActionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentReleasesReleaseAction = {
  __typename?: 'ContentReleasesReleaseAction';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entry?: Maybe<GenericMorph>;
  locale?: Maybe<Scalars['String']['output']>;
  release?: Maybe<ContentReleasesReleaseEntityResponse>;
  type: Enum_Contentreleasesreleaseaction_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentReleasesReleaseActionEntity = {
  __typename?: 'ContentReleasesReleaseActionEntity';
  attributes?: Maybe<ContentReleasesReleaseAction>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ContentReleasesReleaseActionEntityResponse = {
  __typename?: 'ContentReleasesReleaseActionEntityResponse';
  data?: Maybe<ContentReleasesReleaseActionEntity>;
};

export type ContentReleasesReleaseActionEntityResponseCollection = {
  __typename?: 'ContentReleasesReleaseActionEntityResponseCollection';
  data: Array<ContentReleasesReleaseActionEntity>;
  meta: ResponseCollectionMeta;
};

export type ContentReleasesReleaseActionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ContentReleasesReleaseActionFiltersInput>>>;
  contentType?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContentReleasesReleaseActionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ContentReleasesReleaseActionFiltersInput>>>;
  release?: InputMaybe<ContentReleasesReleaseFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ContentReleasesReleaseActionInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  release?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Contentreleasesreleaseaction_Type>;
};

export type ContentReleasesReleaseActionRelationResponseCollection = {
  __typename?: 'ContentReleasesReleaseActionRelationResponseCollection';
  data: Array<ContentReleasesReleaseActionEntity>;
};

export type ContentReleasesReleaseEntity = {
  __typename?: 'ContentReleasesReleaseEntity';
  attributes?: Maybe<ContentReleasesRelease>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ContentReleasesReleaseEntityResponse = {
  __typename?: 'ContentReleasesReleaseEntityResponse';
  data?: Maybe<ContentReleasesReleaseEntity>;
};

export type ContentReleasesReleaseEntityResponseCollection = {
  __typename?: 'ContentReleasesReleaseEntityResponseCollection';
  data: Array<ContentReleasesReleaseEntity>;
  meta: ResponseCollectionMeta;
};

export type ContentReleasesReleaseFiltersInput = {
  actions?: InputMaybe<ContentReleasesReleaseActionFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ContentReleasesReleaseFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContentReleasesReleaseFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ContentReleasesReleaseFiltersInput>>>;
  releasedAt?: InputMaybe<DateTimeFilterInput>;
  scheduledAt?: InputMaybe<DateTimeFilterInput>;
  timezone?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ContentReleasesReleaseInput = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  releasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CorrectedFieldModel = {
  __typename?: 'CorrectedFieldModel';
  correctedValue: Scalars['String']['output'];
  fieldName: AddressFieldEnum;
  originalValue: Scalars['String']['output'];
};

export type CountriesResult = {
  __typename?: 'CountriesResult';
  data: Array<Country>;
};

export type Country = {
  __typename?: 'Country';
  iso2: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CountrySourceReference = {
  __typename?: 'CountrySourceReference';
  id: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type CouponDiscount = DiscountAmount | DiscountPercent;

export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  code: Scalars['String']['output'];
  discount: CouponDiscount;
  type: Scalars['String']['output'];
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
};

export type DateRangeFilter = {
  value: DateRangeInput;
};

export type DateRangeInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['Date']['input'];
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DatoDocumentRelationsInput = {
  key: Scalars['String']['input'];
  model: DatoDocumentRelations_ModelType;
};

export enum DatoDocumentRelations_ModelType {
  RentalStation = 'rental_station',
  Tenant = 'tenant'
}

export type DeliveryCost = {
  __typename?: 'DeliveryCost';
  maxDistance: Scalars['Int']['output'];
  minPalletSpaces: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export type DeliveryDestination = {
  __typename?: 'DeliveryDestination';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  amount: Scalars['Float']['output'];
  discount: DiscountObject;
};

export type DiscountAmount = {
  __typename?: 'DiscountAmount';
  value: Scalars['Int']['output'];
};

export type DiscountObject = {
  __typename?: 'DiscountObject';
  code: Scalars['String']['output'];
  discount: DiscountValue;
};

export type DiscountPercent = {
  __typename?: 'DiscountPercent';
  value: Scalars['Int']['output'];
};

export type DiscountPrice = {
  __typename?: 'DiscountPrice';
  amount: Scalars['Float']['output'];
};

export enum DiscountTypeEnum {
  PlatformVoucherAmount = 'PLATFORM_VOUCHER_AMOUNT',
  PlatformVoucherCustomerDiscount = 'PLATFORM_VOUCHER_CUSTOMER_DISCOUNT',
  PlatformVoucherNone = 'PLATFORM_VOUCHER_NONE',
  PlatformVoucherPercentage = 'PLATFORM_VOUCHER_PERCENTAGE'
}

export type DiscountValue = {
  __typename?: 'DiscountValue';
  amount?: Maybe<DiscountValueData>;
  percent?: Maybe<DiscountValueData>;
  type: Scalars['String']['output'];
};

export type DiscountValueData = {
  __typename?: 'DiscountValueData';
  value: Scalars['Float']['output'];
};

export enum Enum_Advancedcachemanagerrecord_Cachetype {
  PurgeAll = 'purge_all',
  PurgeCdn = 'purge_cdn',
  ShortCache = 'short_cache'
}

export enum Enum_Componentcontentactionbutton_Actiontype {
  OpenSignIn = 'openSignIn',
  OpenSignUp = 'openSignUp'
}

export enum Enum_Componentcontenttextwithimage_Imageposition {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum Enum_Contentreleasesreleaseaction_Type {
  Publish = 'publish',
  Unpublish = 'unpublish'
}

export enum Enum_Log_Eventlevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO'
}

export type EndBookingInput = {
  bookingId: Scalars['String']['input'];
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  mode: UpdateBookingMode;
};

export type EnumPropertyValue = {
  __typename?: 'EnumPropertyValue';
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EqBooleanFilter = {
  value: Scalars['Boolean']['input'];
};

export type EqFilter = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorPage = {
  __typename?: 'ErrorPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  popularCategories?: Maybe<ComponentContentPopularCategories>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ErrorPageEntity = {
  __typename?: 'ErrorPageEntity';
  attributes?: Maybe<ErrorPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ErrorPageEntityResponse = {
  __typename?: 'ErrorPageEntityResponse';
  data?: Maybe<ErrorPageEntity>;
};

export type ErrorPageInput = {
  popularCategories?: InputMaybe<ComponentContentPopularCategoriesInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Faq = {
  __typename?: 'Faq';
  answer?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  prismicId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  question: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FaqEntity = {
  __typename?: 'FaqEntity';
  attributes?: Maybe<Faq>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FaqEntityResponse = {
  __typename?: 'FaqEntityResponse';
  data?: Maybe<FaqEntity>;
};

export type FaqEntityResponseCollection = {
  __typename?: 'FaqEntityResponseCollection';
  data: Array<FaqEntity>;
  meta: ResponseCollectionMeta;
};

export type FaqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FaqFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<FaqFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FaqFiltersInput>>>;
  prismicId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  question?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type FaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  prismicId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqRelationResponseCollection = {
  __typename?: 'FaqRelationResponseCollection';
  data: Array<FaqEntity>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  focalPoint?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = AdvancedCacheManagerRecord | AuthProcess | Author | BasketPage | BlogArticle | BlogCategory | BlogOverview | ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNavigationLinkWrapper | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPopularCategories | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentSlugSelector | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | ComponentHeaderHeader | ComponentHeaderHomepageHeader | ComponentHeaderImageHeader | ComponentHeaderTenantHeader | ComponentHelperBenefits | ComponentHelperCallToAction | ComponentHelperDigandoCategorySelector | ComponentHelperFactBox | ComponentHelperImagePresentation | ComponentHelperInternalLink | ComponentHelperLabelValue | ComponentHelperNavigationLink | ComponentHelperOnBoarding | ComponentHelperProducts | ComponentHelperProductsList | ComponentHelperRecommendedCategory | ComponentHelperSeo | ComponentHelperSnippet | ComponentHelperTenantLogo | ComponentHelperTest | ComponentHelperTestimonial | ComponentHelperUspCard | ComponentHelperUspDigandoItem | ConfiguratorPage | Contact | ContentReleasesRelease | ContentReleasesReleaseAction | ErrorPage | Faq | Homepage | I18NLocale | InternalLinkSelectorInternalLinkSelector | Job | JobOverview | Log | Navigation | ProductPage | SearchLocation | SearchPage | StandardPage | TenantPage | UploadFile | UploadFolder | UsersPermissionsRole | UsersPermissionsUser;

export type GeoPointInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GeolocationInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type GeolocationModel = {
  __typename?: 'GeolocationModel';
  address: AddressModel;
  correctedFields?: Maybe<Array<CorrectedFieldModel>>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locationQuality: LocationQualityModel;
  normalizedAddress: AddressModel;
  radius?: Maybe<Scalars['Int']['output']>;
};

export type Geolocation_GetLocationsQuery = {
  __typename?: 'Geolocation_GetLocationsQuery';
  locations: Array<Geolocation_LocationModel>;
};

export type Geolocation_LocationDataModel = {
  __typename?: 'Geolocation_LocationDataModel';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type Geolocation_LocationModel = {
  __typename?: 'Geolocation_LocationModel';
  data: Geolocation_LocationDataModel;
  label: Scalars['String']['output'];
};

export type GetLocationsInput = {
  /** Search parameter for locations. Can be a zip, city, or street. */
  searchParam: Scalars['String']['input'];
};

export type GraduatedPrice = {
  __typename?: 'GraduatedPrice';
  minDays: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export type Homepage = {
  __typename?: 'Homepage';
  content?: Maybe<Array<Maybe<HomepageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header?: Maybe<Array<Maybe<ComponentHeaderHomepageHeader>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<HomepageRelationResponseCollection>;
  popularCategories?: Maybe<ComponentContentPopularCategories>;
  seo?: Maybe<ComponentHelperSeo>;
  snippet?: Maybe<ComponentHelperSnippet>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type HomepageHeaderArgs = {
  filters?: InputMaybe<ComponentHeaderHomepageHeaderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HomepageContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type HomepageEntity = {
  __typename?: 'HomepageEntity';
  attributes?: Maybe<Homepage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HomepageEntityResponse = {
  __typename?: 'HomepageEntityResponse';
  data?: Maybe<HomepageEntity>;
};

export type HomepageInput = {
  content?: InputMaybe<Array<Scalars['HomepageContentDynamicZoneInput']['input']>>;
  header?: InputMaybe<Array<InputMaybe<ComponentHeaderHomepageHeaderInput>>>;
  popularCategories?: InputMaybe<ComponentContentPopularCategoriesInput>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageRelationResponseCollection = {
  __typename?: 'HomepageRelationResponseCollection';
  data: Array<HomepageEntity>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IdObject = {
  __typename?: 'IdObject';
  id: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  alt: Scalars['String']['output'];
  copyright: Scalars['String']['output'];
  format: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the image url with the specified width and height and in
   * different resolutions.
   */
  responsiveImage?: Maybe<Scalars['JSON']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type ImageMetaDataModel = {
  __typename?: 'ImageMetaDataModel';
  format: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type InFilter = {
  value: Array<Scalars['String']['input']>;
};

export enum InsuranceMode {
  PlatformInsuranceCalendardays = 'PLATFORM_INSURANCE_CALENDARDAYS',
  PlatformInsuranceIncluded = 'PLATFORM_INSURANCE_INCLUDED',
  PlatformInsuranceNone = 'PLATFORM_INSURANCE_NONE',
  PlatformInsuranceRentaldays = 'PLATFORM_INSURANCE_RENTALDAYS'
}

export type InsurancePrice = {
  __typename?: 'InsurancePrice';
  mode: InsuranceMode;
  percentage: Scalars['Float']['output'];
  price: Price;
};

export enum InsuranceTypeEnum {
  PlatformInsuranceCalendardays = 'PLATFORM_INSURANCE_CALENDARDAYS',
  PlatformInsuranceDefault = 'PLATFORM_INSURANCE_DEFAULT',
  PlatformInsuranceIncluded = 'PLATFORM_INSURANCE_INCLUDED',
  PlatformInsuranceNone = 'PLATFORM_INSURANCE_NONE',
  PlatformInsuranceRentaldays = 'PLATFORM_INSURANCE_RENTALDAYS'
}

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type IntRange = {
  __typename?: 'IntRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type InternalLinkEntityType = {
  __typename?: 'InternalLinkEntityType';
  contentType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<UploadFileEntity>;
  readMoreLinkText?: Maybe<Scalars['String']['output']>;
  readMoreLinkTitle?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tenantKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InternalLinkSelectorInternalLinkSelector = {
  __typename?: 'InternalLinkSelectorInternalLinkSelector';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InternalLinkSelectorInternalLinkSelectorEntity = {
  __typename?: 'InternalLinkSelectorInternalLinkSelectorEntity';
  attributes?: Maybe<InternalLinkSelectorInternalLinkSelector>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InternalLinkSelectorInternalLinkSelectorEntityResponse = {
  __typename?: 'InternalLinkSelectorInternalLinkSelectorEntityResponse';
  data?: Maybe<InternalLinkSelectorInternalLinkSelectorEntity>;
};

export type InternalLinkSelectorInternalLinkSelectorEntityResponseCollection = {
  __typename?: 'InternalLinkSelectorInternalLinkSelectorEntityResponseCollection';
  data: Array<InternalLinkSelectorInternalLinkSelectorEntity>;
  meta: ResponseCollectionMeta;
};

export type InternalLinkSelectorInternalLinkSelectorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InternalLinkSelectorInternalLinkSelectorFiltersInput>>>;
  contentType?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isExternal?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<InternalLinkSelectorInternalLinkSelectorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InternalLinkSelectorInternalLinkSelectorFiltersInput>>>;
  pageId?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type InternalLinkSelectorInternalLinkSelectorInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  billingPeriod: DateRange;
  created: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Job = {
  __typename?: 'Job';
  content?: Maybe<Array<Maybe<JobContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header: ComponentHeaderImageHeader;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<JobRelationResponseCollection>;
  prismicId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentHelperSeo>;
  slug: Scalars['String']['output'];
  snippet?: Maybe<ComponentHelperSnippet>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type JobLocalizationsArgs = {
  filters?: InputMaybe<JobFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type JobContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type JobEntity = {
  __typename?: 'JobEntity';
  attributes?: Maybe<Job>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type JobEntityResponse = {
  __typename?: 'JobEntityResponse';
  data?: Maybe<JobEntity>;
};

export type JobEntityResponseCollection = {
  __typename?: 'JobEntityResponseCollection';
  data: Array<JobEntity>;
  meta: ResponseCollectionMeta;
};

export type JobFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<JobFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  header?: InputMaybe<ComponentHeaderImageHeaderFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<JobFiltersInput>;
  not?: InputMaybe<JobFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<JobFiltersInput>>>;
  prismicId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentHelperSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  snippet?: InputMaybe<ComponentHelperSnippetFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type JobInput = {
  content?: InputMaybe<Array<Scalars['JobContentDynamicZoneInput']['input']>>;
  header?: InputMaybe<ComponentHeaderImageHeaderInput>;
  prismicId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type JobOverview = {
  __typename?: 'JobOverview';
  content?: Maybe<Array<Maybe<JobOverviewContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header?: Maybe<ComponentHeaderImageHeader>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<JobOverviewRelationResponseCollection>;
  seo?: Maybe<ComponentHelperSeo>;
  snippet?: Maybe<ComponentHelperSnippet>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JobOverviewContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type JobOverviewEntity = {
  __typename?: 'JobOverviewEntity';
  attributes?: Maybe<JobOverview>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type JobOverviewEntityResponse = {
  __typename?: 'JobOverviewEntityResponse';
  data?: Maybe<JobOverviewEntity>;
};

export type JobOverviewInput = {
  content?: InputMaybe<Array<Scalars['JobOverviewContentDynamicZoneInput']['input']>>;
  header?: InputMaybe<ComponentHeaderImageHeaderInput>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type JobOverviewRelationResponseCollection = {
  __typename?: 'JobOverviewRelationResponseCollection';
  data: Array<JobOverviewEntity>;
};

export type JobRelationResponseCollection = {
  __typename?: 'JobRelationResponseCollection';
  data: Array<JobEntity>;
};

export enum KeycloadUser_Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type KeycloakUserService_FilterUsersArgs = {
  hasBeenMigrated?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KeycloakUserService_UpdateUserByAdminInput = {
  crsAffiliateId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: KeycloadUser_Gender;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type KeycloakUserService_UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<KeycloadUser_Gender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type KeycloakUserService_UpdateUserResponse = {
  __typename?: 'KeycloakUserService_UpdateUserResponse';
  updated: Scalars['Boolean']['output'];
};

export type KeycloakUser_GetKeycloakUserResponse = {
  __typename?: 'KeycloakUser_GetKeycloakUserResponse';
  affiliateId: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  crsAffiliateId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  gender: KeycloadUser_Gender;
  group?: Maybe<Scalars['String']['output']>;
  hasBeenMigrated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type KeycloakUser_GetKeycloakUsersResponse = {
  __typename?: 'KeycloakUser_GetKeycloakUsersResponse';
  total: Scalars['Float']['output'];
  users: Array<KeycloakUser_GetKeycloakUserResponse>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  locale: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  distance?: Maybe<Scalars['Int']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};


export type LocationDistanceArgs = {
  referenceLocation?: InputMaybe<LocationInput>;
};

export type LocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  /** @deprecated Name will never be used in api, this is only added to solve a typeScript error in frontend-project. 3:D */
  name?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationQuality = {
  __typename?: 'LocationQuality';
  score: Scalars['Int']['output'];
  sourceService: Scalars['String']['output'];
};

export type LocationQualityModel = {
  __typename?: 'LocationQualityModel';
  score: Scalars['Int']['output'];
  sourceService: Scalars['String']['output'];
};

export type Log = {
  __typename?: 'Log';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  eventLevel?: Maybe<Enum_Log_Eventlevel>;
  message?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LogEntity = {
  __typename?: 'LogEntity';
  attributes?: Maybe<Log>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LogEntityResponse = {
  __typename?: 'LogEntityResponse';
  data?: Maybe<LogEntity>;
};

export type LogEntityResponseCollection = {
  __typename?: 'LogEntityResponseCollection';
  data: Array<LogEntity>;
  meta: ResponseCollectionMeta;
};

export type LogFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LogFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  eventDate?: InputMaybe<DateTimeFilterInput>;
  eventLevel?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LogFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LogFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LogInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  eventDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventLevel?: InputMaybe<Enum_Log_Eventlevel>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  id: Scalars['String']['output'];
  logo?: Maybe<ManufacturerLogo>;
  title: Scalars['String']['output'];
};

export type ManufacturerLogo = {
  __typename?: 'ManufacturerLogo';
  alt: Scalars['String']['output'];
  metadata: ManufacturerLogoMetaData;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ManufacturerLogoMetaData = {
  __typename?: 'ManufacturerLogoMetaData';
  format: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type ManufacturerModel = {
  __typename?: 'ManufacturerModel';
  title: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
};

export type ManufacturerQueryFilterCategoryEq = {
  value: Scalars['String']['input'];
};

export type ManufacturerQueryFilters = {
  /** Allows to filter for a specific category. */
  categoryEq?: InputMaybe<ManufacturerQueryFilterCategoryEq>;
};

export type ManufacturerQueryParams = {
  filters?: InputMaybe<ManufacturerQueryFilters>;
};

export type ManufacturersList = {
  __typename?: 'ManufacturersList';
  data: Array<Manufacturer>;
  total: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  BookingService_cancelBooking: BookingService_Booking;
  BookingService_changeBookingStatus: BookingService_Booking;
  /** Tenant preview for a booking */
  BookingService_tenantBookingPreview: BookingService_TenantBookingPreviewMutation;
  KeycloakUserService_SetUserGroup: KeycloakUserService_UpdateUserResponse;
  KeycloakUserService_UpdateUser: KeycloakUserService_UpdateUserResponse;
  KeycloakUserService_UpdateUserByAdmin: KeycloakUser_GetKeycloakUserResponse;
  OrganizationService_BlockOrganization: OrganizationService_BlockUnblockOrganizationsResponse;
  OrganizationService_CreateAddress: OrganizationService_Address;
  OrganizationService_CreateAddressByAdmin: OrganizationService_Address;
  OrganizationService_CreateBusinessUnit: OrganizationService_BusinessUnit;
  OrganizationService_CreateOrganization: OrganizationService_CreateOrganizationResponse;
  OrganizationService_CreateProject: OrganizationService_Project;
  OrganizationService_DeleteAddress: OrganizationService_DeleteResponse;
  OrganizationService_UnblockOrganization: OrganizationService_BlockUnblockOrganizationsResponse;
  OrganizationService_UpdateAddress: OrganizationService_Address;
  OrganizationService_UpdateAddressByAdmin: OrganizationService_Address;
  OrganizationService_UpdateBusinessUnit: OrganizationService_BusinessUnit;
  OrganizationService_UpdateOrganization: OrganizationService_Organization;
  OrganizationService_UpdateProject: OrganizationService_Project;
  RegisterService_Register: RegisterService_RegisterResponse;
  RegisterService_ResetPassword: RegisterService_ResetPasswordResponse;
  RegisterService_UpdatePassword: RegisterService_UpdatePasswordResponse;
  addOrUpdateCartItem?: Maybe<Cart>;
  applyCoupon?: Maybe<Cart>;
  authenticate: AuthenticateResponse;
  bookCart?: Maybe<BookCartResult>;
  cancelBooking?: Maybe<CancelBookingResponse>;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAdvancedCacheManagerRecord?: Maybe<AdvancedCacheManagerRecordEntityResponse>;
  createAuthProcessLocalization?: Maybe<AuthProcessEntityResponse>;
  createAuthor?: Maybe<AuthorEntityResponse>;
  createAuthorLocalization?: Maybe<AuthorEntityResponse>;
  createBasketPageLocalization?: Maybe<BasketPageEntityResponse>;
  createBlogArticle?: Maybe<BlogArticleEntityResponse>;
  createBlogArticleLocalization?: Maybe<BlogArticleEntityResponse>;
  createBlogCategory?: Maybe<BlogCategoryEntityResponse>;
  createBlogCategoryLocalization?: Maybe<BlogCategoryEntityResponse>;
  createBlogOverviewLocalization?: Maybe<BlogOverviewEntityResponse>;
  createContact?: Maybe<ContactEntityResponse>;
  createContentReleasesRelease?: Maybe<ContentReleasesReleaseEntityResponse>;
  createContentReleasesReleaseAction?: Maybe<ContentReleasesReleaseActionEntityResponse>;
  createFaq?: Maybe<FaqEntityResponse>;
  createHomepageLocalization?: Maybe<HomepageEntityResponse>;
  createInternalLinkSelectorInternalLinkSelector?: Maybe<InternalLinkSelectorInternalLinkSelectorEntityResponse>;
  createJob?: Maybe<JobEntityResponse>;
  createJobLocalization?: Maybe<JobEntityResponse>;
  createJobOverviewLocalization?: Maybe<JobOverviewEntityResponse>;
  createLog?: Maybe<LogEntityResponse>;
  createNavigationLocalization?: Maybe<NavigationEntityResponse>;
  createProductPageLocalization?: Maybe<ProductPageEntityResponse>;
  createSearchLocation?: Maybe<SearchLocationEntityResponse>;
  createSearchPage?: Maybe<SearchPageEntityResponse>;
  createSearchPageLocalization?: Maybe<SearchPageEntityResponse>;
  createStandardPage?: Maybe<StandardPageEntityResponse>;
  createStandardPageLocalization?: Maybe<StandardPageEntityResponse>;
  createTenantPage?: Maybe<TenantPageEntityResponse>;
  createTenantPageLocalization?: Maybe<TenantPageEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteAdvancedCacheManagerRecord?: Maybe<AdvancedCacheManagerRecordEntityResponse>;
  deleteAuthProcess?: Maybe<AuthProcessEntityResponse>;
  deleteAuthor?: Maybe<AuthorEntityResponse>;
  deleteBasketPage?: Maybe<BasketPageEntityResponse>;
  deleteBlogArticle?: Maybe<BlogArticleEntityResponse>;
  deleteBlogCategory?: Maybe<BlogCategoryEntityResponse>;
  deleteBlogOverview?: Maybe<BlogOverviewEntityResponse>;
  deleteConfiguratorPage?: Maybe<ConfiguratorPageEntityResponse>;
  deleteContact?: Maybe<ContactEntityResponse>;
  deleteContentReleasesRelease?: Maybe<ContentReleasesReleaseEntityResponse>;
  deleteContentReleasesReleaseAction?: Maybe<ContentReleasesReleaseActionEntityResponse>;
  deleteErrorPage?: Maybe<ErrorPageEntityResponse>;
  deleteFaq?: Maybe<FaqEntityResponse>;
  deleteHomepage?: Maybe<HomepageEntityResponse>;
  deleteInternalLinkSelectorInternalLinkSelector?: Maybe<InternalLinkSelectorInternalLinkSelectorEntityResponse>;
  deleteJob?: Maybe<JobEntityResponse>;
  deleteJobOverview?: Maybe<JobOverviewEntityResponse>;
  deleteLog?: Maybe<LogEntityResponse>;
  deleteNavigation?: Maybe<NavigationEntityResponse>;
  deleteProductPage?: Maybe<ProductPageEntityResponse>;
  deleteSearchLocation?: Maybe<SearchLocationEntityResponse>;
  deleteSearchPage?: Maybe<SearchPageEntityResponse>;
  deleteStandardPage?: Maybe<StandardPageEntityResponse>;
  deleteTenantPage?: Maybe<TenantPageEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  endBooking?: Maybe<UpdateBookingResponse>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeCartItem?: Maybe<Cart>;
  removeCoupon?: Maybe<Cart>;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  subscribe: SubscriptionResponse;
  updateAdvancedCacheManagerRecord?: Maybe<AdvancedCacheManagerRecordEntityResponse>;
  updateAuthProcess?: Maybe<AuthProcessEntityResponse>;
  updateAuthor?: Maybe<AuthorEntityResponse>;
  updateBasketPage?: Maybe<BasketPageEntityResponse>;
  updateBlogArticle?: Maybe<BlogArticleEntityResponse>;
  updateBlogCategory?: Maybe<BlogCategoryEntityResponse>;
  updateBlogOverview?: Maybe<BlogOverviewEntityResponse>;
  updateBooking?: Maybe<UpdateBookingResponse>;
  updateConfiguratorPage?: Maybe<ConfiguratorPageEntityResponse>;
  updateContact?: Maybe<ContactEntityResponse>;
  updateContentReleasesRelease?: Maybe<ContentReleasesReleaseEntityResponse>;
  updateContentReleasesReleaseAction?: Maybe<ContentReleasesReleaseActionEntityResponse>;
  updateErrorPage?: Maybe<ErrorPageEntityResponse>;
  updateFaq?: Maybe<FaqEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateHomepage?: Maybe<HomepageEntityResponse>;
  updateInternalLinkSelectorInternalLinkSelector?: Maybe<InternalLinkSelectorInternalLinkSelectorEntityResponse>;
  updateJob?: Maybe<JobEntityResponse>;
  updateJobOverview?: Maybe<JobOverviewEntityResponse>;
  updateLog?: Maybe<LogEntityResponse>;
  updateNavigation?: Maybe<NavigationEntityResponse>;
  updateProductPage?: Maybe<ProductPageEntityResponse>;
  updateSearchLocation?: Maybe<SearchLocationEntityResponse>;
  updateSearchPage?: Maybe<SearchPageEntityResponse>;
  updateStandardPage?: Maybe<StandardPageEntityResponse>;
  updateTenantPage?: Maybe<TenantPageEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationBookingService_CancelBookingArgs = {
  bookingNumber: Scalars['String']['input'];
};


export type MutationBookingService_ChangeBookingStatusArgs = {
  bookingNumber: Scalars['String']['input'];
  newStatusCode: BookingStatusEnum;
};


export type MutationBookingService_TenantBookingPreviewArgs = {
  params: BookingService_TenantBookingPreviewInput;
};


export type MutationKeycloakUserService_SetUserGroupArgs = {
  groupName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationKeycloakUserService_UpdateUserArgs = {
  profile: KeycloakUserService_UpdateUserInput;
};


export type MutationKeycloakUserService_UpdateUserByAdminArgs = {
  emailVerified: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  profile: KeycloakUserService_UpdateUserByAdminInput;
  userId: Scalars['String']['input'];
};


export type MutationOrganizationService_BlockOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type MutationOrganizationService_CreateAddressArgs = {
  address: OrganizationService_CreateAddress;
};


export type MutationOrganizationService_CreateAddressByAdminArgs = {
  address: OrganizationService_CreateAddress;
};


export type MutationOrganizationService_CreateBusinessUnitArgs = {
  businessUnit: OrganizationService_CreateBusinessUnit;
};


export type MutationOrganizationService_CreateOrganizationArgs = {
  organization: OrganizationService_CreateOrganization;
};


export type MutationOrganizationService_CreateProjectArgs = {
  project: OrganizationService_CreateProject;
};


export type MutationOrganizationService_DeleteAddressArgs = {
  id: Scalars['String']['input'];
};


export type MutationOrganizationService_UnblockOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type MutationOrganizationService_UpdateAddressArgs = {
  address: OrganizationService_UpdateAddress;
};


export type MutationOrganizationService_UpdateAddressByAdminArgs = {
  address: OrganizationService_UpdateAddress;
};


export type MutationOrganizationService_UpdateBusinessUnitArgs = {
  businessUnit: OrganizationService_UpdateBusinessUnit;
};


export type MutationOrganizationService_UpdateOrganizationArgs = {
  organization: OrganizationService_UpdateOrganization;
};


export type MutationOrganizationService_UpdateProjectArgs = {
  project: OrganizationService_UpdateProject;
};


export type MutationRegisterService_RegisterArgs = {
  affiliateId: Scalars['String']['input'];
  crsAffiliateId: Scalars['String']['input'];
  organization: RegisterService_RegisterOrganization;
  user: RegisterService_RegisterUser;
};


export type MutationRegisterService_ResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationRegisterService_UpdatePasswordArgs = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationAddOrUpdateCartItemArgs = {
  input: AddOrUpdateCartItemInput;
};


export type MutationApplyCouponArgs = {
  input: ApplyCouponInput;
};


export type MutationAuthenticateArgs = {
  input: AuthenticateInput;
};


export type MutationBookCartArgs = {
  input: BookCartInput;
};


export type MutationCancelBookingArgs = {
  input: CancelBookingInput;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateAdvancedCacheManagerRecordArgs = {
  data: AdvancedCacheManagerRecordInput;
};


export type MutationCreateAuthProcessLocalizationArgs = {
  data?: InputMaybe<AuthProcessInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateAuthorArgs = {
  data: AuthorInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateAuthorLocalizationArgs = {
  data?: InputMaybe<AuthorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBasketPageLocalizationArgs = {
  data?: InputMaybe<BasketPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogArticleArgs = {
  data: BlogArticleInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogArticleLocalizationArgs = {
  data?: InputMaybe<BlogArticleInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogCategoryArgs = {
  data: BlogCategoryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogCategoryLocalizationArgs = {
  data?: InputMaybe<BlogCategoryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogOverviewLocalizationArgs = {
  data?: InputMaybe<BlogOverviewInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateContactArgs = {
  data: ContactInput;
};


export type MutationCreateContentReleasesReleaseArgs = {
  data: ContentReleasesReleaseInput;
};


export type MutationCreateContentReleasesReleaseActionArgs = {
  data: ContentReleasesReleaseActionInput;
};


export type MutationCreateFaqArgs = {
  data: FaqInput;
};


export type MutationCreateHomepageLocalizationArgs = {
  data?: InputMaybe<HomepageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInternalLinkSelectorInternalLinkSelectorArgs = {
  data: InternalLinkSelectorInternalLinkSelectorInput;
};


export type MutationCreateJobArgs = {
  data: JobInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateJobLocalizationArgs = {
  data?: InputMaybe<JobInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateJobOverviewLocalizationArgs = {
  data?: InputMaybe<JobOverviewInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLogArgs = {
  data: LogInput;
};


export type MutationCreateNavigationLocalizationArgs = {
  data?: InputMaybe<NavigationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateProductPageLocalizationArgs = {
  data?: InputMaybe<ProductPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSearchLocationArgs = {
  data: SearchLocationInput;
};


export type MutationCreateSearchPageArgs = {
  data: SearchPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSearchPageLocalizationArgs = {
  data?: InputMaybe<SearchPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateStandardPageArgs = {
  data: StandardPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateStandardPageLocalizationArgs = {
  data?: InputMaybe<StandardPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateTenantPageArgs = {
  data: TenantPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateTenantPageLocalizationArgs = {
  data?: InputMaybe<TenantPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteAdvancedCacheManagerRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAuthProcessArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteAuthorArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteBasketPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteBlogArticleArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteBlogCategoryArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteBlogOverviewArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentReleasesReleaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentReleasesReleaseActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFaqArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHomepageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteInternalLinkSelectorInternalLinkSelectorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteJobOverviewArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNavigationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteProductPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSearchLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSearchPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteStandardPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteTenantPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationEndBookingArgs = {
  input: EndBookingInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveCartItemArgs = {
  input: RemoveCartItemInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationSubscribeArgs = {
  input: SubscribeInput;
};


export type MutationUpdateAdvancedCacheManagerRecordArgs = {
  data: AdvancedCacheManagerRecordInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAuthProcessArgs = {
  data: AuthProcessInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateAuthorArgs = {
  data: AuthorInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateBasketPageArgs = {
  data: BasketPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateBlogArticleArgs = {
  data: BlogArticleInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateBlogCategoryArgs = {
  data: BlogCategoryInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateBlogOverviewArgs = {
  data: BlogOverviewInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput;
};


export type MutationUpdateConfiguratorPageArgs = {
  data: ConfiguratorPageInput;
};


export type MutationUpdateContactArgs = {
  data: ContactInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateContentReleasesReleaseArgs = {
  data: ContentReleasesReleaseInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateContentReleasesReleaseActionArgs = {
  data: ContentReleasesReleaseActionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateErrorPageArgs = {
  data: ErrorPageInput;
};


export type MutationUpdateFaqArgs = {
  data: FaqInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateHomepageArgs = {
  data: HomepageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateInternalLinkSelectorInternalLinkSelectorArgs = {
  data: InternalLinkSelectorInternalLinkSelectorInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateJobArgs = {
  data: JobInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateJobOverviewArgs = {
  data: JobOverviewInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateLogArgs = {
  data: LogInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateNavigationArgs = {
  data: NavigationInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateProductPageArgs = {
  data: ProductPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateSearchLocationArgs = {
  data: SearchLocationInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSearchPageArgs = {
  data: SearchPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateStandardPageArgs = {
  data: StandardPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateTenantPageArgs = {
  data: TenantPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type Navigation = {
  __typename?: 'Navigation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  footerLeft?: Maybe<Array<Maybe<ComponentHelperNavigationLink>>>;
  footerRight?: Maybe<Array<Maybe<ComponentHelperNavigationLink>>>;
  header?: Maybe<Array<Maybe<ComponentContentNavigationLinkWrapper>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NavigationRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NavigationFooterLeftArgs = {
  filters?: InputMaybe<ComponentHelperNavigationLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type NavigationFooterRightArgs = {
  filters?: InputMaybe<ComponentHelperNavigationLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type NavigationHeaderArgs = {
  filters?: InputMaybe<ComponentContentNavigationLinkWrapperFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NavigationEntity = {
  __typename?: 'NavigationEntity';
  attributes?: Maybe<Navigation>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NavigationEntityResponse = {
  __typename?: 'NavigationEntityResponse';
  data?: Maybe<NavigationEntity>;
};

export type NavigationInput = {
  footerLeft?: InputMaybe<Array<InputMaybe<ComponentHelperNavigationLinkInput>>>;
  footerRight?: InputMaybe<Array<InputMaybe<ComponentHelperNavigationLinkInput>>>;
  header?: InputMaybe<Array<InputMaybe<ComponentContentNavigationLinkWrapperInput>>>;
};

export type NavigationLinkEntityType = {
  __typename?: 'NavigationLinkEntityType';
  contentType?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NavigationRelationResponseCollection = {
  __typename?: 'NavigationRelationResponseCollection';
  data: Array<NavigationEntity>;
};

export type OrganizationService_Address = {
  __typename?: 'OrganizationService_Address';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  geoPoint: OrganizationService_GeoPoint;
  id: Scalars['String']['output'];
  locationQuality?: Maybe<OrganizationService_LocationQuality>;
  name: Scalars['String']['output'];
  project?: Maybe<OrganizationService_Project>;
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  zipCode: Scalars['String']['output'];
};

export type OrganizationService_AddressesResponse = {
  __typename?: 'OrganizationService_AddressesResponse';
  addresses: Array<OrganizationService_Address>;
  total: Scalars['Float']['output'];
};

export type OrganizationService_BlockUnblockOrganizationsResponse = {
  __typename?: 'OrganizationService_BlockUnblockOrganizationsResponse';
  updated: Scalars['Boolean']['output'];
};

export type OrganizationService_BusinessUnit = {
  __typename?: 'OrganizationService_BusinessUnit';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationService_Organization;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationService_BusinessUnitsResponse = {
  __typename?: 'OrganizationService_BusinessUnitsResponse';
  businessUnits: Array<OrganizationService_BusinessUnit>;
  total: Scalars['Float']['output'];
};

export type OrganizationService_CheckVatIdResponse = {
  __typename?: 'OrganizationService_CheckVatIdResponse';
  address: OrganizationService_VatIdAddress;
  name: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
  vatId: Scalars['String']['output'];
};

export type OrganizationService_CreateAddress = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  geoPoint: OrganizationService_GeoPointArgs;
  locationQuality: OrganizationService_LocationQualityArgs;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type OrganizationService_CreateBusinessUnit = {
  /** If true, this business unit will be the default business unit for the organization. If there is already a default business unit, we will return the existing default business unit. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationService_CreateOrganization = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  geoPoint: OrganizationService_GeoPointArgs;
  name: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type OrganizationService_CreateOrganizationResponse = {
  __typename?: 'OrganizationService_CreateOrganizationResponse';
  isNewOrganization: Scalars['Boolean']['output'];
  organization: OrganizationService_Organization;
};

export type OrganizationService_CreateProject = {
  businessUnitId: Scalars['String']['input'];
  externalProjectId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type OrganizationService_DeleteResponse = {
  __typename?: 'OrganizationService_DeleteResponse';
  deleted: Scalars['Boolean']['output'];
};

export type OrganizationService_FilterAddressArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type OrganizationService_FilterBusinessUnitArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type OrganizationService_FilterOrganizationArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The HPK Customer Number. If the value is undefined it will show all, null will deliver only organizations without HPK Customer Number. */
  hpkCustomerNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationService_FilterProjectArgs = {
  businessUnitId?: InputMaybe<Scalars['String']['input']>;
  externalProjectId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationService_GeoPoint = {
  __typename?: 'OrganizationService_GeoPoint';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type OrganizationService_GeoPointArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type OrganizationService_LocationQuality = {
  __typename?: 'OrganizationService_LocationQuality';
  score: Scalars['Float']['output'];
  sourceService: Scalars['String']['output'];
};

export type OrganizationService_LocationQualityArgs = {
  score: Scalars['Float']['input'];
  sourceService: Scalars['String']['input'];
};

export type OrganizationService_Organization = {
  __typename?: 'OrganizationService_Organization';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  geoPoint: OrganizationService_GeoPoint;
  hpkCustomerNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isBlocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type OrganizationService_OrganizationIdsResponse = {
  __typename?: 'OrganizationService_OrganizationIdsResponse';
  organizationIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrganizationService_OrganizationMembersResponse = {
  __typename?: 'OrganizationService_OrganizationMembersResponse';
  members: Array<OrganizationsService_Members>;
  total: Scalars['Float']['output'];
};

export type OrganizationService_OrganizationsResponse = {
  __typename?: 'OrganizationService_OrganizationsResponse';
  organizations: Array<OrganizationService_Organization>;
  total: Scalars['Float']['output'];
};

export type OrganizationService_Project = {
  __typename?: 'OrganizationService_Project';
  addresses?: Maybe<Array<OrganizationService_Address>>;
  businessUnit: OrganizationService_BusinessUnit;
  createdAt: Scalars['DateTime']['output'];
  externalProjectId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationService_ProjectsResponse = {
  __typename?: 'OrganizationService_ProjectsResponse';
  projects: Array<OrganizationService_Project>;
  total: Scalars['Float']['output'];
};

export type OrganizationService_SanitizedVatIdResponse = {
  __typename?: 'OrganizationService_SanitizedVatIdResponse';
  vatId: Scalars['String']['output'];
};

export type OrganizationService_SortAddressArgs = {
  by: AddressSortBy;
  order: SortOrder;
};

export type OrganizationService_SortBusinessUnitArgs = {
  by: BusinessUnitSortBy;
  order: SortOrder;
};

export type OrganizationService_SortOrganizationArgs = {
  by: OrganizationSortBy;
  order: SortOrder;
};

export type OrganizationService_SortProjectArgs = {
  by: ProjectSortBy;
  order: SortOrder;
};

export type OrganizationService_UpdateAddress = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  geoPoint?: InputMaybe<OrganizationService_GeoPointArgs>;
  id: Scalars['String']['input'];
  locationQuality: OrganizationService_LocationQualityArgs;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type OrganizationService_UpdateBusinessUnit = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationService_UpdateOrganization = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  geoPoint?: InputMaybe<OrganizationService_GeoPointArgs>;
  hpkCustomerNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationService_UpdateProject = {
  externalProjectId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OrganizationService_VatIdAddress = {
  __typename?: 'OrganizationService_VatIdAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

/** Sort Organization list by */
export enum OrganizationSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type OrganizationsService_Members = {
  __typename?: 'OrganizationsService_Members';
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationArgs = {
  limit: Scalars['Float']['input'];
  offset: Scalars['Float']['input'];
};

export type PercentagePrice = {
  __typename?: 'PercentagePrice';
  percentage: Scalars['Float']['output'];
  price: Price;
};

export type PlaceInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type PlaceModel = {
  __typename?: 'PlaceModel';
  address?: Maybe<AddressModel>;
  id: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  radius?: Maybe<Scalars['Int']['output']>;
};

export type PlaceSuggestionModel = {
  __typename?: 'PlaceSuggestionModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  radius?: Maybe<Scalars['Int']['output']>;
};

export type PlacesInput = {
  options?: InputMaybe<PlacesOptionsInput>;
  text: Scalars['String']['input'];
};

export type PlacesOptionsInput = {
  suggestionType: SuggestionType;
};

export type PlacesSuggestionModel = {
  __typename?: 'PlacesSuggestionModel';
  data: Array<PlaceSuggestionModel>;
  total: Scalars['Int']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  amountPerDay: Scalars['Float']['output'];
  amountPerDayReduced: Scalars['Float']['output'];
};

export type PriceInformationPriceModel = {
  __typename?: 'PriceInformationPriceModel';
  amount: Scalars['Int']['output'];
  type: ProductSearch_PriceAmountTypeEnum;
};

export type PriceService_DateRangeInput = {
  gte: Scalars['String']['input'];
  lte: Scalars['String']['input'];
};

export type PriceService_Discount = {
  __typename?: 'PriceService_Discount';
  amount: PriceService_DiscountValue;
  code: Scalars['String']['output'];
  percent: PriceService_DiscountValue;
  type: Scalars['String']['output'];
};

export type PriceService_DiscountValue = {
  __typename?: 'PriceService_DiscountValue';
  value: Scalars['Int']['output'];
};

export enum PriceService_PriceAmountTypeEnum {
  Eq = 'EQ',
  Min = 'MIN'
}

export type PriceService_ProductPrice = {
  __typename?: 'PriceService_ProductPrice';
  amount: Scalars['Int']['output'];
  type: PriceService_PriceAmountTypeEnum;
};

export type PriceService_ProductPriceDiscount = {
  __typename?: 'PriceService_ProductPriceDiscount';
  amount: Scalars['Int']['output'];
  discount: PriceService_Discount;
};

export type PriceService_ProductPriceModel = {
  __typename?: 'PriceService_ProductPriceModel';
  discounts: Array<PriceService_ProductPriceDiscount>;
  productAmount: Scalars['Int']['output'];
  productPricePerDay: PriceService_ProductPrice;
  productPriceReducedPerDay: PriceService_ProductPrice;
  serviceFees: Array<PriceService_ServiceFee>;
  tierPrices: Array<PriceService_TierPrice>;
  workingDays: Scalars['Int']['output'];
};

export type PriceService_ServiceFee = {
  __typename?: 'PriceService_ServiceFee';
  identifier: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type PriceService_TierPrice = {
  __typename?: 'PriceService_TierPrice';
  /** This price will be used if the rental period is more than or equal to minDays */
  minDays: Scalars['Int']['output'];
  /** Price in cents */
  price: Scalars['Int']['output'];
};

export enum PriceType {
  Eq = 'EQ',
  Min = 'MIN'
}

export type ProductAccessory = {
  __typename?: 'ProductAccessory';
  accessoryType?: Maybe<ProductAccessoryType>;
  forcePayment?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<Maybe<ProductAccessoryImage>>>;
  isPreselected?: Maybe<Scalars['Boolean']['output']>;
  manufacturerName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priceType: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  tierPrices?: Maybe<Array<GraduatedPrice>>;
  title?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  wearPartPrice?: Maybe<Scalars['Int']['output']>;
};

export type ProductAccessoryImage = {
  __typename?: 'ProductAccessoryImage';
  alt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ProductAccessoryType = {
  __typename?: 'ProductAccessoryType';
  identifier?: Maybe<Scalars['String']['output']>;
};

export type ProductBundle = {
  __typename?: 'ProductBundle';
  availableProducts: Scalars['Int']['output'];
  availableRentalStations: Array<RentalStation>;
  deliveryRentalStations: Array<RentalStation>;
  pickupRentalStations: Array<RentalStation>;
  priceInformation?: Maybe<ProductBundlePriceInformation>;
  prices: Array<GraduatedPrice>;
  properties: Array<ProductBundleProperty>;
  rentInformation: RentInformation;
  rentalStations: Array<RentalStation>;
  rentalStationsDistances: Array<RentalStationDistance>;
  selectedProduct?: Maybe<SelectedProduct>;
  selectedRentalStation?: Maybe<RentalStation>;
  shippingOptions: ShippingOptions;
  totalProducts: Scalars['Int']['output'];
  type: ProductType;
};

export type ProductBundleInput = {
  accessories?: InputMaybe<Array<AccessoryInput>>;
  dateRange: DateRangeInput;
  deliveryAddressId?: InputMaybe<Scalars['String']['input']>;
  editBasketItemId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  productAmount?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Array<PropertyFilter>>;
  rentalStationIdentifier?: InputMaybe<Scalars['String']['input']>;
  shippingOption?: InputMaybe<ShippingOption>;
  tenantKey?: InputMaybe<Scalars['String']['input']>;
  uriComponent: Scalars['String']['input'];
};

export type ProductBundlePriceInformation = {
  __typename?: 'ProductBundlePriceInformation';
  productAmount?: Maybe<Scalars['Int']['output']>;
  productPricePerDay: TypedPrice;
  productPriceReducedPerDay: TypedPrice;
  serviceFees: Array<ServiceFee>;
  workingDays: Scalars['Int']['output'];
};

export type ProductBundleProperty = {
  __typename?: 'ProductBundleProperty';
  descriptor: PropertyDescriptor;
  isEquipment: Scalars['Boolean']['output'];
  isFact: Scalars['Boolean']['output'];
  isRolloverProperty: Scalars['Boolean']['output'];
  isVariant: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  values?: Maybe<Scalars['JSON']['output']>;
};

export type ProductBundleResult = {
  __typename?: 'ProductBundleResult';
  accessories: Array<ProductAccessory>;
  bundle?: Maybe<ProductBundle>;
  relatedProducts: Array<ProductBundle>;
};

export type ProductCategoriesConnection = {
  __typename?: 'ProductCategoriesConnection';
  edges?: Maybe<Array<Maybe<ProductCategoriesEdge>>>;
};

export type ProductCategoriesEdge = {
  __typename?: 'ProductCategoriesEdge';
  node?: Maybe<Category>;
};

export type ProductPage = {
  __typename?: 'ProductPage';
  benefits?: Maybe<Array<Maybe<ComponentHelperBenefits>>>;
  content?: Maybe<Array<Maybe<ProductPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ProductPageRelationResponseCollection>;
  seo?: Maybe<ComponentHelperSeo>;
  snippet?: Maybe<ComponentHelperSnippet>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProductPageBenefitsArgs = {
  filters?: InputMaybe<ComponentHelperBenefitsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProductPageContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | Error;

export type ProductPageEntity = {
  __typename?: 'ProductPageEntity';
  attributes?: Maybe<ProductPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProductPageEntityResponse = {
  __typename?: 'ProductPageEntityResponse';
  data?: Maybe<ProductPageEntity>;
};

export type ProductPageInput = {
  benefits?: InputMaybe<Array<InputMaybe<ComponentHelperBenefitsInput>>>;
  content?: InputMaybe<Array<Scalars['ProductPageContentDynamicZoneInput']['input']>>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
};

export type ProductPageRelationResponseCollection = {
  __typename?: 'ProductPageRelationResponseCollection';
  data: Array<ProductPageEntity>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  accessories: Array<AccessoryPrice>;
  accessory: Price;
  discount?: Maybe<Price>;
  discounts?: Maybe<Array<Discount>>;
  effective: Price;
  final: Price;
  insurance?: Maybe<InsurancePrice>;
  product: Price;
  productAmount: Scalars['Int']['output'];
  serviceFees: Array<ServiceFee>;
  shipping?: Maybe<Price>;
  taxes: Array<PercentagePrice>;
  total: Price;
  workingDays: Scalars['Int']['output'];
};

export type ProductPriceData = {
  __typename?: 'ProductPriceData';
  productPrice?: Maybe<ProductPrice>;
  productPriceError?: Maybe<ProductPriceError>;
};

export type ProductPriceError = {
  __typename?: 'ProductPriceError';
  code: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type ProductPriceInput = {
  accessories?: InputMaybe<Array<AccessoryInput>>;
  dateRange: DateRangeInput;
  deliveryAddressId?: InputMaybe<Scalars['String']['input']>;
  insurance?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<LocationInput>;
  productAmount?: InputMaybe<Scalars['Int']['input']>;
  properties: Array<PropertyInput>;
  relatedTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rentalStationIdentifier?: InputMaybe<Scalars['String']['input']>;
  shippingOption?: InputMaybe<ShippingOption>;
  uriComponent: Scalars['String']['input'];
};

export type ProductPropertyModel = {
  __typename?: 'ProductPropertyModel';
  descriptor: PropertyDescriptorModel;
  isEquipment: Scalars['Boolean']['output'];
  isFact: Scalars['Boolean']['output'];
  isRolloverProperty: Scalars['Boolean']['output'];
  isVariant: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value: Scalars['ProductSearch_PropertyValue']['output'];
};

export type ProductSearchDateRange = {
  gte: Scalars['Date']['input'];
  lte: Scalars['Date']['input'];
};

export type ProductSearchFilterCategoryItem = {
  __typename?: 'ProductSearchFilterCategoryItem';
  categoryId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type ProductSearchFilterItem = {
  __typename?: 'ProductSearchFilterItem';
  enums: Array<ProductSearchFilterItemEnum>;
  key: Scalars['String']['output'];
  propertyDescriptor: PropertyDescriptor;
  range?: Maybe<ProductSearchFilterItemRange>;
};

export type ProductSearchFilterItemEnum = {
  __typename?: 'ProductSearchFilterItemEnum';
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type ProductSearchFilterItemRange = {
  __typename?: 'ProductSearchFilterItemRange';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type ProductSearchFilterParams = {
  dateRange: ProductSearchDateRange;
  geoPoint?: InputMaybe<GeoPointInput>;
  isDeliveryPossible?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
  searchRadius?: InputMaybe<Scalars['Int']['input']>;
  tenantKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  uriComponent: Scalars['String']['input'];
};

export type ProductSearchFilterResult = {
  __typename?: 'ProductSearchFilterResult';
  categories: Array<ProductSearchFilterCategoryItem>;
  manufacturers: Array<ProductSearchFilterItemEnum>;
  properties: Array<ProductSearchFilterItem>;
  tenants: Array<ProductSearchFilterItemEnum>;
};

export type ProductSearchFilterResults = {
  __typename?: 'ProductSearchFilterResults';
  category: Category;
  data: ProductSearchFilterResult;
  total: Scalars['Int']['output'];
};

export type ProductSearchItem = {
  __typename?: 'ProductSearchItem';
  groupKey: Scalars['String']['output'];
  hasHiddenPrices: Scalars['Boolean']['output'];
  priceInformation?: Maybe<ProductSearchItemPriceInformation>;
  prices: Array<GraduatedPrice>;
  productImage: ProductTypeImage;
  properties: Array<ProductSearchProperties>;
  rentalStation: RentalStation;
  rentalStations: Array<RentalStation>;
  serviceFees: Array<ServiceFee>;
  showPrices: Scalars['Boolean']['output'];
  type: ProductType;
};

export type ProductSearchItemPriceInformation = {
  __typename?: 'ProductSearchItemPriceInformation';
  productPricePerDay: TypedPrice;
  productPriceReducedPerDay: TypedPrice;
  serviceFees: Array<ServiceFee>;
  workingDays: Scalars['Int']['output'];
};

export type ProductSearchPaginationParams = {
  page: Scalars['Int']['input'];
};

export type ProductSearchPaginationResult = {
  __typename?: 'ProductSearchPaginationResult';
  hasMore: Scalars['Boolean']['output'];
};

export type ProductSearchParams = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateRange: ProductSearchDateRange;
  geoPoint?: InputMaybe<GeoPointInput>;
  isDeliveryPossible?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination: ProductSearchPaginationParams;
  productTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<ProductSearchPropertyFilter>>;
  searchRadius?: InputMaybe<Scalars['Int']['input']>;
  tenantKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  uriComponent: Scalars['String']['input'];
};

export type ProductSearchProperties = {
  __typename?: 'ProductSearchProperties';
  descriptor: PropertyDescriptor;
  isEquipment: Scalars['Boolean']['output'];
  isFact: Scalars['Boolean']['output'];
  isRolloverProperty: Scalars['Boolean']['output'];
  isVariant: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['AnyScalar']['output']>;
};

export type ProductSearchPropertyFilter = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type ProductSearchResultFilters = {
  __typename?: 'ProductSearchResultFilters';
  radius?: Maybe<Scalars['Int']['output']>;
  sort: ProductSearchResultSort;
};

export type ProductSearchResultSort = {
  __typename?: 'ProductSearchResultSort';
  by: ProductSearchSortOptionArgs;
};

export type ProductSearchResults = {
  __typename?: 'ProductSearchResults';
  activeFilters: ProductSearchResultFilters;
  category?: Maybe<Category>;
  data: Array<ProductSearchItem>;
  loadedDate: Scalars['DateTime']['output'];
  pagination: ProductSearchPaginationResult;
  total: Scalars['Int']['output'];
};

export type ProductSearchSort = {
  by?: InputMaybe<ProductSearchSortOptionInput>;
};

export enum ProductSearchSortOptionArgs {
  DistanceAsc = 'DISTANCE_ASC',
  PositionAsc = 'POSITION_ASC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  ScoreAsc = 'SCORE_ASC'
}

export enum ProductSearchSortOptionInput {
  DistanceAsc = 'DISTANCE_ASC',
  PositionAsc = 'POSITION_ASC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  ScoreAsc = 'SCORE_ASC'
}

export type ProductSearch_ActiveFilters = {
  __typename?: 'ProductSearch_ActiveFilters';
  radius?: Maybe<Scalars['Int']['output']>;
  sort: ProductSearch_ActiveFiltersSort;
};

export type ProductSearch_ActiveFiltersSort = {
  __typename?: 'ProductSearch_ActiveFiltersSort';
  by: ProductSearch_SortOption;
};

export type ProductSearch_DateRangeInput = {
  gte: Scalars['String']['input'];
  lte: Scalars['String']['input'];
};

/** Price information for a product, including daily prices, tiered pricing, and service fees, also includes working days and reduced prices. This model is used for detailed price information and can be loaded slower than the preview price information model. */
export type ProductSearch_DetailedPriceInformationModel = {
  __typename?: 'ProductSearch_DetailedPriceInformationModel';
  productPricePerDay: PriceInformationPriceModel;
  productPriceReducedPerDay: PriceInformationPriceModel;
  serviceFees: Array<ProductSearch_ServiceFee>;
  tierPrices: Array<ProductSearch_TierPrice>;
  workingDays: Scalars['Int']['output'];
};

export type ProductSearch_EnumPropertiesInput = {
  key: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export type ProductSearch_GeoPointInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  searchRadius?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductSearch_ImageModel = {
  __typename?: 'ProductSearch_ImageModel';
  alt: Scalars['String']['output'];
  metadata: ImageMetaDataModel;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProductSearch_PaginationInput = {
  /** Page number starts with 1 */
  page: Scalars['Int']['input'];
};

export type ProductSearch_PaginationModel = {
  __typename?: 'ProductSearch_PaginationModel';
  currentPage: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
};

/** Preview price information for a product, including daily prices, tiered pricing, and service fees. This model can be loaded much faster than the detailed price information model. */
export type ProductSearch_PreviewPriceInformationModel = {
  __typename?: 'ProductSearch_PreviewPriceInformationModel';
  productPricePerDay: PriceInformationPriceModel;
  serviceFees: Array<ProductSearch_ServiceFee>;
  tierPrices: Array<ProductSearch_TierPrice>;
};

export enum ProductSearch_PriceAmountTypeEnum {
  Eq = 'EQ',
  Min = 'MIN'
}

export type ProductSearch_ProductModel = {
  __typename?: 'ProductSearch_ProductModel';
  detailedPriceInformation?: Maybe<ProductSearch_DetailedPriceInformationModel>;
  groupKey: Scalars['ID']['output'];
  hasHiddenPrice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDeliveryPossible: Scalars['Boolean']['output'];
  previewPriceInformation?: Maybe<ProductSearch_PreviewPriceInformationModel>;
  productImages: Array<ProductSearch_ImageModel>;
  properties: Array<ProductPropertyModel>;
  rentalStation: ProductSearch_RentalStationModel;
  rentalStations: Array<ProductSearch_RentalStationModel>;
  shippingOptions: ProductSearch_ShippingOptions;
  showPrices: Scalars['Boolean']['output'];
  tenant: ProductSearch_TenantModel;
  type: ProductSearch_ProductTypeModel;
};

export type ProductSearch_ProductSearchResponseModel = {
  __typename?: 'ProductSearch_ProductSearchResponseModel';
  activeFilters: ProductSearch_ActiveFilters;
  loadedDate: Scalars['DateTime']['output'];
  pagination: ProductSearch_PaginationModel;
  products: Array<ProductSearch_ProductModel>;
  total: Scalars['Int']['output'];
};

export type ProductSearch_ProductTypeModel = {
  __typename?: 'ProductSearch_ProductTypeModel';
  configuratorPageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mainCategory: CategoryModel;
  manufacturer: ManufacturerModel;
  productPageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
};

export type ProductSearch_RangePropertiesInput = {
  from: Scalars['Float']['input'];
  key: Scalars['String']['input'];
  to: Scalars['Float']['input'];
};

export type ProductSearch_RecommendedProductsResponseModel = {
  __typename?: 'ProductSearch_RecommendedProductsResponseModel';
  loadedDate: Scalars['DateTime']['output'];
  products: Array<ProductSearch_ProductModel>;
  total: Scalars['Int']['output'];
};

export type ProductSearch_RelatedProductsResponseModel = {
  __typename?: 'ProductSearch_RelatedProductsResponseModel';
  loadedDate: Scalars['DateTime']['output'];
  products: Array<ProductSearch_ProductModel>;
  total: Scalars['Int']['output'];
};

export type ProductSearch_RentalStationModel = {
  __typename?: 'ProductSearch_RentalStationModel';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  distance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type ProductSearch_SearchFilterEnum = {
  __typename?: 'ProductSearch_SearchFilterEnum';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type ProductSearch_SearchFilterItem = {
  __typename?: 'ProductSearch_SearchFilterItem';
  enums: Array<ProductSearch_SearchFilterEnum>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  range?: Maybe<ProductSearch_SearchFilterItemRange>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type ProductSearch_SearchFilterItemRange = {
  __typename?: 'ProductSearch_SearchFilterItemRange';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type ProductSearch_SearchFilterResponseModel = {
  __typename?: 'ProductSearch_SearchFilterResponseModel';
  manufacturers: Array<ProductSearch_SearchFilterEnum>;
  properties: Array<ProductSearch_SearchFilterItem>;
  tenants: Array<ProductSearch_SearchFilterEnum>;
};

export type ProductSearch_SearchSortInput = {
  by: Scalars['String']['input'];
};

export type ProductSearch_ServiceFee = {
  __typename?: 'ProductSearch_ServiceFee';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ProductSearch_ShippingOptions = {
  __typename?: 'ProductSearch_ShippingOptions';
  deliveryEnabled: Scalars['Boolean']['output'];
  pickupEnabled: Scalars['Boolean']['output'];
};

export enum ProductSearch_SortOption {
  DistanceAsc = 'DISTANCE_ASC',
  PositionAsc = 'POSITION_ASC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  ScoreAsc = 'SCORE_ASC'
}

export type ProductSearch_TenantModel = {
  __typename?: 'ProductSearch_TenantModel';
  key: Scalars['String']['output'];
  logo: ProductSearch_ImageModel;
  name: Scalars['String']['output'];
};

export type ProductSearch_TierPrice = {
  __typename?: 'ProductSearch_TierPrice';
  /** This price will be used if the rental period is more than or equal to minDays */
  minDays: Scalars['Int']['output'];
  /** Price in cents */
  price: Scalars['Int']['output'];
};

/** Describes the type or model of a product. */
export type ProductType = {
  __typename?: 'ProductType';
  accessoryOnly: Scalars['Boolean']['output'];
  configuratorPageUrl: Scalars['String']['output'];
  customization: ProductTypeCustomization;
  datoId: Scalars['String']['output'];
  firstPublicationDate: Scalars['Date']['output'];
  hasManagedStock: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** Images of the product type. */
  images: Array<ProductTypeImage>;
  importAsUriComponent?: Maybe<Scalars['String']['output']>;
  isTopSuggestion?: Maybe<Scalars['Boolean']['output']>;
  /** The main (or canonical) category. */
  mainCategory?: Maybe<Category>;
  /** The manufacturer of this product. */
  manufacturer?: Maybe<Manufacturer>;
  palletSpaces: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  productPageUrl: Scalars['String']['output'];
  /** @deprecated use productPageUrl or configuratorPageUrl */
  relativeUrl: Scalars['String']['output'];
  relativeUrls: Array<LocalizedString>;
  /** The product types of this type's accessories. */
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
};

export type ProductTypeCategoryFilter = {
  value: Scalars['String']['input'];
};

export type ProductTypeCustomization = {
  __typename?: 'ProductTypeCustomization';
  tenant?: Maybe<Tenant>;
};

export type ProductTypeImage = {
  __typename?: 'ProductTypeImage';
  alt: Scalars['String']['output'];
  metadata: ProductTypeImageMetaData;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProductTypeImageMetaData = {
  __typename?: 'ProductTypeImageMetaData';
  format: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type ProductTypeManufacturerFilter = {
  value: Array<Scalars['String']['input']>;
};

export type ProductTypesList = {
  __typename?: 'ProductTypesList';
  data: Array<ProductType>;
  total: Scalars['Int']['output'];
};

/** Sort Project list by */
export enum ProjectSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type Property = {
  __typename?: 'Property';
  descriptor: PropertyDescriptor;
  isEquipment: Scalars['Boolean']['output'];
  isFact: Scalars['Boolean']['output'];
  isVariant: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  value: Scalars['AnyScalar']['output'];
};

export type PropertyDescriptor = {
  __typename?: 'PropertyDescriptor';
  enums?: Maybe<Array<EnumPropertyValue>>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: PropertyType;
  unit?: Maybe<Scalars['String']['output']>;
};

export type PropertyDescriptorEnumModel = {
  __typename?: 'PropertyDescriptorEnumModel';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PropertyDescriptorModel = {
  __typename?: 'PropertyDescriptorModel';
  enums: Array<PropertyDescriptorEnumModel>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type PropertyDescriptorsList = {
  __typename?: 'PropertyDescriptorsList';
  data: Array<PropertyDescriptor>;
  total: Scalars['Int']['output'];
};

export type PropertyFilter = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type PropertyInput = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export enum PropertyType {
  Boolean = 'BOOLEAN',
  Enum = 'ENUM',
  Integer = 'INTEGER',
  Text = 'TEXT'
}

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  /** Check if user can book on project */
  BookingService_canBookOnProject: Scalars['Boolean']['output'];
  /** Get bookings by product id */
  BookingService_getActiveBookingsByProductId: BookingService_BookingsQuery;
  /** Get booking */
  BookingService_getBooking: BookingService_Booking;
  /** Get booking entities by tenant key */
  BookingService_getBookingEntitiesByTenantKey: Array<BookingService_BookingEntitySimplifiedQuery>;
  /** Get booking for admin */
  BookingService_getBookingForAdmin: BookingService_Booking;
  /** Get bookings */
  BookingService_getBookings: BookingService_BookingsQuery;
  /** Get bookings as csv */
  BookingService_getBookingsAsCSV: Scalars['String']['output'];
  /** Get bookings by ids */
  BookingService_getBookingsByBookingNumbers: Array<BookingService_Booking>;
  /** Get bookings for admin */
  BookingService_getBookingsForAdmin: BookingService_BookingsQuery;
  /** Get unique booking filter options */
  BookingService_getUniqueBookingFilterOptions: BookingService_BookingFilterOptionsQuery;
  /** Check if user is first time booker by given tenant key */
  BookingService_isFirstTimeBooker: Scalars['Boolean']['output'];
  CmsService_GetProductTypePages: CmsService_GetProductTypePagesResponse;
  CmsService_getLocationByUriComponent?: Maybe<CmsService_LocationModel>;
  CmsService_getLocations: Array<CmsService_LocationModel>;
  CmsService_getManufacturerByUriComponent?: Maybe<CmsService_ManufacturerModel>;
  CmsService_getManufacturers: Array<CmsService_ManufacturerModel>;
  CmsService_getNonWorkingDaysBlockByDatoId?: Maybe<CmsService_NonWorkingDaysBlockModel>;
  CmsService_getNonWorkingDaysBlocks?: Maybe<Array<CmsService_NonWorkingDaysBlockModel>>;
  CmsService_getProductTypeByDatoId?: Maybe<CmsService_ProductTypeModel>;
  CmsService_getProductTypeByHpkImportKey?: Maybe<CmsService_ProductTypeModel>;
  CmsService_getProductTypeByUriComponent?: Maybe<CmsService_ProductTypeModel>;
  CmsService_getProductTypes: Array<CmsService_ProductTypeModel>;
  CmsService_getProductTypesBySearchTerm: Array<CmsService_ProductTypeModel>;
  CmsService_getProductTypesByUriComponents: Array<CmsService_ProductTypeModel>;
  /** Returns the list of addresses of the given field type that match the given input. */
  Geolocation_addressAutocomplete: Array<AutocompleteModel>;
  /** Returns the geolocation and normalized address for the given address. First, it tries to get the geolocation from PTV. If it fails, it tries to get it from Google. */
  Geolocation_geolocation?: Maybe<GeolocationModel>;
  Geolocation_getLocationInformation?: Maybe<PlaceModel>;
  /** Get locations from ptv */
  Geolocation_getLocations: Geolocation_GetLocationsQuery;
  Geolocation_locationByPlace?: Maybe<PlaceModel>;
  Geolocation_locationByUriComponent?: Maybe<PlaceModel>;
  Geolocation_place?: Maybe<PlaceModel>;
  Geolocation_places: PlacesSuggestionModel;
  Geolocation_validateAddresses: PlacesSuggestionModel;
  KeycloakUserService_getUserByExternalId?: Maybe<KeycloakUser_GetKeycloakUserResponse>;
  KeycloakUserService_getUserById?: Maybe<KeycloakUser_GetKeycloakUserResponse>;
  KeycloakUserService_getUsers?: Maybe<KeycloakUser_GetKeycloakUsersResponse>;
  KeycloakUserService_isUserMigrated: Scalars['Boolean']['output'];
  KeycloakUserService_me?: Maybe<KeycloakUser_GetKeycloakUserResponse>;
  OrganizationService_AddressById?: Maybe<OrganizationService_Address>;
  OrganizationService_AddressIdsByProjectId?: Maybe<Array<OrganizationService_Address>>;
  OrganizationService_Addresses: OrganizationService_AddressesResponse;
  OrganizationService_AllProjects: OrganizationService_ProjectsResponse;
  OrganizationService_BusinessUnit?: Maybe<OrganizationService_BusinessUnit>;
  OrganizationService_BusinessUnitByName?: Maybe<OrganizationService_BusinessUnit>;
  OrganizationService_BusinessUnitByNameAndOrganizationId?: Maybe<OrganizationService_BusinessUnit>;
  OrganizationService_BusinessUnits: OrganizationService_BusinessUnitsResponse;
  OrganizationService_CheckVatId: OrganizationService_CheckVatIdResponse;
  OrganizationService_DefaultProjectAddress: OrganizationService_Address;
  OrganizationService_DefaultProjectByOrganizationId?: Maybe<OrganizationService_Project>;
  OrganizationService_MeAddressById?: Maybe<OrganizationService_Address>;
  OrganizationService_MeAddresses?: Maybe<Array<OrganizationService_Address>>;
  OrganizationService_MeOrganizationByAddressId?: Maybe<OrganizationService_Organization>;
  OrganizationService_MeProjects: OrganizationService_ProjectsResponse;
  /** Returns all members for the user identified by the access token. */
  OrganizationService_MembersForUserOrganization?: Maybe<OrganizationService_OrganizationMembersResponse>;
  OrganizationService_Organization: OrganizationService_Organization;
  OrganizationService_OrganizationByVatId?: Maybe<OrganizationService_Organization>;
  /** Returns the organization for the user identified by the access token. */
  OrganizationService_OrganizationForUser?: Maybe<OrganizationService_Organization>;
  OrganizationService_Organizations: OrganizationService_OrganizationsResponse;
  /** Returns all organizations which are connected with given project ids. */
  OrganizationService_OrganizationsByProjectIds?: Maybe<OrganizationService_OrganizationIdsResponse>;
  OrganizationService_OrganizationsForUser: OrganizationService_OrganizationsResponse;
  OrganizationService_Project?: Maybe<OrganizationService_Project>;
  OrganizationService_ProjectByAddressId?: Maybe<OrganizationService_Project>;
  OrganizationService_ProjectByExternalProjectNumber?: Maybe<OrganizationService_Project>;
  OrganizationService_Projects: OrganizationService_ProjectsResponse;
  OrganizationService_ProjectsByUserId: OrganizationService_ProjectsResponse;
  OrganizationService_SanitizeVatId: OrganizationService_SanitizedVatIdResponse;
  PriceService_productPrice?: Maybe<PriceService_ProductPriceModel>;
  ProductSearch_recommendedProducts?: Maybe<ProductSearch_RecommendedProductsResponseModel>;
  ProductSearch_relatedProducts?: Maybe<ProductSearch_RelatedProductsResponseModel>;
  ProductSearch_searchFilter?: Maybe<ProductSearch_SearchFilterResponseModel>;
  ProductSearch_searchProducts?: Maybe<ProductSearch_ProductSearchResponseModel>;
  /**
   * Check if a user has been migrated to the new keycloak instance
   * @deprecated This query will be removed in the future after most users have been migrated.
   */
  RegisterService_HasUserBeenMigrated: Scalars['Boolean']['output'];
  advancedCacheManagerRecord?: Maybe<AdvancedCacheManagerRecordEntityResponse>;
  advancedCacheManagerRecords?: Maybe<AdvancedCacheManagerRecordEntityResponseCollection>;
  authProcess?: Maybe<AuthProcessEntityResponse>;
  author?: Maybe<AuthorEntityResponse>;
  authors?: Maybe<AuthorEntityResponseCollection>;
  basketPage?: Maybe<BasketPageEntityResponse>;
  blogArticle?: Maybe<BlogArticleEntityResponse>;
  blogArticles?: Maybe<BlogArticleEntityResponseCollection>;
  blogCategories?: Maybe<BlogCategoryEntityResponseCollection>;
  blogCategory?: Maybe<BlogCategoryEntityResponse>;
  blogOverview?: Maybe<BlogOverviewEntityResponse>;
  cart?: Maybe<Cart>;
  /** Returns the results of a full-text search on product types and categories. */
  catalogSearch: Array<CatalogSearchResult>;
  /**
   * Allows queryig the categories. Currently it only allows to get
   * all categories.
   */
  categories: CategoriesList;
  /** This function will return one category when the text matches the title */
  categoryByText?: Maybe<Category>;
  /** Allows lookup by uri component. */
  categoryByUriComponent?: Maybe<Category>;
  configuratorPage?: Maybe<ConfiguratorPageEntityResponse>;
  contact?: Maybe<ContactEntityResponse>;
  contacts?: Maybe<ContactEntityResponseCollection>;
  contentReleasesRelease?: Maybe<ContentReleasesReleaseEntityResponse>;
  contentReleasesReleaseAction?: Maybe<ContentReleasesReleaseActionEntityResponse>;
  contentReleasesReleaseActions?: Maybe<ContentReleasesReleaseActionEntityResponseCollection>;
  contentReleasesReleases?: Maybe<ContentReleasesReleaseEntityResponseCollection>;
  /** A list of all countries known to Digando. */
  countries: CountriesResult;
  datoDocumentRelations: Urls;
  errorPage?: Maybe<ErrorPageEntityResponse>;
  faq?: Maybe<FaqEntityResponse>;
  faqs?: Maybe<FaqEntityResponseCollection>;
  getAllProductProperties: Array<CmsProductPropertyModel>;
  getCategoriesByUriComponents: Array<CmsCategoryModel>;
  getCategoryByUriComponent: CmsCategoryModel;
  getCountries: Array<CmsCountryModel>;
  getCountryByIso2: CmsCountryModel;
  getProductPropertiesByKeys: Array<CmsProductPropertyModel>;
  getProductPropertyByKey?: Maybe<CmsProductPropertyModel>;
  getRentalStationByIdentifier?: Maybe<CmsRentalStationModel>;
  getTenantByKey: CmsService_TenantModel;
  getTenants: Array<CmsService_TenantModel>;
  homepage?: Maybe<HomepageEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  internalLinkSelectorInternalLinkSelector?: Maybe<InternalLinkSelectorInternalLinkSelectorEntityResponse>;
  internalLinkSelectorInternalLinkSelectors?: Maybe<InternalLinkSelectorInternalLinkSelectorEntityResponseCollection>;
  job?: Maybe<JobEntityResponse>;
  jobOverview?: Maybe<JobOverviewEntityResponse>;
  jobs?: Maybe<JobEntityResponseCollection>;
  log?: Maybe<LogEntityResponse>;
  logs?: Maybe<LogEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  navigation?: Maybe<NavigationEntityResponse>;
  productBundle?: Maybe<ProductBundleResult>;
  productPage?: Maybe<ProductPageEntityResponse>;
  productPrice?: Maybe<ProductPriceData>;
  /** Returns the results of a global product search. */
  productSearch?: Maybe<ProductSearchResults>;
  /** Returns the results of a global product search. */
  productSearchFilter?: Maybe<ProductSearchFilterResults>;
  /**
   * Query to fetch all product types if no nanufacturer or category are given.
   * Otherwise only the products type of the specified manufacturer(s) or category
   * are returned.
   */
  productTypes: ProductTypesList;
  /**
   * Allows queryig the categories. Currently it only allows to get
   * all categories.
   */
  propertyDescriptors: PropertyDescriptorsList;
  recommendedProducts?: Maybe<RecommendedProductResults>;
  relatedProducts?: Maybe<RelatedProductResults>;
  rentalStation?: Maybe<RentalStation>;
  rentalStations?: Maybe<RentalStationsResponse>;
  savedPlaces: SavedAddresses;
  searchLocation?: Maybe<SearchLocationEntityResponse>;
  searchLocations?: Maybe<SearchLocationEntityResponseCollection>;
  searchPage?: Maybe<SearchPageEntityResponse>;
  searchPages?: Maybe<SearchPageEntityResponseCollection>;
  searchRentalStations: Array<CmsRentalStationModel>;
  serviceInfo: ServiceInfo;
  standardPage?: Maybe<StandardPageEntityResponse>;
  standardPages?: Maybe<StandardPageEntityResponseCollection>;
  tenant?: Maybe<Tenant>;
  tenantPage?: Maybe<TenantPageEntityResponse>;
  tenantPages?: Maybe<TenantPageEntityResponseCollection>;
  tenants: TenantsResult;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
};


export type QueryBookingService_CanBookOnProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryBookingService_GetActiveBookingsByProductIdArgs = {
  productId: Scalars['String']['input'];
};


export type QueryBookingService_GetBookingArgs = {
  bookingNumber: Scalars['String']['input'];
};


export type QueryBookingService_GetBookingEntitiesByTenantKeyArgs = {
  tenantKey: Scalars['String']['input'];
};


export type QueryBookingService_GetBookingForAdminArgs = {
  bookingNumber: Scalars['String']['input'];
};


export type QueryBookingService_GetBookingsArgs = {
  filter?: InputMaybe<BookingService_BookingsFilter>;
  pagination: BookingService_PaginationArgs;
};


export type QueryBookingService_GetBookingsAsCsvArgs = {
  filter: BookingService_BookingsFilter;
};


export type QueryBookingService_GetBookingsByBookingNumbersArgs = {
  bookingNumbers: Array<Scalars['String']['input']>;
};


export type QueryBookingService_GetBookingsForAdminArgs = {
  filter?: InputMaybe<BookingService_BookingsFilter>;
  pagination: BookingService_PaginationArgs;
};


export type QueryBookingService_IsFirstTimeBookerArgs = {
  tenantKey: Scalars['String']['input'];
};


export type QueryCmsService_GetLocationByUriComponentArgs = {
  uriComponent: Scalars['String']['input'];
};


export type QueryCmsService_GetManufacturerByUriComponentArgs = {
  uriComponent: Scalars['String']['input'];
};


export type QueryCmsService_GetNonWorkingDaysBlockByDatoIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCmsService_GetProductTypeByDatoIdArgs = {
  datoId: Scalars['String']['input'];
};


export type QueryCmsService_GetProductTypeByHpkImportKeyArgs = {
  hpkImportKey: Scalars['String']['input'];
};


export type QueryCmsService_GetProductTypeByUriComponentArgs = {
  uriComponent: Scalars['String']['input'];
};


export type QueryCmsService_GetProductTypesArgs = {
  page: Scalars['Float']['input'];
};


export type QueryCmsService_GetProductTypesBySearchTermArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QueryCmsService_GetProductTypesByUriComponentsArgs = {
  uriComponents: Array<Scalars['String']['input']>;
};


export type QueryGeolocation_AddressAutocompleteArgs = {
  field: AutocompleteFieldEnum;
  params: AutocompleteInput;
};


export type QueryGeolocation_GeolocationArgs = {
  params: GeolocationInput;
};


export type QueryGeolocation_GetLocationInformationArgs = {
  uriComponent: Scalars['String']['input'];
};


export type QueryGeolocation_GetLocationsArgs = {
  params: GetLocationsInput;
};


export type QueryGeolocation_LocationByPlaceArgs = {
  id: Scalars['String']['input'];
};


export type QueryGeolocation_LocationByUriComponentArgs = {
  uriComponent: Scalars['String']['input'];
};


export type QueryGeolocation_PlaceArgs = {
  params: PlaceInput;
};


export type QueryGeolocation_PlacesArgs = {
  params: PlacesInput;
};


export type QueryGeolocation_ValidateAddressesArgs = {
  params: PlacesInput;
};


export type QueryKeycloakUserService_GetUserByExternalIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryKeycloakUserService_GetUserByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryKeycloakUserService_GetUsersArgs = {
  filter?: InputMaybe<KeycloakUserService_FilterUsersArgs>;
  pagination: PaginationArgs;
};


export type QueryKeycloakUserService_IsUserMigratedArgs = {
  accessToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type QueryOrganizationService_AddressByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationService_AddressIdsByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryOrganizationService_AddressesArgs = {
  filter?: InputMaybe<OrganizationService_FilterAddressArgs>;
  pagination: PaginationArgs;
  sort: OrganizationService_SortAddressArgs;
};


export type QueryOrganizationService_BusinessUnitArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationService_BusinessUnitByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryOrganizationService_BusinessUnitByNameAndOrganizationIdArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationService_BusinessUnitsArgs = {
  filter?: InputMaybe<OrganizationService_FilterBusinessUnitArgs>;
  pagination: PaginationArgs;
  sort: OrganizationService_SortBusinessUnitArgs;
};


export type QueryOrganizationService_CheckVatIdArgs = {
  vatId: Scalars['String']['input'];
};


export type QueryOrganizationService_DefaultProjectAddressArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryOrganizationService_DefaultProjectByOrganizationIdArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationService_MeAddressByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationService_MeAddressesArgs = {
  sort?: InputMaybe<OrganizationService_SortAddressArgs>;
};


export type QueryOrganizationService_MeOrganizationByAddressIdArgs = {
  addressId: Scalars['String']['input'];
};


export type QueryOrganizationService_MeProjectsArgs = {
  filter?: InputMaybe<OrganizationService_FilterProjectArgs>;
  pagination: PaginationArgs;
  sort: OrganizationService_SortProjectArgs;
};


export type QueryOrganizationService_OrganizationArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationService_OrganizationByVatIdArgs = {
  vatId: Scalars['String']['input'];
};


export type QueryOrganizationService_OrganizationsArgs = {
  filter?: InputMaybe<OrganizationService_FilterOrganizationArgs>;
  pagination: PaginationArgs;
  sort: OrganizationService_SortOrganizationArgs;
};


export type QueryOrganizationService_OrganizationsByProjectIdsArgs = {
  projectIds: Array<Scalars['String']['input']>;
};


export type QueryOrganizationService_OrganizationsForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryOrganizationService_ProjectArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationService_ProjectByAddressIdArgs = {
  addressId: Scalars['String']['input'];
};


export type QueryOrganizationService_ProjectByExternalProjectNumberArgs = {
  externalProjectNumber: Scalars['String']['input'];
};


export type QueryOrganizationService_ProjectsArgs = {
  filter?: InputMaybe<OrganizationService_FilterProjectArgs>;
  pagination: PaginationArgs;
  sort: OrganizationService_SortProjectArgs;
};


export type QueryOrganizationService_ProjectsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryOrganizationService_SanitizeVatIdArgs = {
  vatId: Scalars['String']['input'];
};


export type QueryPriceService_ProductPriceArgs = {
  dateRange: PriceService_DateRangeInput;
  productId: Scalars['ID']['input'];
};


export type QueryProductSearch_RecommendedProductsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  productTypeUriComponents: Array<Scalars['String']['input']>;
  tenantKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProductSearch_RelatedProductsArgs = {
  categoryUriComponent: Scalars['String']['input'];
  dateRange?: InputMaybe<ProductSearch_DateRangeInput>;
  geoPoint?: InputMaybe<ProductSearch_GeoPointInput>;
};


export type QueryProductSearch_SearchFilterArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateRange: ProductSearch_DateRangeInput;
  enumProperties: Array<ProductSearch_EnumPropertiesInput>;
  geoPoint?: InputMaybe<ProductSearch_GeoPointInput>;
  manufacturers: Array<Scalars['String']['input']>;
  pagination: ProductSearch_PaginationInput;
  rangeProperties: Array<ProductSearch_RangePropertiesInput>;
  refresh?: Scalars['Boolean']['input'];
  searchSort?: InputMaybe<ProductSearch_SearchSortInput>;
  tenantKeys: Array<Scalars['String']['input']>;
  testingMode?: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  uriComponent: Scalars['String']['input'];
};


export type QueryProductSearch_SearchProductsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateRange: ProductSearch_DateRangeInput;
  enumProperties: Array<ProductSearch_EnumPropertiesInput>;
  geoPoint?: InputMaybe<ProductSearch_GeoPointInput>;
  manufacturers: Array<Scalars['String']['input']>;
  pagination: ProductSearch_PaginationInput;
  rangeProperties: Array<ProductSearch_RangePropertiesInput>;
  refresh?: Scalars['Boolean']['input'];
  searchSort?: InputMaybe<ProductSearch_SearchSortInput>;
  tenantKeys: Array<Scalars['String']['input']>;
  testingMode?: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  uriComponent: Scalars['String']['input'];
};


export type QueryRegisterService_HasUserBeenMigratedArgs = {
  email: Scalars['String']['input'];
};


export type QueryAdvancedCacheManagerRecordArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdvancedCacheManagerRecordsArgs = {
  filters?: InputMaybe<AdvancedCacheManagerRecordFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAuthProcessArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryAuthorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryAuthorsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBasketPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryBlogArticleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryBlogArticlesArgs = {
  filters?: InputMaybe<BlogArticleFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBlogCategoriesArgs = {
  filters?: InputMaybe<BlogCategoryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBlogCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryBlogOverviewArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryCatalogSearchArgs = {
  tenantKey?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QueryCategoriesArgs = {
  params?: InputMaybe<CategoryQueryParams>;
};


export type QueryCategoryByTextArgs = {
  text: Scalars['String']['input'];
};


export type QueryCategoryByUriComponentArgs = {
  uriComponent: Scalars['String']['input'];
};


export type QueryContactArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactsArgs = {
  filters?: InputMaybe<ContactFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryContentReleasesReleaseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContentReleasesReleaseActionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContentReleasesReleaseActionsArgs = {
  filters?: InputMaybe<ContentReleasesReleaseActionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryContentReleasesReleasesArgs = {
  filters?: InputMaybe<ContentReleasesReleaseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDatoDocumentRelationsArgs = {
  input: DatoDocumentRelationsInput;
};


export type QueryErrorPageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFaqArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFaqsArgs = {
  filters?: InputMaybe<FaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCategoriesByUriComponentsArgs = {
  uriComponents: Array<Scalars['String']['input']>;
};


export type QueryGetCategoryByUriComponentArgs = {
  uriComponent: Scalars['String']['input'];
};


export type QueryGetCountryByIso2Args = {
  iso2: Scalars['String']['input'];
};


export type QueryGetProductPropertiesByKeysArgs = {
  keys: Array<Scalars['String']['input']>;
};


export type QueryGetProductPropertyByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetRentalStationByIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryGetTenantByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryHomepageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInternalLinkSelectorInternalLinkSelectorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInternalLinkSelectorInternalLinkSelectorsArgs = {
  filters?: InputMaybe<InternalLinkSelectorInternalLinkSelectorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryJobOverviewArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryJobsArgs = {
  filters?: InputMaybe<JobFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLogArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLogsArgs = {
  filters?: InputMaybe<LogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNavigationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryProductBundleArgs = {
  input: ProductBundleInput;
};


export type QueryProductPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryProductPriceArgs = {
  input: ProductPriceInput;
};


export type QueryProductSearchArgs = {
  params?: InputMaybe<ProductSearchParams>;
  searchSort?: InputMaybe<ProductSearchSort>;
};


export type QueryProductSearchFilterArgs = {
  params?: InputMaybe<ProductSearchFilterParams>;
};


export type QueryPropertyDescriptorsArgs = {
  params?: InputMaybe<CategoryQueryParams>;
};


export type QueryRecommendedProductsArgs = {
  params?: InputMaybe<RecommendedProductParams>;
};


export type QueryRelatedProductsArgs = {
  params?: InputMaybe<RelatedProductsParams>;
};


export type QueryRentalStationArgs = {
  id: Scalars['String']['input'];
};


export type QueryRentalStationsArgs = {
  params?: InputMaybe<RentalStationsParams>;
};


export type QuerySearchLocationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySearchLocationsArgs = {
  filters?: InputMaybe<SearchLocationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySearchPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QuerySearchPagesArgs = {
  filters?: InputMaybe<SearchPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySearchRentalStationsArgs = {
  location?: InputMaybe<CmsService_Location>;
  tenantKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStandardPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryStandardPagesArgs = {
  filters?: InputMaybe<StandardPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTenantArgs = {
  key: Scalars['String']['input'];
};


export type QueryTenantPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryTenantPagesArgs = {
  filters?: InputMaybe<TenantPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RecommendedProductParams = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  productTypeUriComponents?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RecommendedProductResults = {
  __typename?: 'RecommendedProductResults';
  categories: Array<Category>;
  products: Array<ProductSearchItem>;
  total: Scalars['Int']['output'];
};

/** Gender of the user */
export enum RegisterService_Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type RegisterService_RegisterOrganization = {
  address: RegisterService_RegisterOrganizationAddress;
  name: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
};

export type RegisterService_RegisterOrganizationAddress = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type RegisterService_RegisterResponse = {
  __typename?: 'RegisterService_RegisterResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RegisterService_RegisterUser = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: RegisterService_Gender;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type RegisterService_ResetPasswordResponse = {
  __typename?: 'RegisterService_ResetPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type RegisterService_UpdatePasswordResponse = {
  __typename?: 'RegisterService_UpdatePasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type RelatedProductResults = {
  __typename?: 'RelatedProductResults';
  products: Array<ProductSearchItem>;
  total: Scalars['Int']['output'];
};

export type RelatedProductTypes = {
  __typename?: 'RelatedProductTypes';
  id: Scalars['String']['output'];
  uriComponent: Scalars['String']['output'];
};

export type RelatedProductsPaginationParams = {
  size: Scalars['Int']['input'];
};

export type RelatedProductsParams = {
  dateRange: ProductSearchDateRange;
  location?: InputMaybe<LocationInput>;
  pagination?: InputMaybe<RelatedProductsPaginationParams>;
  uriComponent: Scalars['String']['input'];
};

export type RemoveCartItemInput = {
  itemId: Scalars['String']['input'];
};

export type RentInformation = {
  __typename?: 'RentInformation';
  additionHours?: Maybe<Scalars['Int']['output']>;
  earliestStartDate?: Maybe<Scalars['String']['output']>;
};

export enum RentalPeriodModeEnum {
  PlatformRentalPeriodCalendarDays = 'PLATFORM_RENTAL_PERIOD_CALENDAR_DAYS',
  PlatformRentalPeriodWorkingDays = 'PLATFORM_RENTAL_PERIOD_WORKING_DAYS'
}

export type RentalStation = {
  __typename?: 'RentalStation';
  city: Scalars['String']['output'];
  country: Country;
  deliveryCosts: Array<DeliveryCost>;
  hasDelivery: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  location: Location;
  minimumRentalPeriodDays?: Maybe<Scalars['Int']['output']>;
  minimumRentalPeriodEndDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nonWorkingDays: Array<Scalars['String']['output']>;
  openingHours: Scalars['String']['output'];
  shippingOptions: RentalStationShippingOptions;
  shortName: Scalars['String']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  tenant: Tenant;
  zip: Scalars['String']['output'];
};

export type RentalStationAddress = {
  __typename?: 'RentalStationAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type RentalStationContact = {
  __typename?: 'RentalStationContact';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type RentalStationDeliveryCost = {
  __typename?: 'RentalStationDeliveryCost';
  maxDistance: Scalars['Float']['output'];
  minPalletSpaces: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
};

export type RentalStationDistance = {
  __typename?: 'RentalStationDistance';
  distance: Scalars['Int']['output'];
  id: Scalars['String']['output'];
};

export type RentalStationService = {
  __typename?: 'RentalStationService';
  name: Scalars['String']['output'];
  option: Scalars['String']['output'];
};

export type RentalStationShippingOptions = {
  __typename?: 'RentalStationShippingOptions';
  deliveryEnabled: Scalars['Boolean']['output'];
  pickupEnabled: Scalars['Boolean']['output'];
};

export type RentalStationSourceReference = {
  __typename?: 'RentalStationSourceReference';
  id: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type RentalStationsParams = {
  location?: InputMaybe<LocationInput>;
  tenantKey?: InputMaybe<Scalars['String']['input']>;
};

export type RentalStationsResponse = {
  __typename?: 'RentalStationsResponse';
  data?: Maybe<Array<RentalStation>>;
  total: Scalars['Int']['output'];
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type SavedAddress = {
  __typename?: 'SavedAddress';
  city?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type SavedAddresses = {
  __typename?: 'SavedAddresses';
  data: Array<SavedAddress>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchLocation = {
  __typename?: 'SearchLocation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SearchLocationEntity = {
  __typename?: 'SearchLocationEntity';
  attributes?: Maybe<SearchLocation>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SearchLocationEntityResponse = {
  __typename?: 'SearchLocationEntityResponse';
  data?: Maybe<SearchLocationEntity>;
};

export type SearchLocationEntityResponseCollection = {
  __typename?: 'SearchLocationEntityResponseCollection';
  data: Array<SearchLocationEntity>;
  meta: ResponseCollectionMeta;
};

export type SearchLocationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SearchLocationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SearchLocationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SearchLocationFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SearchLocationInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPage = {
  __typename?: 'SearchPage';
  contentBottom?: Maybe<Array<Maybe<SearchPageContentBottomDynamicZone>>>;
  contentTop?: Maybe<Array<Maybe<SearchPageContentTopDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  headerImage?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SearchPageRelationResponseCollection>;
  prismicId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  searchLocation?: Maybe<SearchLocationEntityResponse>;
  seo: ComponentHelperSeo;
  slug?: Maybe<Scalars['String']['output']>;
  slugSelector?: Maybe<ComponentHelperDigandoCategorySelector>;
  snippet: ComponentHelperSnippet;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SearchPageLocalizationsArgs = {
  filters?: InputMaybe<SearchPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SearchPageContentBottomDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentQuoteBlock | ComponentContentSearchBox | ComponentContentTextWithBlock | ComponentContentTextWithImage | Error;

export type SearchPageContentTopDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type SearchPageEntity = {
  __typename?: 'SearchPageEntity';
  attributes?: Maybe<SearchPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SearchPageEntityResponse = {
  __typename?: 'SearchPageEntityResponse';
  data?: Maybe<SearchPageEntity>;
};

export type SearchPageEntityResponseCollection = {
  __typename?: 'SearchPageEntityResponseCollection';
  data: Array<SearchPageEntity>;
  meta: ResponseCollectionMeta;
};

export type SearchPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SearchPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SearchPageFiltersInput>;
  not?: InputMaybe<SearchPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SearchPageFiltersInput>>>;
  prismicId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  searchLocation?: InputMaybe<SearchLocationFiltersInput>;
  seo?: InputMaybe<ComponentHelperSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  slugSelector?: InputMaybe<ComponentHelperDigandoCategorySelectorFiltersInput>;
  snippet?: InputMaybe<ComponentHelperSnippetFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SearchPageInput = {
  contentBottom?: InputMaybe<Array<Scalars['SearchPageContentBottomDynamicZoneInput']['input']>>;
  contentTop?: InputMaybe<Array<Scalars['SearchPageContentTopDynamicZoneInput']['input']>>;
  headerImage?: InputMaybe<Scalars['ID']['input']>;
  prismicId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  searchLocation?: InputMaybe<Scalars['ID']['input']>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugSelector?: InputMaybe<ComponentHelperDigandoCategorySelectorInput>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPageRelationResponseCollection = {
  __typename?: 'SearchPageRelationResponseCollection';
  data: Array<SearchPageEntity>;
};

export type SelectedProduct = {
  __typename?: 'SelectedProduct';
  currentStock?: Maybe<Scalars['Int']['output']>;
  hasHiddenPrices: Scalars['Boolean']['output'];
  includedAccessoriesAmount: Scalars['Int']['output'];
  productImages?: Maybe<Array<ProductTypeImage>>;
  showPrices: Scalars['Boolean']['output'];
};

export type ServiceFee = {
  __typename?: 'ServiceFee';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ServiceInfo = {
  __typename?: 'ServiceInfo';
  /** The service's name. */
  name: Scalars['String']['output'];
  /** The version of the service. */
  version: Scalars['String']['output'];
};

export type Shipping = ShippingDelivery | ShippingPickup;

export type ShippingDelivery = {
  __typename?: 'ShippingDelivery';
  costs: Scalars['Int']['output'];
  destination: DeliveryDestination;
  rentalStation: RentalStation;
};

export enum ShippingOption {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export enum ShippingOptionEnum {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type ShippingOptions = {
  __typename?: 'ShippingOptions';
  deliveryEnabled: Scalars['Boolean']['output'];
  pickupEnabled: Scalars['Boolean']['output'];
};

export type ShippingPickup = {
  __typename?: 'ShippingPickup';
  rentalStation: RentalStation;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceReference = {
  __typename?: 'SourceReference';
  id: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type StandardPage = {
  __typename?: 'StandardPage';
  content?: Maybe<Array<Maybe<StandardPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header: ComponentHeaderImageHeader;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StandardPageRelationResponseCollection>;
  prismicId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentHelperSeo>;
  slug: Scalars['String']['output'];
  snippet?: Maybe<ComponentHelperSnippet>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type StandardPageLocalizationsArgs = {
  filters?: InputMaybe<StandardPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StandardPageContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type StandardPageEntity = {
  __typename?: 'StandardPageEntity';
  attributes?: Maybe<StandardPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StandardPageEntityResponse = {
  __typename?: 'StandardPageEntityResponse';
  data?: Maybe<StandardPageEntity>;
};

export type StandardPageEntityResponseCollection = {
  __typename?: 'StandardPageEntityResponseCollection';
  data: Array<StandardPageEntity>;
  meta: ResponseCollectionMeta;
};

export type StandardPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StandardPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  header?: InputMaybe<ComponentHeaderImageHeaderFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<StandardPageFiltersInput>;
  not?: InputMaybe<StandardPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StandardPageFiltersInput>>>;
  prismicId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentHelperSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  snippet?: InputMaybe<ComponentHelperSnippetFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type StandardPageInput = {
  content?: InputMaybe<Array<Scalars['StandardPageContentDynamicZoneInput']['input']>>;
  header?: InputMaybe<ComponentHeaderImageHeaderInput>;
  prismicId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StandardPageRelationResponseCollection = {
  __typename?: 'StandardPageRelationResponseCollection';
  data: Array<StandardPageEntity>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionResponse = {
  __typename?: 'SubscriptionResponse';
  email: Scalars['String']['output'];
};

export enum SuggestionType {
  Address = 'ADDRESS',
  Regions = 'REGIONS'
}

export type Tenant = {
  __typename?: 'Tenant';
  digandoUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  logo: TenantLogo;
  name: Scalars['String']['output'];
  tenantInsuranceMode: Scalars['String']['output'];
};

export type TenantLogo = {
  __typename?: 'TenantLogo';
  alt: Scalars['String']['output'];
  metadata: TenantLogoMetaData;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TenantLogoMetaData = {
  __typename?: 'TenantLogoMetaData';
  format: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type TenantPage = {
  __typename?: 'TenantPage';
  content?: Maybe<Array<Maybe<TenantPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header: ComponentHeaderTenantHeader;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<TenantPageRelationResponseCollection>;
  prismicId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  searchBox: ComponentContentSearchBox;
  seo: ComponentHelperSeo;
  slug: Scalars['String']['output'];
  snippet: ComponentHelperSnippet;
  tenantKey: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TenantPageLocalizationsArgs = {
  filters?: InputMaybe<TenantPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TenantPageContentDynamicZone = ComponentContentActionButton | ComponentContentCallToAction | ComponentContentCategoryOverview | ComponentContentContactSection | ComponentContentFaq | ComponentContentHubspotForm | ComponentContentImagePresentation | ComponentContentInternalLinks | ComponentContentNewsletterSubscription | ComponentContentOnBoarding | ComponentContentPrivacySettings | ComponentContentQuoteBlock | ComponentContentRecommendedCategories | ComponentContentRentalStations | ComponentContentSearchBox | ComponentContentTenantLogos | ComponentContentTestimonials | ComponentContentTextWithBlock | ComponentContentTextWithImage | ComponentContentTextWithLink | ComponentContentUspCards | ComponentContentUspDigando | ComponentContentUspProduct | ComponentContentYoutubeVideo | Error;

export type TenantPageEntity = {
  __typename?: 'TenantPageEntity';
  attributes?: Maybe<TenantPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TenantPageEntityResponse = {
  __typename?: 'TenantPageEntityResponse';
  data?: Maybe<TenantPageEntity>;
};

export type TenantPageEntityResponseCollection = {
  __typename?: 'TenantPageEntityResponseCollection';
  data: Array<TenantPageEntity>;
  meta: ResponseCollectionMeta;
};

export type TenantPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TenantPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  header?: InputMaybe<ComponentHeaderTenantHeaderFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<TenantPageFiltersInput>;
  not?: InputMaybe<TenantPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TenantPageFiltersInput>>>;
  prismicId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  searchBox?: InputMaybe<ComponentContentSearchBoxFiltersInput>;
  seo?: InputMaybe<ComponentHelperSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  snippet?: InputMaybe<ComponentHelperSnippetFiltersInput>;
  tenantKey?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TenantPageInput = {
  content?: InputMaybe<Array<Scalars['TenantPageContentDynamicZoneInput']['input']>>;
  header?: InputMaybe<ComponentHeaderTenantHeaderInput>;
  prismicId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  searchBox?: InputMaybe<ComponentContentSearchBoxInput>;
  seo?: InputMaybe<ComponentHelperSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snippet?: InputMaybe<ComponentHelperSnippetInput>;
  tenantKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TenantPageRelationResponseCollection = {
  __typename?: 'TenantPageRelationResponseCollection';
  data: Array<TenantPageEntity>;
};

export type TenantsResult = {
  __typename?: 'TenantsResult';
  data?: Maybe<Array<Tenant>>;
  total: Scalars['Int']['output'];
};

export type TypedPrice = {
  __typename?: 'TypedPrice';
  amount: Scalars['Int']['output'];
  type: PriceType;
};

export type UpdateBookingInput = {
  bookingId: Scalars['String']['input'];
  dateRange: DateRangeInput;
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  mode: UpdateBookingMode;
};

export enum UpdateBookingMode {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  Preview = 'PREVIEW'
}

export type UpdateBookingResponse = {
  __typename?: 'UpdateBookingResponse';
  id: Scalars['String']['output'];
  price: UpdateBookingResponsePrice;
};

export type UpdateBookingResponsePrice = {
  __typename?: 'UpdateBookingResponsePrice';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  focalPoint?: InputMaybe<JsonFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  focalPoint?: InputMaybe<Scalars['JSON']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type Urls = {
  __typename?: 'Urls';
  urls: Array<Scalars['String']['output']>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type BlogOverviewArticleFragment = { __typename?: 'BlogArticleEntity', id?: string | null, attributes?: { __typename?: 'BlogArticle', title: string, teaser?: string | null, slug: string, publishedAt?: any | null, blogCategory?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string } | null } | null } | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null };

export type RentalStationsItemFragment = { __typename?: 'RentalStation', id: string, name: string, shortName: string, zip: string, city: string, street: string, streetNumber: string, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, location: { __typename?: 'Location', lat: number, lng: number }, tenant: { __typename?: 'Tenant', name: string, key: string, id: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', alt: string, url: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', format: string, height: number, width: number } } } };

export type RentalStationTenantItemFragment = { __typename?: 'Tenant', name: string, key: string, id: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', alt: string, url: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', format: string, height: number, width: number } } };

export type SeoComponentFragment = { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null };

export type SnippetComponentFragment = { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null };

export type StrapiImageFragment = { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null };

export type ZoneTextWithImageFragment = { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null };

export type ZoneActionButtonFragment = { __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype };

export type ZoneCategoryOverviewFragment = { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null };

export type ZoneCallToActionFragment = { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null };

export type ZoneContentFaqFragment = { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null };

export type ZoneContentQuoteBlockFragment = { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null };

export type ZoneContentNewsletterSubscriptionFragment = { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null };

export type ZoneContentContactSectionFragment = { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null };

export type ZoneContentRecommendedCategoriesFragment = { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> };

export type ZoneContentHubspotFormFragment = { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null };

export type ZoneContentImagePresentationFragment = { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> };

export type ZoneContentPrivacySettingsFragment = { __typename?: 'ComponentContentPrivacySettings', id: string };

export type ZoneContentTenantLogosFragment = { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null };

export type ZoneContentTestimonialsFragment = { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null };

export type ZoneContentTextWithImageFragment = { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null };

export type ZoneContentUspCardsFragment = { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null };

export type ZoneContentUspDigandoFragment = { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null };

export type ZoneContentYoutubeVideoFragment = { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null };

export type ZoneContentSearchBoxFragment = { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null };

export type ZoneContentOnBoardingFragment = { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null };

export type ZoneContentTextWithLinkFragment = { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null };

export type ZoneContentUspProductFragment = { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null };

export type ZoneContentRentalStationsFragment = { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null };

export type InternalLinkPageTypeFragment = { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null };

export type CtaLinkPageTypeFragment = { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null };

export type ZoneContentInternalLinksFragment = { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null };

export type HelperDigandoCategorySelectorFragment = { __typename?: 'ComponentHelperDigandoCategorySelector', id: string, slug?: string | null };

export type ZonePopularCategoriesFragment = { __typename?: 'ComponentContentPopularCategories', id: string, title?: string | null, categories?: Array<{ __typename?: 'ComponentHelperDigandoCategorySelector', id: string, slug?: string | null } | null> | null };

export type AllZones_AdvancedCacheManagerRecord_Fragment = { __typename?: 'AdvancedCacheManagerRecord' };

export type AllZones_AuthProcess_Fragment = { __typename?: 'AuthProcess' };

export type AllZones_Author_Fragment = { __typename?: 'Author' };

export type AllZones_BasketPage_Fragment = { __typename?: 'BasketPage' };

export type AllZones_BlogArticle_Fragment = { __typename?: 'BlogArticle' };

export type AllZones_BlogCategory_Fragment = { __typename?: 'BlogCategory' };

export type AllZones_BlogOverview_Fragment = { __typename?: 'BlogOverview' };

export type AllZones_ComponentContentActionButton_Fragment = { __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype };

export type AllZones_ComponentContentCallToAction_Fragment = { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null };

export type AllZones_ComponentContentCategoryOverview_Fragment = { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null };

export type AllZones_ComponentContentContactSection_Fragment = { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null };

export type AllZones_ComponentContentFaq_Fragment = { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null };

export type AllZones_ComponentContentHubspotForm_Fragment = { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null };

export type AllZones_ComponentContentImagePresentation_Fragment = { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> };

export type AllZones_ComponentContentInternalLinks_Fragment = { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null };

export type AllZones_ComponentContentNavigationLinkWrapper_Fragment = { __typename?: 'ComponentContentNavigationLinkWrapper' };

export type AllZones_ComponentContentNewsletterSubscription_Fragment = { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null };

export type AllZones_ComponentContentOnBoarding_Fragment = { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null };

export type AllZones_ComponentContentPopularCategories_Fragment = { __typename?: 'ComponentContentPopularCategories' };

export type AllZones_ComponentContentPrivacySettings_Fragment = { __typename?: 'ComponentContentPrivacySettings', id: string };

export type AllZones_ComponentContentQuoteBlock_Fragment = { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null };

export type AllZones_ComponentContentRecommendedCategories_Fragment = { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> };

export type AllZones_ComponentContentRentalStations_Fragment = { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null };

export type AllZones_ComponentContentSearchBox_Fragment = { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null };

export type AllZones_ComponentContentSlugSelector_Fragment = { __typename?: 'ComponentContentSlugSelector' };

export type AllZones_ComponentContentTenantLogos_Fragment = { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null };

export type AllZones_ComponentContentTestimonials_Fragment = { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null };

export type AllZones_ComponentContentTextWithBlock_Fragment = { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null };

export type AllZones_ComponentContentTextWithImage_Fragment = { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null };

export type AllZones_ComponentContentTextWithLink_Fragment = { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null };

export type AllZones_ComponentContentUspCards_Fragment = { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null };

export type AllZones_ComponentContentUspDigando_Fragment = { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null };

export type AllZones_ComponentContentUspProduct_Fragment = { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null };

export type AllZones_ComponentContentYoutubeVideo_Fragment = { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null };

export type AllZones_ComponentHeaderHeader_Fragment = { __typename?: 'ComponentHeaderHeader' };

export type AllZones_ComponentHeaderHomepageHeader_Fragment = { __typename?: 'ComponentHeaderHomepageHeader' };

export type AllZones_ComponentHeaderImageHeader_Fragment = { __typename?: 'ComponentHeaderImageHeader' };

export type AllZones_ComponentHeaderTenantHeader_Fragment = { __typename?: 'ComponentHeaderTenantHeader' };

export type AllZones_ComponentHelperBenefits_Fragment = { __typename?: 'ComponentHelperBenefits' };

export type AllZones_ComponentHelperCallToAction_Fragment = { __typename?: 'ComponentHelperCallToAction' };

export type AllZones_ComponentHelperDigandoCategorySelector_Fragment = { __typename?: 'ComponentHelperDigandoCategorySelector' };

export type AllZones_ComponentHelperFactBox_Fragment = { __typename?: 'ComponentHelperFactBox' };

export type AllZones_ComponentHelperImagePresentation_Fragment = { __typename?: 'ComponentHelperImagePresentation' };

export type AllZones_ComponentHelperInternalLink_Fragment = { __typename?: 'ComponentHelperInternalLink' };

export type AllZones_ComponentHelperLabelValue_Fragment = { __typename?: 'ComponentHelperLabelValue' };

export type AllZones_ComponentHelperNavigationLink_Fragment = { __typename?: 'ComponentHelperNavigationLink' };

export type AllZones_ComponentHelperOnBoarding_Fragment = { __typename?: 'ComponentHelperOnBoarding' };

export type AllZones_ComponentHelperProducts_Fragment = { __typename?: 'ComponentHelperProducts' };

export type AllZones_ComponentHelperProductsList_Fragment = { __typename?: 'ComponentHelperProductsList' };

export type AllZones_ComponentHelperRecommendedCategory_Fragment = { __typename?: 'ComponentHelperRecommendedCategory' };

export type AllZones_ComponentHelperSeo_Fragment = { __typename?: 'ComponentHelperSeo' };

export type AllZones_ComponentHelperSnippet_Fragment = { __typename?: 'ComponentHelperSnippet' };

export type AllZones_ComponentHelperTenantLogo_Fragment = { __typename?: 'ComponentHelperTenantLogo' };

export type AllZones_ComponentHelperTest_Fragment = { __typename?: 'ComponentHelperTest' };

export type AllZones_ComponentHelperTestimonial_Fragment = { __typename?: 'ComponentHelperTestimonial' };

export type AllZones_ComponentHelperUspCard_Fragment = { __typename?: 'ComponentHelperUspCard' };

export type AllZones_ComponentHelperUspDigandoItem_Fragment = { __typename?: 'ComponentHelperUspDigandoItem' };

export type AllZones_ConfiguratorPage_Fragment = { __typename?: 'ConfiguratorPage' };

export type AllZones_Contact_Fragment = { __typename?: 'Contact' };

export type AllZones_ContentReleasesRelease_Fragment = { __typename?: 'ContentReleasesRelease' };

export type AllZones_ContentReleasesReleaseAction_Fragment = { __typename?: 'ContentReleasesReleaseAction' };

export type AllZones_ErrorPage_Fragment = { __typename?: 'ErrorPage' };

export type AllZones_Faq_Fragment = { __typename?: 'Faq' };

export type AllZones_Homepage_Fragment = { __typename?: 'Homepage' };

export type AllZones_I18NLocale_Fragment = { __typename?: 'I18NLocale' };

export type AllZones_InternalLinkSelectorInternalLinkSelector_Fragment = { __typename?: 'InternalLinkSelectorInternalLinkSelector' };

export type AllZones_Job_Fragment = { __typename?: 'Job' };

export type AllZones_JobOverview_Fragment = { __typename?: 'JobOverview' };

export type AllZones_Log_Fragment = { __typename?: 'Log' };

export type AllZones_Navigation_Fragment = { __typename?: 'Navigation' };

export type AllZones_ProductPage_Fragment = { __typename?: 'ProductPage' };

export type AllZones_SearchLocation_Fragment = { __typename?: 'SearchLocation' };

export type AllZones_SearchPage_Fragment = { __typename?: 'SearchPage' };

export type AllZones_StandardPage_Fragment = { __typename?: 'StandardPage' };

export type AllZones_TenantPage_Fragment = { __typename?: 'TenantPage' };

export type AllZones_UploadFile_Fragment = { __typename?: 'UploadFile' };

export type AllZones_UploadFolder_Fragment = { __typename?: 'UploadFolder' };

export type AllZones_UsersPermissionsRole_Fragment = { __typename?: 'UsersPermissionsRole' };

export type AllZones_UsersPermissionsUser_Fragment = { __typename?: 'UsersPermissionsUser' };

export type AllZonesFragment = AllZones_AdvancedCacheManagerRecord_Fragment | AllZones_AuthProcess_Fragment | AllZones_Author_Fragment | AllZones_BasketPage_Fragment | AllZones_BlogArticle_Fragment | AllZones_BlogCategory_Fragment | AllZones_BlogOverview_Fragment | AllZones_ComponentContentActionButton_Fragment | AllZones_ComponentContentCallToAction_Fragment | AllZones_ComponentContentCategoryOverview_Fragment | AllZones_ComponentContentContactSection_Fragment | AllZones_ComponentContentFaq_Fragment | AllZones_ComponentContentHubspotForm_Fragment | AllZones_ComponentContentImagePresentation_Fragment | AllZones_ComponentContentInternalLinks_Fragment | AllZones_ComponentContentNavigationLinkWrapper_Fragment | AllZones_ComponentContentNewsletterSubscription_Fragment | AllZones_ComponentContentOnBoarding_Fragment | AllZones_ComponentContentPopularCategories_Fragment | AllZones_ComponentContentPrivacySettings_Fragment | AllZones_ComponentContentQuoteBlock_Fragment | AllZones_ComponentContentRecommendedCategories_Fragment | AllZones_ComponentContentRentalStations_Fragment | AllZones_ComponentContentSearchBox_Fragment | AllZones_ComponentContentSlugSelector_Fragment | AllZones_ComponentContentTenantLogos_Fragment | AllZones_ComponentContentTestimonials_Fragment | AllZones_ComponentContentTextWithBlock_Fragment | AllZones_ComponentContentTextWithImage_Fragment | AllZones_ComponentContentTextWithLink_Fragment | AllZones_ComponentContentUspCards_Fragment | AllZones_ComponentContentUspDigando_Fragment | AllZones_ComponentContentUspProduct_Fragment | AllZones_ComponentContentYoutubeVideo_Fragment | AllZones_ComponentHeaderHeader_Fragment | AllZones_ComponentHeaderHomepageHeader_Fragment | AllZones_ComponentHeaderImageHeader_Fragment | AllZones_ComponentHeaderTenantHeader_Fragment | AllZones_ComponentHelperBenefits_Fragment | AllZones_ComponentHelperCallToAction_Fragment | AllZones_ComponentHelperDigandoCategorySelector_Fragment | AllZones_ComponentHelperFactBox_Fragment | AllZones_ComponentHelperImagePresentation_Fragment | AllZones_ComponentHelperInternalLink_Fragment | AllZones_ComponentHelperLabelValue_Fragment | AllZones_ComponentHelperNavigationLink_Fragment | AllZones_ComponentHelperOnBoarding_Fragment | AllZones_ComponentHelperProducts_Fragment | AllZones_ComponentHelperProductsList_Fragment | AllZones_ComponentHelperRecommendedCategory_Fragment | AllZones_ComponentHelperSeo_Fragment | AllZones_ComponentHelperSnippet_Fragment | AllZones_ComponentHelperTenantLogo_Fragment | AllZones_ComponentHelperTest_Fragment | AllZones_ComponentHelperTestimonial_Fragment | AllZones_ComponentHelperUspCard_Fragment | AllZones_ComponentHelperUspDigandoItem_Fragment | AllZones_ConfiguratorPage_Fragment | AllZones_Contact_Fragment | AllZones_ContentReleasesRelease_Fragment | AllZones_ContentReleasesReleaseAction_Fragment | AllZones_ErrorPage_Fragment | AllZones_Faq_Fragment | AllZones_Homepage_Fragment | AllZones_I18NLocale_Fragment | AllZones_InternalLinkSelectorInternalLinkSelector_Fragment | AllZones_Job_Fragment | AllZones_JobOverview_Fragment | AllZones_Log_Fragment | AllZones_Navigation_Fragment | AllZones_ProductPage_Fragment | AllZones_SearchLocation_Fragment | AllZones_SearchPage_Fragment | AllZones_StandardPage_Fragment | AllZones_TenantPage_Fragment | AllZones_UploadFile_Fragment | AllZones_UploadFolder_Fragment | AllZones_UsersPermissionsRole_Fragment | AllZones_UsersPermissionsUser_Fragment;

export type BasketPageResponseFragment = { __typename?: 'BasketPageEntity', attributes?: { __typename?: 'BasketPage', title: string, createdAt?: any | null, updatedAt?: any | null, seo: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null } | null };

export type BasketPageQueryVariables = Exact<{ [key: string]: never; }>;


export type BasketPageQuery = { __typename?: 'Query', basketPage?: { __typename?: 'BasketPageEntityResponse', data?: { __typename?: 'BasketPageEntity', attributes?: { __typename?: 'BasketPage', title: string, createdAt?: any | null, updatedAt?: any | null, seo: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, cart?: { __typename?: 'Cart', id: string, discount: number, totalPrice: number, finalPrice: number, insurance: number, rentalTax: number, isActive: boolean, deposit: number, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, items: Array<{ __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }>, actions: { __typename?: 'CartActions', canBeBooked: boolean } } | null };

export type BlogCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogCategoriesQuery = { __typename?: 'Query', blogCategories?: { __typename?: 'BlogCategoryEntityResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string } | null }> } | null };

export type BlogOverviewHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogOverviewHeaderQuery = { __typename?: 'Query', headerPost?: { __typename?: 'BlogArticleEntityResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', id?: string | null, attributes?: { __typename?: 'BlogArticle', title: string, teaser?: string | null, slug: string, publishedAt?: any | null, blogCategory?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string } | null } | null } | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', pageCount: number } } } | null };

export type BlogOverviewNewPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogOverviewNewPostsQuery = { __typename?: 'Query', brandNewPosts?: { __typename?: 'BlogArticleEntityResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', id?: string | null, attributes?: { __typename?: 'BlogArticle', title: string, teaser?: string | null, slug: string, publishedAt?: any | null, blogCategory?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string } | null } | null } | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', pageCount: number } } } | null };

export type BlogOverviewQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']['input']>;
  postsPerPage?: InputMaybe<Scalars['Int']['input']>;
  blogCategoryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BlogOverviewQuery = { __typename?: 'Query', headerPost?: { __typename?: 'BlogArticleEntityResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', id?: string | null, attributes?: { __typename?: 'BlogArticle', title: string, teaser?: string | null, slug: string, publishedAt?: any | null, blogCategory?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string } | null } | null } | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', pageCount: number } } } | null, brandNewPosts?: { __typename?: 'BlogArticleEntityResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', id?: string | null, attributes?: { __typename?: 'BlogArticle', title: string, teaser?: string | null, slug: string, publishedAt?: any | null, blogCategory?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string } | null } | null } | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', pageCount: number } } } | null, posts?: { __typename?: 'BlogArticleEntityResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', id?: string | null, attributes?: { __typename?: 'BlogArticle', title: string, teaser?: string | null, slug: string, publishedAt?: any | null, blogCategory?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string } | null } | null } | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', pageCount: number } } } | null, blogCategories?: { __typename?: 'BlogCategoryEntityResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string } | null }> } | null, blogOverview?: { __typename?: 'BlogOverviewEntityResponse', data?: { __typename?: 'BlogOverviewEntity', attributes?: { __typename?: 'BlogOverview', createdAt?: any | null, updatedAt?: any | null, title: string, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null } | null } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type BlogArticleResponseFragment = { __typename?: 'BlogArticleEntity', attributes?: { __typename?: 'BlogArticle', locale?: string | null, title: string, slug: string, publishedAt?: any | null, articleCreatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, teaser?: string | null, localizations?: { __typename?: 'BlogArticleRelationResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', attributes?: { __typename?: 'BlogArticle', locale?: string | null, slug: string } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', name: string, jobTitle: string, description: string, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null } | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } } | null };

export type BlogPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState: PublicationState;
}>;


export type BlogPageQuery = { __typename?: 'Query', blogArticles?: { __typename?: 'BlogArticleEntityResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', attributes?: { __typename?: 'BlogArticle', locale?: string | null, title: string, slug: string, publishedAt?: any | null, articleCreatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, teaser?: string | null, localizations?: { __typename?: 'BlogArticleRelationResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', attributes?: { __typename?: 'BlogArticle', locale?: string | null, slug: string } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', name: string, jobTitle: string, description: string, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null } | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } } | null }> } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type ConfiguratorPageResponseFragment = { __typename?: 'ConfiguratorPageEntity', attributes?: { __typename?: 'ConfiguratorPage', createdAt?: any | null, updatedAt?: any | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null };

export type ConfiguratorPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfiguratorPageQuery = { __typename?: 'Query', configuratorPage?: { __typename?: 'ConfiguratorPageEntityResponse', data?: { __typename?: 'ConfiguratorPageEntity', attributes?: { __typename?: 'ConfiguratorPage', createdAt?: any | null, updatedAt?: any | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null };

export type ErrorPageResponseFragment = { __typename?: 'ErrorPageEntity', attributes?: { __typename?: 'ErrorPage', publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, popularCategories?: { __typename?: 'ComponentContentPopularCategories', id: string, title?: string | null, categories?: Array<{ __typename?: 'ComponentHelperDigandoCategorySelector', id: string, slug?: string | null } | null> | null } | null } | null };

export type ErrorPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ErrorPageQuery = { __typename?: 'Query', errorPage?: { __typename?: 'ErrorPageEntityResponse', data?: { __typename?: 'ErrorPageEntity', attributes?: { __typename?: 'ErrorPage', publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, popularCategories?: { __typename?: 'ComponentContentPopularCategories', id: string, title?: string | null, categories?: Array<{ __typename?: 'ComponentHelperDigandoCategorySelector', id: string, slug?: string | null } | null> | null } | null } | null } | null } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type HomepageResponseFragment = { __typename?: 'HomepageEntity', attributes?: { __typename?: 'Homepage', locale?: string | null, createdAt?: any | null, updatedAt?: any | null, title: string, localizations?: { __typename?: 'HomepageRelationResponseCollection', data: Array<{ __typename?: 'HomepageEntity', attributes?: { __typename?: 'Homepage', locale?: string | null } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header?: Array<{ __typename?: 'ComponentHeaderHomepageHeader', maxBrowserWidth: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> | null, popularCategories?: { __typename?: 'ComponentContentPopularCategories', id: string, title?: string | null, categories?: Array<{ __typename?: 'ComponentHelperDigandoCategorySelector', id: string, slug?: string | null } | null> | null } | null } | null };

export type HomepageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomepageQuery = { __typename?: 'Query', homepage?: { __typename?: 'HomepageEntityResponse', data?: { __typename?: 'HomepageEntity', attributes?: { __typename?: 'Homepage', locale?: string | null, createdAt?: any | null, updatedAt?: any | null, title: string, localizations?: { __typename?: 'HomepageRelationResponseCollection', data: Array<{ __typename?: 'HomepageEntity', attributes?: { __typename?: 'Homepage', locale?: string | null } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header?: Array<{ __typename?: 'ComponentHeaderHomepageHeader', maxBrowserWidth: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> | null, popularCategories?: { __typename?: 'ComponentContentPopularCategories', id: string, title?: string | null, categories?: Array<{ __typename?: 'ComponentHelperDigandoCategorySelector', id: string, slug?: string | null } | null> | null } | null } | null } | null } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type JobOverviewResponseFragment = { __typename?: 'JobOverview', locale?: string | null, title: string, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'JobOverviewRelationResponseCollection', data: Array<{ __typename?: 'JobOverviewEntity', attributes?: { __typename?: 'JobOverview', locale?: string | null } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header?: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null };

export type GetJobOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobOverviewQuery = { __typename?: 'Query', jobOverview?: { __typename?: 'JobOverviewEntityResponse', data?: { __typename?: 'JobOverviewEntity', attributes?: { __typename?: 'JobOverview', locale?: string | null, title: string, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'JobOverviewRelationResponseCollection', data: Array<{ __typename?: 'JobOverviewEntity', attributes?: { __typename?: 'JobOverview', locale?: string | null } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header?: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null } | null } | null } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type JobResponseFragment = { __typename?: 'JobEntity', attributes?: { __typename?: 'Job', locale?: string | null, title: string, slug: string, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'JobRelationResponseCollection', data: Array<{ __typename?: 'JobEntity', attributes?: { __typename?: 'Job', locale?: string | null, slug: string } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } } | null };

export type JobQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState: PublicationState;
}>;


export type JobQuery = { __typename?: 'Query', jobs?: { __typename?: 'JobEntityResponseCollection', data: Array<{ __typename?: 'JobEntity', attributes?: { __typename?: 'Job', locale?: string | null, title: string, slug: string, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'JobRelationResponseCollection', data: Array<{ __typename?: 'JobEntity', attributes?: { __typename?: 'Job', locale?: string | null, slug: string } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } } | null }> } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type GetLoginPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoginPageQuery = { __typename?: 'Query', authProcess?: { __typename?: 'AuthProcessEntityResponse', data?: { __typename?: 'AuthProcessEntity', attributes?: { __typename?: 'AuthProcess', emailVerifiedMessage?: string | null, signInIntroText?: string | null, signUpSuccessMessage?: string | null, loginPageTitle?: string | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNavigationLinkWrapper' } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPopularCategories' } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentSlugSelector' } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null };

export type NavigationLinkFragment = { __typename?: 'ComponentHelperNavigationLink', id: string, text?: string | null, navigationLinkPage?: { __typename?: 'NavigationLinkEntityType', text?: string | null, slug?: string | null, contentType?: string | null } | null };

export type GetNavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNavigationQuery = { __typename?: 'Query', navigation?: { __typename?: 'NavigationEntityResponse', data?: { __typename?: 'NavigationEntity', id?: string | null, attributes?: { __typename?: 'Navigation', header?: Array<{ __typename?: 'ComponentContentNavigationLinkWrapper', id: string, text?: string | null, navigationLinks?: Array<{ __typename?: 'ComponentHelperNavigationLink', id: string, text?: string | null, navigationLinkPage?: { __typename?: 'NavigationLinkEntityType', text?: string | null, slug?: string | null, contentType?: string | null } | null } | null> | null } | null> | null, footerLeft?: Array<{ __typename?: 'ComponentHelperNavigationLink', id: string, text?: string | null, navigationLinkPage?: { __typename?: 'NavigationLinkEntityType', text?: string | null, slug?: string | null, contentType?: string | null } | null } | null> | null, footerRight?: Array<{ __typename?: 'ComponentHelperNavigationLink', id: string, text?: string | null, navigationLinkPage?: { __typename?: 'NavigationLinkEntityType', text?: string | null, slug?: string | null, contentType?: string | null } | null } | null> | null } | null } | null } | null };

export type ProductPageResponseFragment = { __typename?: 'ProductPageEntity', attributes?: { __typename?: 'ProductPage', locale?: string | null, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'ProductPageRelationResponseCollection', data: Array<{ __typename?: 'ProductPageEntity', attributes?: { __typename?: 'ProductPage', locale?: string | null } | null }> } | null, benefits?: Array<{ __typename?: 'ComponentHelperBenefits', benefit?: string | null } | null> | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null };

export type ProductPageQueryVariables = Exact<{
  location?: InputMaybe<LocationInput>;
  input: ProductBundleInput;
  productPriceInput: ProductPriceInput;
}>;


export type ProductPageQuery = { __typename?: 'Query', productPage?: { __typename?: 'ProductPageEntityResponse', data?: { __typename?: 'ProductPageEntity', attributes?: { __typename?: 'ProductPage', locale?: string | null, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'ProductPageRelationResponseCollection', data: Array<{ __typename?: 'ProductPageEntity', attributes?: { __typename?: 'ProductPage', locale?: string | null } | null }> } | null, benefits?: Array<{ __typename?: 'ComponentHelperBenefits', benefit?: string | null } | null> | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null, productBundle?: { __typename?: 'ProductBundleResult', bundle?: { __typename?: 'ProductBundle', availableProducts: number, type: { __typename?: 'ProductType', id: string, title: string, text: string, productPageUrl: string, configuratorPageUrl: string, importAsUriComponent?: string | null, firstPublicationDate: any, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, uriComponent: string, relativeUrl: string, title: string, searchTitle: string, parent?: { __typename?: 'Category', title: string, relativeUrl: string } | null } | null, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> }, selectedProduct?: { __typename?: 'SelectedProduct', hasHiddenPrices: boolean, showPrices: boolean, productImages?: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> | null } | null, properties: Array<{ __typename?: 'ProductBundleProperty', key: string, values?: any | null, isFact: boolean, isVariant: boolean, isEquipment: boolean, isRolloverProperty: boolean, descriptor: { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null } }>, priceInformation?: { __typename?: 'ProductBundlePriceInformation', productPricePerDay: { __typename?: 'TypedPrice', amount: number }, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }> } | null, prices: Array<{ __typename?: 'GraduatedPrice', minDays: number, price: number }>, availableRentalStations: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, country: { __typename?: 'Country', iso2: string, name?: string | null } }>, selectedRentalStation?: { __typename?: 'RentalStation', minimumRentalPeriodDays?: number | null, id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lat: number, lng: number, distance?: number | null }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } | null } | null } | null, productPrice?: { __typename?: 'ProductPriceData', productPrice?: { __typename?: 'ProductPrice', workingDays: number, product: { __typename?: 'Price', amountPerDay: number, amountPerDayReduced: number, amount: number }, total: { __typename?: 'Price', amountPerDay: number, amount: number }, final: { __typename?: 'Price', amount: number, amountPerDay: number }, discount?: { __typename?: 'Price', amount: number } | null, discounts?: Array<{ __typename?: 'Discount', amount: number, discount: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, percent?: { __typename?: 'DiscountValueData', value: number } | null, amount?: { __typename?: 'DiscountValueData', value: number } | null } } }> | null } | null, productPriceError?: { __typename?: 'ProductPriceError', code: string, target: string } | null } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type SearchPageResponseFragment = { __typename?: 'SearchPageEntity', attributes?: { __typename?: 'SearchPage', locale?: string | null, title: string, slug?: string | null, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'SearchPageRelationResponseCollection', data: Array<{ __typename?: 'SearchPageEntity', attributes?: { __typename?: 'SearchPage', locale?: string | null, slug?: string | null } | null }> } | null, slugSelector?: { __typename?: 'ComponentHelperDigandoCategorySelector', slug?: string | null } | null, searchLocation?: { __typename?: 'SearchLocationEntityResponse', data?: { __typename?: 'SearchLocationEntity', attributes?: { __typename?: 'SearchLocation', title?: string | null, slug?: string | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, seo: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, contentTop?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, contentBottom?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'Error' } | null> | null } | null };

export type SearchPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  publicationState: PublicationState;
}>;


export type SearchPageQuery = { __typename?: 'Query', searchPages?: { __typename?: 'SearchPageEntityResponseCollection', data: Array<{ __typename?: 'SearchPageEntity', attributes?: { __typename?: 'SearchPage', locale?: string | null, title: string, slug?: string | null, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'SearchPageRelationResponseCollection', data: Array<{ __typename?: 'SearchPageEntity', attributes?: { __typename?: 'SearchPage', locale?: string | null, slug?: string | null } | null }> } | null, slugSelector?: { __typename?: 'ComponentHelperDigandoCategorySelector', slug?: string | null } | null, searchLocation?: { __typename?: 'SearchLocationEntityResponse', data?: { __typename?: 'SearchLocationEntity', attributes?: { __typename?: 'SearchLocation', title?: string | null, slug?: string | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, seo: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, contentTop?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, contentBottom?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'Error' } | null> | null } | null }> } | null };

export type BlogArticleSitemapResponseFragment = { __typename?: 'BlogArticleEntityResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', attributes?: { __typename?: 'BlogArticle', slug: string, seo?: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } };

export type JobSitemapResponseFragment = { __typename?: 'JobEntityResponseCollection', data: Array<{ __typename?: 'JobEntity', attributes?: { __typename?: 'Job', slug: string, seo?: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } };

export type SearchSitemapResponseFragment = { __typename?: 'SearchPageEntityResponseCollection', data: Array<{ __typename?: 'SearchPageEntity', attributes?: { __typename?: 'SearchPage', slug?: string | null, seo: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } };

export type StandartSitemapResponseFragment = { __typename?: 'StandardPageEntityResponseCollection', data: Array<{ __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string, seo?: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } };

export type TenantSitemapResponseFragment = { __typename?: 'TenantPageEntityResponseCollection', data: Array<{ __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, seo: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } };

export type SitemapPageQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitemapPageQuery = { __typename?: 'Query', blogArticles?: { __typename?: 'BlogArticleEntityResponseCollection', data: Array<{ __typename?: 'BlogArticleEntity', attributes?: { __typename?: 'BlogArticle', slug: string, seo?: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } } | null, jobs?: { __typename?: 'JobEntityResponseCollection', data: Array<{ __typename?: 'JobEntity', attributes?: { __typename?: 'Job', slug: string, seo?: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } } | null, searchPages?: { __typename?: 'SearchPageEntityResponseCollection', data: Array<{ __typename?: 'SearchPageEntity', attributes?: { __typename?: 'SearchPage', slug?: string | null, seo: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } } | null, standardPages?: { __typename?: 'StandardPageEntityResponseCollection', data: Array<{ __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string, seo?: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } } | null, tenantPages?: { __typename?: 'TenantPageEntityResponseCollection', data: Array<{ __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, seo: { __typename?: 'ComponentHelperSeo', hideFromSidebarAndIndex?: boolean | null } } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } } } | null };

export type StandardPageResponseFragment = { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', locale?: string | null, title: string, slug: string, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'StandardPageRelationResponseCollection', data: Array<{ __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', locale?: string | null, slug: string } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } } | null };

export type StandardPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState: PublicationState;
}>;


export type StandardPageQuery = { __typename?: 'Query', standardPages?: { __typename?: 'StandardPageEntityResponseCollection', data: Array<{ __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', locale?: string | null, title: string, slug: string, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, localizations?: { __typename?: 'StandardPageRelationResponseCollection', data: Array<{ __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', locale?: string | null, slug: string } | null }> } | null, seo?: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, snippet?: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header: { __typename?: 'ComponentHeaderImageHeader', image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } } | null }> } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type TenantMapPageQueryVariables = Exact<{
  tenantKey: Scalars['String']['input'];
  params?: InputMaybe<RentalStationsParams>;
}>;


export type TenantMapPageQuery = { __typename?: 'Query', tenant?: { __typename?: 'Tenant', id: string, key: string, name: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } | null, rentalStations?: { __typename?: 'RentalStationsResponse', data?: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, zip: string, city: string, street: string, streetNumber: string, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, location: { __typename?: 'Location', lat: number, lng: number }, tenant: { __typename?: 'Tenant', name: string, key: string, id: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', alt: string, url: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', format: string, height: number, width: number } } } }> | null } | null };

export type TenantPageResponseFragment = { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', locale?: string | null, title: string, slug: string, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, tenantKey: string, localizations?: { __typename?: 'TenantPageRelationResponseCollection', data: Array<{ __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', locale?: string | null, slug: string } | null }> } | null, seo: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header: { __typename?: 'ComponentHeaderTenantHeader', title?: string | null, subtitle?: string | null, description?: string | null, facts: Array<{ __typename?: 'ComponentHelperLabelValue', key: string, value: string } | null>, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, searchBox: { __typename?: 'ComponentContentSearchBox', title?: string | null, tenantKey?: string | null } } | null };

export type TenantPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState: PublicationState;
}>;


export type TenantPageQuery = { __typename?: 'Query', tenantPages?: { __typename?: 'TenantPageEntityResponseCollection', data: Array<{ __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', locale?: string | null, title: string, slug: string, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, tenantKey: string, localizations?: { __typename?: 'TenantPageRelationResponseCollection', data: Array<{ __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', locale?: string | null, slug: string } | null }> } | null, seo: { __typename?: 'ComponentHelperSeo', title?: string | null, description?: string | null, hideFromSidebarAndIndex?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, snippet: { __typename?: 'ComponentHelperSnippet', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, content?: Array<{ __typename?: 'ComponentContentActionButton', id: string, buttonText?: string | null, actionType: Enum_Componentcontentactionbutton_Actiontype } | { __typename?: 'ComponentContentCallToAction', id: string, heading?: any | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentCategoryOverview', id: string, heading?: any | null, description?: string | null } | { __typename?: 'ComponentContentContactSection', id: string, heading?: any | null, contacts?: { __typename?: 'ContactRelationResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', position: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null }> } | null } | { __typename?: 'ComponentContentFaq', id: string, heading?: any | null, faqs?: { __typename?: 'FaqRelationResponseCollection', data: Array<{ __typename?: 'FaqEntity', id?: string | null, attributes?: { __typename?: 'Faq', answer?: string | null, question: string } | null }> } | null } | { __typename?: 'ComponentContentHubspotForm', id: string, hubspotFormId?: string | null, hubspotPortalId?: string | null, heading?: any | null } | { __typename?: 'ComponentContentImagePresentation', id: string, images: Array<{ __typename?: 'ComponentHelperImagePresentation', id: string, title?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } } | null> } | { __typename?: 'ComponentContentInternalLinks', id: string, heading?: any | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentNewsletterSubscription', id: string, description?: string | null, heading?: any | null } | { __typename?: 'ComponentContentOnBoarding', id: string, items?: Array<{ __typename?: 'ComponentHelperOnBoarding', id: string, title?: string | null, description?: string | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null, internalLinks?: Array<{ __typename?: 'ComponentHelperInternalLink', internalLinkPage?: { __typename?: 'InternalLinkEntityType', title?: string | null, description?: string | null, slug?: string | null, readMoreLinkText?: string | null, readMoreLinkTitle?: string | null, contentType?: string | null, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'ComponentContentPrivacySettings', id: string } | { __typename?: 'ComponentContentQuoteBlock', id: string, author?: string | null, quote?: string | null } | { __typename?: 'ComponentContentRecommendedCategories', id: string, tenantKey?: string | null, recommendedCategoryTitle?: string | null, categories: Array<{ __typename?: 'ComponentHelperRecommendedCategory', id: string, title?: string | null, products: Array<{ __typename?: 'ComponentHelperProducts', id: string, uriComponent: string } | null> } | null> } | { __typename?: 'ComponentContentRentalStations', id: string, tenantKey?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentContentSearchBox', id: string, title?: string | null, tenantKey?: string | null } | { __typename?: 'ComponentContentTenantLogos', id: string, heading?: any | null, tenants?: Array<{ __typename?: 'ComponentHelperTenantLogo', id: string, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, tenant?: { __typename?: 'TenantPageEntityResponse', data?: { __typename?: 'TenantPageEntity', attributes?: { __typename?: 'TenantPage', slug: string, title: string } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentTestimonials', id: string, heading?: any | null, testimonials?: Array<{ __typename?: 'ComponentHelperTestimonial', authorCompany?: string | null, authorName?: string | null, authorRole?: string | null, text?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithBlock', id: string, heading?: any | null, text?: string | null, factBox?: Array<{ __typename?: 'ComponentHelperFactBox', description?: string | null, title?: string | null } | null> | null } | { __typename?: 'ComponentContentTextWithImage', id: string, transparentBackground?: boolean | null, heading?: any | null, description?: string | null, imagePosition?: Enum_Componentcontenttextwithimage_Imageposition | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null, cta?: { __typename?: 'ComponentHelperCallToAction', title?: string | null, text?: string | null, ctaLinkPage?: { __typename?: 'CTALinkEntityType', title?: string | null, text?: string | null, slug?: string | null, contentType?: string | null } | null } | null } | { __typename?: 'ComponentContentTextWithLink', id: string, heading?: any | null, description?: string | null, linkText?: string | null, page?: { __typename?: 'StandardPageEntityResponse', data?: { __typename?: 'StandardPageEntity', attributes?: { __typename?: 'StandardPage', slug: string } | null } | null } | null } | { __typename?: 'ComponentContentUspCards', id: string, heading?: any | null, usps?: Array<{ __typename?: 'ComponentHelperUspCard', title?: string | null, description?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentContentUspDigando', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentUspProduct', id: string, usps?: Array<{ __typename?: 'ComponentHelperUspDigandoItem', id: string, advantage?: string | null } | null> | null } | { __typename?: 'ComponentContentYoutubeVideo', id: string, youtubeLink?: string | null } | { __typename?: 'Error' } | null> | null, header: { __typename?: 'ComponentHeaderTenantHeader', title?: string | null, subtitle?: string | null, description?: string | null, facts: Array<{ __typename?: 'ComponentHelperLabelValue', key: string, value: string } | null>, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, width?: number | null, height?: number | null, ext?: string | null, formats?: any | null } | null } | null } | null }, searchBox: { __typename?: 'ComponentContentSearchBox', title?: string | null, tenantKey?: string | null } } | null }> } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type SearchPageByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SearchPageByIdQuery = { __typename?: 'Query', searchPage?: { __typename?: 'SearchPageEntityResponse', data?: { __typename?: 'SearchPageEntity', id?: string | null, attributes?: { __typename?: 'SearchPage', searchLocation?: { __typename?: 'SearchLocationEntityResponse', data?: { __typename?: 'SearchLocationEntity', id?: string | null, attributes?: { __typename?: 'SearchLocation', slug?: string | null } | null } | null } | null, slugSelector?: { __typename?: 'ComponentHelperDigandoCategorySelector', id: string, slug?: string | null } | null } | null } | null } | null };

export type AddressFragment = { __typename?: 'OrganizationService_Address', id: string, name: string, street: string, streetNumber: string, zipCode: string, city: string, countryCode: string, createdAt: any };

export type BookingServiceBookingDetailFragment = { __typename?: 'BookingService_Booking', id: string, state: BookingStatusEnum, created: string, deliveryTime?: string | null, note?: string | null, dateRange: { __typename?: 'BookingService_DateRange', start: string, end: string }, price: { __typename?: 'BookingService_Price', amount: number, currency: string }, product: { __typename?: 'BookingService_Product', effectiveNonWorkingDays: Array<string>, minimumRentalPeriodDays: number, minimumRentalPeriodEndDate: string }, productType: { __typename?: 'BookingService_ProductType', id: string, title: string, hasManagedStock: boolean, configuratorPageUrl: string, manufacturer: { __typename?: 'BookingService_Manufacturer', title: string, id: string } }, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, tenant: { __typename?: 'BookingService_Tenant', name: string, key: string, logo: { __typename?: 'BookingService_TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'BookingService_TenantLogoMetaData', width: number, height: number, format: string } } }, project: { __typename?: 'BookingService_Project', id: string, name: string, externalProjectId?: string | null }, renter: { __typename?: 'BookingService_Renter', firstName: string, lastName: string }, actions: { __typename?: 'BookingService_Actions', readOnly: boolean, canBeCanceled: boolean, canBeEnd: boolean, canBeUpdated: { __typename?: 'BookingService_Actions_CanBeUpdated', possible: boolean, startDate: boolean, endDate: boolean } }, billingAddress: { __typename?: 'BookingService_Address', name: string, streetNumber: string, street: string, zipCode: string, city: string, countryCode: string }, priceSnapshot: { __typename?: 'BookingService_BookingPriceSnapshot', productAmount: number, workingDays: number, final: { __typename?: 'BookingService_BookingPrice', amount: number }, insurance: { __typename?: 'BookingService_BookingPrice', amount: number }, discount: { __typename?: 'BookingService_BookingPrice', amount: number }, tax: { __typename?: 'BookingService_BookingPrice', amount: number }, accessoriesPrice: { __typename?: 'BookingService_BookingPrice', amount: number }, shipping: { __typename?: 'BookingService_BookingPrice', amount: number }, serviceFees: Array<{ __typename?: 'BookingService_BookingServiceFee', key: string, value: number }> }, coupons: Array<{ __typename?: 'BookingService_BookingCoupon', code: string, discount: { __typename?: 'BookingService_BookingCouponDiscount', amount: number, percent: number, type: DiscountTypeEnum } }>, accessories: Array<{ __typename?: 'BookingService_BookingAccessory', title: string, identifier: string, quantity: number, totalPrice: number }>, productProperties: Array<{ __typename?: 'BookingService_BookingProductProperty', key: string, isVariant: boolean, value: { __typename?: 'BookingService_BookingProductPropertyValue', value: string, title: string }, descriptor: { __typename?: 'BookingService_BookingProductPropertyDescriptor', title: string } }>, shipping: { __typename?: 'BookingService_BookingShippingDelivery', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, destination: { __typename?: 'BookingService_BookingShippingDestination', id: string, address: { __typename?: 'BookingService_Address', name: string, street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } | { __typename?: 'BookingService_BookingShippingPickup', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } };

export type CartDetailsFragment = { __typename?: 'Cart', id: string, discount: number, totalPrice: number, finalPrice: number, insurance: number, rentalTax: number, isActive: boolean, deposit: number, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, items: Array<{ __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }>, actions: { __typename?: 'CartActions', canBeBooked: boolean } };

export type CartItemFragment = { __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } };

export type DeliveryDestinationFragment = { __typename?: 'DeliveryDestination', id: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string };

export type BasketItemPropertyFragment = { __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } };

export type CouponFragment = { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } };

export type CategoriesResponseFragment = { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> };

export type CategoryFragment = { __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null };

export type CategoryTreeFragment = { __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null };

export type MeDetailsFragment = { __typename?: 'KeycloakUser_GetKeycloakUserResponse', id: string, lastName: string, firstName: string, email: string, phone: string, gender: KeycloadUser_Gender };

export type OrganizationResponseFragment = { __typename?: 'OrganizationService_Organization', id: string, name: string, street: string, streetNumber: string, city: string, zipCode: string, countryCode: string, createdAt: any };

export type ProductBundleAccessoriesFragment = { __typename?: 'ProductAccessory', title?: string | null, isPreselected?: boolean | null, forcePayment?: boolean | null, priceType: string, wearPartPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', id?: string | null } | null, images?: Array<{ __typename?: 'ProductAccessoryImage', url: string, alt?: string | null, title?: string | null, id: string } | null> | null, tierPrices?: Array<{ __typename?: 'GraduatedPrice', price: number }> | null };

export type ProductBundleDetailFragment = { __typename?: 'ProductBundle', availableProducts: number, type: { __typename?: 'ProductType', id: string, title: string, text: string, productPageUrl: string, configuratorPageUrl: string, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, relativeUrl: string, title: string, parent?: { __typename?: 'Category', title: string, relativeUrl: string } | null } | null, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> }, properties: Array<{ __typename?: 'ProductBundleProperty', key: string, values?: any | null, isFact: boolean, isVariant: boolean, isEquipment: boolean, isRolloverProperty: boolean, descriptor: { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null } }>, priceInformation?: { __typename?: 'ProductBundlePriceInformation', productPricePerDay: { __typename?: 'TypedPrice', amount: number } } | null, prices: Array<{ __typename?: 'GraduatedPrice', minDays: number, price: number }> };

export type ProductBundleRelatedProductsFragment = { __typename?: 'ProductBundle', type: { __typename?: 'ProductType', id: string, title: string, uriComponent: string, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> }, priceInformation?: { __typename?: 'ProductBundlePriceInformation', productPricePerDay: { __typename?: 'TypedPrice', type: PriceType, amount: number }, productPriceReducedPerDay: { __typename?: 'TypedPrice', type: PriceType, amount: number } } | null };

export type ProductBundleFragment = { __typename?: 'ProductBundle', type: { __typename?: 'ProductType', id: string, title: string, productPageUrl: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, uriComponent: string, relativeUrl: string, title: string, parent?: { __typename?: 'Category', title: string, relativeUrl: string } | null } | null, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> }, prices: Array<{ __typename?: 'GraduatedPrice', minDays: number, price: number }>, properties: Array<{ __typename?: 'ProductBundleProperty', key: string, values?: any | null, isFact: boolean, isVariant: boolean, isEquipment: boolean, isRolloverProperty: boolean, descriptor: { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null } }>, rentalStations: Array<{ __typename?: 'RentalStation', nonWorkingDays: Array<string>, id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }>, selectedRentalStation?: { __typename?: 'RentalStation', nonWorkingDays: Array<string>, minimumRentalPeriodDays?: number | null, minimumRentalPeriodEndDate?: string | null, id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lat: number, lng: number, distance?: number | null }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } | null, selectedProduct?: { __typename?: 'SelectedProduct', includedAccessoriesAmount: number, currentStock?: number | null, productImages?: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> | null } | null, rentInformation: { __typename?: 'RentInformation', earliestStartDate?: string | null, additionHours?: number | null }, deliveryRentalStations: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }> };

export type FullProductBundleResponseFragment = { __typename?: 'ProductBundle', type: { __typename?: 'ProductType', id: string }, shippingOptions: { __typename?: 'ShippingOptions', pickupEnabled: boolean, deliveryEnabled: boolean }, rentalStations: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lat: number, lng: number, distance?: number | null }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }>, pickupRentalStations: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }>, rentalStationsDistances: Array<{ __typename?: 'RentalStationDistance', id: string, distance: number }> };

export type ProductPropertyFragment = { __typename?: 'ProductBundleProperty', key: string, values?: any | null, isFact: boolean, isVariant: boolean, isEquipment: boolean, isRolloverProperty: boolean, descriptor: { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null } };

export type ProductSearchItemTenantFragment = { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } };

export type ProductSearchItemPreviewPriceInformationFragment = { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> };

export type ProductSearchItemFragment = { __typename?: 'ProductSearch_ProductModel', id: string, groupKey: string, isDeliveryPossible: boolean, hasHiddenPrice: boolean, showPrices: boolean, previewPriceInformation?: { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> } | null, productImages: Array<{ __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } }>, properties: Array<{ __typename?: 'ProductPropertyModel', isEquipment: boolean, isFact: boolean, isRolloverProperty: boolean, isVariant: boolean, key: string, value: any, descriptor: { __typename?: 'PropertyDescriptorModel', id: string, key: string, title: string, type: string, unit: string, enums: Array<{ __typename?: 'PropertyDescriptorEnumModel', key: string, id: string, title: string }> } }>, rentalStation: { __typename?: 'ProductSearch_RentalStationModel', city: string, countryCode: string, distance?: number | null, id: string, name: string, street: string, streetNumber: string, zip: string }, rentalStations: Array<{ __typename?: 'ProductSearch_RentalStationModel', id: string }>, tenant: { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } }, type: { __typename?: 'ProductSearch_ProductTypeModel', configuratorPageUrl: string, id: string, productPageUrl: string, title: string, uriComponent: string, mainCategory: { __typename?: 'CategoryModel', title: string, id: string }, manufacturer: { __typename?: 'ManufacturerModel', title: string, uriComponent: string } }, shippingOptions: { __typename?: 'ProductSearch_ShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean } };

export type ProductTypeImageFragment = { __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } };

export type ProductTypeFragment = { __typename?: 'ProductType', id: string, title: string, productPageUrl: string, configuratorPageUrl: string, importAsUriComponent?: string | null, isTopSuggestion?: boolean | null, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }>, mainCategory?: { __typename?: 'Category', id: string, title: string } | null };

export type PropertyDescriptorsResponseFragment = { __typename?: 'PropertyDescriptorsList', data: Array<{ __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null }> };

export type PropertyDescriptorFragment = { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null };

export type RentalStationFragment = { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } };

export type RentalStationCompactFragment = { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } };

export type SearchFilterResultFragment = { __typename?: 'ProductSearch_SearchFilterResponseModel', properties: Array<{ __typename?: 'ProductSearch_SearchFilterItem', id: string, key: string, type: string, title: string, unit: string, enums: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', title: string, key: string }>, range?: { __typename?: 'ProductSearch_SearchFilterItemRange', min: number, max: number } | null }>, manufacturers: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', id: string, key: string, title: string }>, tenants: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', id: string, key: string, title: string }> };

export type TenantLogoFragment = { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } };

export type TenantFragment = { __typename?: 'Tenant', id: string, key: string, name: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } };

export type AddOrUpdateCartItemMutationVariables = Exact<{
  input: AddOrUpdateCartItemInput;
}>;


export type AddOrUpdateCartItemMutation = { __typename?: 'Mutation', addOrUpdateCartItem?: { __typename?: 'Cart', id: string, discount: number, totalPrice: number, finalPrice: number, insurance: number, rentalTax: number, isActive: boolean, deposit: number, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, items: Array<{ __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }>, actions: { __typename?: 'CartActions', canBeBooked: boolean } } | null };

export type AddOrganizationAddressMutationVariables = Exact<{
  address: OrganizationService_CreateAddress;
}>;


export type AddOrganizationAddressMutation = { __typename?: 'Mutation', OrganizationService_CreateAddress: { __typename?: 'OrganizationService_Address', id: string } };

export type ApplyCouponMutationVariables = Exact<{
  input: ApplyCouponInput;
}>;


export type ApplyCouponMutation = { __typename?: 'Mutation', applyCoupon?: { __typename?: 'Cart', id: string, discount: number, totalPrice: number, finalPrice: number, insurance: number, rentalTax: number, isActive: boolean, deposit: number, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, items: Array<{ __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }>, actions: { __typename?: 'CartActions', canBeBooked: boolean } } | null };

export type AuthenticateMutationVariables = Exact<{
  input: AuthenticateInput;
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate: { __typename?: 'AuthenticateResponse', migrated: boolean } };

export type BookCartMutationVariables = Exact<{
  input: BookCartInput;
}>;


export type BookCartMutation = { __typename?: 'Mutation', bookCart?: { __typename?: 'BookCartResult', bookings: Array<string | null> } | null };

export type CancelBookingMutationVariables = Exact<{
  input: CancelBookingInput;
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', cancelBooking?: { __typename?: 'CancelBookingResponse', id: string } | null };

export type DeleteOrganizationAddressMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOrganizationAddressMutation = { __typename?: 'Mutation', OrganizationService_DeleteAddress: { __typename?: 'OrganizationService_DeleteResponse', deleted: boolean } };

export type EndBookingMutationVariables = Exact<{
  input: EndBookingInput;
}>;


export type EndBookingMutation = { __typename?: 'Mutation', endBooking?: { __typename?: 'UpdateBookingResponse', id: string, price: { __typename?: 'UpdateBookingResponsePrice', amount: number, currency: string } } | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', RegisterService_ResetPassword: { __typename?: 'RegisterService_ResetPasswordResponse', success: boolean } };

export type RegisterMutationVariables = Exact<{
  user: RegisterService_RegisterUser;
  organization: RegisterService_RegisterOrganization;
  affiliateId: Scalars['String']['input'];
  crsAffiliateId: Scalars['String']['input'];
}>;


export type RegisterMutation = { __typename?: 'Mutation', RegisterService_Register: { __typename?: 'RegisterService_RegisterResponse', success: boolean, errorMessage?: string | null } };

export type RemoveCartItemMutationVariables = Exact<{
  input: RemoveCartItemInput;
}>;


export type RemoveCartItemMutation = { __typename?: 'Mutation', removeCartItem?: { __typename?: 'Cart', id: string, discount: number, totalPrice: number, finalPrice: number, insurance: number, rentalTax: number, isActive: boolean, deposit: number, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, items: Array<{ __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }>, actions: { __typename?: 'CartActions', canBeBooked: boolean } } | null };

export type SubscribeNewsletterMutationVariables = Exact<{
  input: SubscribeInput;
}>;


export type SubscribeNewsletterMutation = { __typename?: 'Mutation', subscribe: { __typename?: 'SubscriptionResponse', email: string } };

export type UpdateBookingMutationVariables = Exact<{
  input: UpdateBookingInput;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking?: { __typename?: 'UpdateBookingResponse', id: string, price: { __typename?: 'UpdateBookingResponsePrice', amount: number, currency: string } } | null };

export type UpdateOrganizationAddressMutationVariables = Exact<{
  address: OrganizationService_UpdateAddress;
}>;


export type UpdateOrganizationAddressMutation = { __typename?: 'Mutation', OrganizationService_UpdateAddress: { __typename?: 'OrganizationService_Address', id: string } };

export type UpdateUserPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', RegisterService_UpdatePassword: { __typename?: 'RegisterService_UpdatePasswordResponse', success: boolean } };

export type UpdateUserProfileMutationVariables = Exact<{
  profile: KeycloakUserService_UpdateUserInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', KeycloakUserService_UpdateUser: { __typename?: 'KeycloakUserService_UpdateUserResponse', updated: boolean } };

export type AddressAutocompleteQueryVariables = Exact<{
  input: AutocompleteInput;
  field: AutocompleteFieldEnum;
}>;


export type AddressAutocompleteQuery = { __typename?: 'Query', Geolocation_addressAutocomplete: Array<{ __typename?: 'AutocompleteModel', label: string, addressData: { __typename?: 'AddressDataModel', street: string, city: string, zip: string } }> };

export type AuthProcessContentQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthProcessContentQuery = { __typename?: 'Query', authProcess?: { __typename?: 'AuthProcessEntityResponse', data?: { __typename?: 'AuthProcessEntity', attributes?: { __typename?: 'AuthProcess', emailVerifiedMessage?: string | null, signInIntroText?: string | null, signUpSuccessMessage?: string | null } | null } | null } | null };

export type BasketDataQueryVariables = Exact<{ [key: string]: never; }>;


export type BasketDataQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, discount: number, totalPrice: number, finalPrice: number, insurance: number, rentalTax: number, isActive: boolean, deposit: number, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, items: Array<{ __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }>, actions: { __typename?: 'CartActions', canBeBooked: boolean } } | null, tenants: { __typename?: 'TenantsResult', data?: Array<{ __typename?: 'Tenant', id: string, key: string, name: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } }> | null }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type BookedBookingsQueryVariables = Exact<{
  bookingNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BookedBookingsQuery = { __typename?: 'Query', BookingService_getBookingsByBookingNumbers: Array<{ __typename?: 'BookingService_Booking', id: string, state: BookingStatusEnum, created: string, deliveryTime?: string | null, note?: string | null, dateRange: { __typename?: 'BookingService_DateRange', start: string, end: string }, price: { __typename?: 'BookingService_Price', amount: number, currency: string }, product: { __typename?: 'BookingService_Product', effectiveNonWorkingDays: Array<string>, minimumRentalPeriodDays: number, minimumRentalPeriodEndDate: string }, productType: { __typename?: 'BookingService_ProductType', id: string, title: string, hasManagedStock: boolean, configuratorPageUrl: string, manufacturer: { __typename?: 'BookingService_Manufacturer', title: string, id: string } }, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, tenant: { __typename?: 'BookingService_Tenant', name: string, key: string, logo: { __typename?: 'BookingService_TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'BookingService_TenantLogoMetaData', width: number, height: number, format: string } } }, project: { __typename?: 'BookingService_Project', id: string, name: string, externalProjectId?: string | null }, renter: { __typename?: 'BookingService_Renter', firstName: string, lastName: string }, actions: { __typename?: 'BookingService_Actions', readOnly: boolean, canBeCanceled: boolean, canBeEnd: boolean, canBeUpdated: { __typename?: 'BookingService_Actions_CanBeUpdated', possible: boolean, startDate: boolean, endDate: boolean } }, billingAddress: { __typename?: 'BookingService_Address', name: string, streetNumber: string, street: string, zipCode: string, city: string, countryCode: string }, priceSnapshot: { __typename?: 'BookingService_BookingPriceSnapshot', productAmount: number, workingDays: number, final: { __typename?: 'BookingService_BookingPrice', amount: number }, insurance: { __typename?: 'BookingService_BookingPrice', amount: number }, discount: { __typename?: 'BookingService_BookingPrice', amount: number }, tax: { __typename?: 'BookingService_BookingPrice', amount: number }, accessoriesPrice: { __typename?: 'BookingService_BookingPrice', amount: number }, shipping: { __typename?: 'BookingService_BookingPrice', amount: number }, serviceFees: Array<{ __typename?: 'BookingService_BookingServiceFee', key: string, value: number }> }, coupons: Array<{ __typename?: 'BookingService_BookingCoupon', code: string, discount: { __typename?: 'BookingService_BookingCouponDiscount', amount: number, percent: number, type: DiscountTypeEnum } }>, accessories: Array<{ __typename?: 'BookingService_BookingAccessory', title: string, identifier: string, quantity: number, totalPrice: number }>, productProperties: Array<{ __typename?: 'BookingService_BookingProductProperty', key: string, isVariant: boolean, value: { __typename?: 'BookingService_BookingProductPropertyValue', value: string, title: string }, descriptor: { __typename?: 'BookingService_BookingProductPropertyDescriptor', title: string } }>, shipping: { __typename?: 'BookingService_BookingShippingDelivery', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, destination: { __typename?: 'BookingService_BookingShippingDestination', id: string, address: { __typename?: 'BookingService_Address', name: string, street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } | { __typename?: 'BookingService_BookingShippingPickup', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } }> };

export type BookingFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingFilterOptionsQuery = { __typename?: 'Query', BookingService_getUniqueBookingFilterOptions: { __typename?: 'BookingService_BookingFilterOptionsQuery', bookingStatus: Array<string>, productTypes: Array<{ __typename?: 'BookingService_BookingFilterOption', key: string, value: string }>, tenantKeys: Array<{ __typename?: 'BookingService_BookingFilterOption', key: string, value: string }>, projects: Array<{ __typename?: 'BookingService_BookingFilterOption', key: string, value: string }> } };

export type GetBookingQueryVariables = Exact<{
  bookingNumber: Scalars['String']['input'];
}>;


export type GetBookingQuery = { __typename?: 'Query', BookingService_getBooking: { __typename?: 'BookingService_Booking', id: string, state: BookingStatusEnum, created: string, deliveryTime?: string | null, note?: string | null, dateRange: { __typename?: 'BookingService_DateRange', start: string, end: string }, price: { __typename?: 'BookingService_Price', amount: number, currency: string }, product: { __typename?: 'BookingService_Product', effectiveNonWorkingDays: Array<string>, minimumRentalPeriodDays: number, minimumRentalPeriodEndDate: string }, productType: { __typename?: 'BookingService_ProductType', id: string, title: string, hasManagedStock: boolean, configuratorPageUrl: string, manufacturer: { __typename?: 'BookingService_Manufacturer', title: string, id: string } }, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, tenant: { __typename?: 'BookingService_Tenant', name: string, key: string, logo: { __typename?: 'BookingService_TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'BookingService_TenantLogoMetaData', width: number, height: number, format: string } } }, project: { __typename?: 'BookingService_Project', id: string, name: string, externalProjectId?: string | null }, renter: { __typename?: 'BookingService_Renter', firstName: string, lastName: string }, actions: { __typename?: 'BookingService_Actions', readOnly: boolean, canBeCanceled: boolean, canBeEnd: boolean, canBeUpdated: { __typename?: 'BookingService_Actions_CanBeUpdated', possible: boolean, startDate: boolean, endDate: boolean } }, billingAddress: { __typename?: 'BookingService_Address', name: string, streetNumber: string, street: string, zipCode: string, city: string, countryCode: string }, priceSnapshot: { __typename?: 'BookingService_BookingPriceSnapshot', productAmount: number, workingDays: number, final: { __typename?: 'BookingService_BookingPrice', amount: number }, insurance: { __typename?: 'BookingService_BookingPrice', amount: number }, discount: { __typename?: 'BookingService_BookingPrice', amount: number }, tax: { __typename?: 'BookingService_BookingPrice', amount: number }, accessoriesPrice: { __typename?: 'BookingService_BookingPrice', amount: number }, shipping: { __typename?: 'BookingService_BookingPrice', amount: number }, serviceFees: Array<{ __typename?: 'BookingService_BookingServiceFee', key: string, value: number }> }, coupons: Array<{ __typename?: 'BookingService_BookingCoupon', code: string, discount: { __typename?: 'BookingService_BookingCouponDiscount', amount: number, percent: number, type: DiscountTypeEnum } }>, accessories: Array<{ __typename?: 'BookingService_BookingAccessory', title: string, identifier: string, quantity: number, totalPrice: number }>, productProperties: Array<{ __typename?: 'BookingService_BookingProductProperty', key: string, isVariant: boolean, value: { __typename?: 'BookingService_BookingProductPropertyValue', value: string, title: string }, descriptor: { __typename?: 'BookingService_BookingProductPropertyDescriptor', title: string } }>, shipping: { __typename?: 'BookingService_BookingShippingDelivery', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, destination: { __typename?: 'BookingService_BookingShippingDestination', id: string, address: { __typename?: 'BookingService_Address', name: string, street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } | { __typename?: 'BookingService_BookingShippingPickup', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } } };

export type BookingsAsCsvQueryVariables = Exact<{
  filter: BookingService_BookingsFilter;
}>;


export type BookingsAsCsvQuery = { __typename?: 'Query', BookingService_getBookingsAsCSV: string };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, discount: number, totalPrice: number, finalPrice: number, insurance: number, rentalTax: number, isActive: boolean, deposit: number, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, items: Array<{ __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }>, actions: { __typename?: 'CartActions', canBeBooked: boolean } } | null };

export type CatalogSearchQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  tenantKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type CatalogSearchQuery = { __typename?: 'Query', results: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | { __typename?: 'ProductType', id: string, title: string, productPageUrl: string, configuratorPageUrl: string, importAsUriComponent?: string | null, isTopSuggestion?: boolean | null, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }>, mainCategory?: { __typename?: 'Category', id: string, title: string } | null } | { __typename?: 'Tenant', id: string, key: string, name: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } }> };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', categories: { __typename?: 'CategoriesList', data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> } };

export type CategoryByTextQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type CategoryByTextQuery = { __typename?: 'Query', categoryByText?: { __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null };

export type CategoryByUriComponentQueryVariables = Exact<{
  uriComponent: Scalars['String']['input'];
}>;


export type CategoryByUriComponentQuery = { __typename?: 'Query', categoryByUriComponent?: { __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null };

export type CategorySitemapVirtualQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorySitemapVirtualQuery = { __typename?: 'Query', searchPages?: { __typename?: 'SearchPageEntityResponseCollection', data: Array<{ __typename?: 'SearchPageEntity', id?: string | null, attributes?: { __typename?: 'SearchPage', slugSelector?: { __typename?: 'ComponentHelperDigandoCategorySelector', id: string, slug?: string | null } | null, searchLocation?: { __typename?: 'SearchLocationEntityResponse', data?: { __typename?: 'SearchLocationEntity', id?: string | null, attributes?: { __typename?: 'SearchLocation', slug?: string | null, title?: string | null } | null } | null } | null } | null }> } | null };

export type CategorySitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorySitemapQuery = { __typename?: 'Query', categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, relativeUrl: string, children?: Array<{ __typename?: 'Category', id: string, relativeUrl: string, children?: Array<{ __typename?: 'Category', id: string, relativeUrl: string } | null> | null } | null> | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> }, tenants: { __typename?: 'TenantsResult', data?: Array<{ __typename?: 'Tenant', id: string, key: string, name: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } }> | null } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type DatoDocumentRelationsQueryVariables = Exact<{
  input: DatoDocumentRelationsInput;
}>;


export type DatoDocumentRelationsQuery = { __typename?: 'Query', datoDocumentRelations: { __typename?: 'Urls', urls: Array<string> } };

export type GeolocationQueryVariables = Exact<{
  input: GeolocationInput;
}>;


export type GeolocationQuery = { __typename?: 'Query', Geolocation_geolocation?: { __typename?: 'GeolocationModel', lat: number, lng: number, radius?: number | null, address: { __typename?: 'AddressModel', city?: string | null, country?: string | null, street?: string | null, streetNumber?: string | null, zip?: string | null }, locationQuality: { __typename?: 'LocationQualityModel', score: number, sourceService: string }, correctedFields?: Array<{ __typename?: 'CorrectedFieldModel', fieldName: AddressFieldEnum, originalValue: string, correctedValue: string }> | null, normalizedAddress: { __typename?: 'AddressModel', city?: string | null, country?: string | null, street?: string | null, streetNumber?: string | null, zip?: string | null } } | null };

export type GetAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddressesQuery = { __typename?: 'Query', OrganizationService_MeAddresses?: Array<{ __typename?: 'OrganizationService_Address', id: string, name: string, street: string, streetNumber: string, zipCode: string, city: string, countryCode: string, createdAt: any }> | null };

export type HasUserBeenMigratedQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type HasUserBeenMigratedQuery = { __typename?: 'Query', RegisterService_HasUserBeenMigrated: boolean };

export type LocationAutocompleteQueryVariables = Exact<{
  params: GetLocationsInput;
}>;


export type LocationAutocompleteQuery = { __typename?: 'Query', Geolocation_getLocations: { __typename?: 'Geolocation_GetLocationsQuery', locations: Array<{ __typename?: 'Geolocation_LocationModel', label: string, data: { __typename?: 'Geolocation_LocationDataModel', x: number, y: number } }> } };

export type LocationByPlaceIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LocationByPlaceIdQuery = { __typename?: 'Query', Geolocation_locationByPlace?: { __typename?: 'PlaceModel', id: string, name: string, lat: number, lng: number, radius?: number | null, address?: { __typename?: 'AddressModel', street?: string | null, streetNumber?: string | null, zip?: string | null, city?: string | null, country?: string | null } | null } | null };

export type LocationByUriComponentQueryVariables = Exact<{
  uriComponent: Scalars['String']['input'];
}>;


export type LocationByUriComponentQuery = { __typename?: 'Query', Geolocation_getLocationInformation?: { __typename?: 'PlaceModel', id: string, name: string, radius?: number | null, lat: number, lng: number } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', KeycloakUserService_me?: { __typename?: 'KeycloakUser_GetKeycloakUserResponse', id: string, lastName: string, firstName: string, email: string, phone: string, gender: KeycloadUser_Gender } | null, OrganizationService_OrganizationForUser?: { __typename?: 'OrganizationService_Organization', id: string, name: string, street: string, streetNumber: string, city: string, zipCode: string, countryCode: string, createdAt: any } | null };

export type CheckVatIdQueryVariables = Exact<{
  vatId: Scalars['String']['input'];
}>;


export type CheckVatIdQuery = { __typename?: 'Query', OrganizationService_CheckVatId: { __typename?: 'OrganizationService_CheckVatIdResponse', vatId: string, valid: boolean, name: string, address: { __typename?: 'OrganizationService_VatIdAddress', zip: string, streetNumber: string, street: string, countryCode: string, city: string } } };

export type MemberFragment = { __typename?: 'OrganizationsService_Members', firstName: string, lastName: string, email: string, enabled: boolean, role: string, id: string };

export type GetorganizationMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetorganizationMembersQuery = { __typename?: 'Query', OrganizationService_MembersForUserOrganization?: { __typename?: 'OrganizationService_OrganizationMembersResponse', total: number, members: Array<{ __typename?: 'OrganizationsService_Members', firstName: string, lastName: string, email: string, enabled: boolean, role: string, id: string }> } | null };

export type BookingPageQueryVariables = Exact<{
  bookingNumber: Scalars['String']['input'];
}>;


export type BookingPageQuery = { __typename?: 'Query', BookingService_getBooking: { __typename?: 'BookingService_Booking', id: string, state: BookingStatusEnum, created: string, deliveryTime?: string | null, note?: string | null, dateRange: { __typename?: 'BookingService_DateRange', start: string, end: string }, price: { __typename?: 'BookingService_Price', amount: number, currency: string }, product: { __typename?: 'BookingService_Product', effectiveNonWorkingDays: Array<string>, minimumRentalPeriodDays: number, minimumRentalPeriodEndDate: string }, productType: { __typename?: 'BookingService_ProductType', id: string, title: string, hasManagedStock: boolean, configuratorPageUrl: string, manufacturer: { __typename?: 'BookingService_Manufacturer', title: string, id: string } }, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, tenant: { __typename?: 'BookingService_Tenant', name: string, key: string, logo: { __typename?: 'BookingService_TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'BookingService_TenantLogoMetaData', width: number, height: number, format: string } } }, project: { __typename?: 'BookingService_Project', id: string, name: string, externalProjectId?: string | null }, renter: { __typename?: 'BookingService_Renter', firstName: string, lastName: string }, actions: { __typename?: 'BookingService_Actions', readOnly: boolean, canBeCanceled: boolean, canBeEnd: boolean, canBeUpdated: { __typename?: 'BookingService_Actions_CanBeUpdated', possible: boolean, startDate: boolean, endDate: boolean } }, billingAddress: { __typename?: 'BookingService_Address', name: string, streetNumber: string, street: string, zipCode: string, city: string, countryCode: string }, priceSnapshot: { __typename?: 'BookingService_BookingPriceSnapshot', productAmount: number, workingDays: number, final: { __typename?: 'BookingService_BookingPrice', amount: number }, insurance: { __typename?: 'BookingService_BookingPrice', amount: number }, discount: { __typename?: 'BookingService_BookingPrice', amount: number }, tax: { __typename?: 'BookingService_BookingPrice', amount: number }, accessoriesPrice: { __typename?: 'BookingService_BookingPrice', amount: number }, shipping: { __typename?: 'BookingService_BookingPrice', amount: number }, serviceFees: Array<{ __typename?: 'BookingService_BookingServiceFee', key: string, value: number }> }, coupons: Array<{ __typename?: 'BookingService_BookingCoupon', code: string, discount: { __typename?: 'BookingService_BookingCouponDiscount', amount: number, percent: number, type: DiscountTypeEnum } }>, accessories: Array<{ __typename?: 'BookingService_BookingAccessory', title: string, identifier: string, quantity: number, totalPrice: number }>, productProperties: Array<{ __typename?: 'BookingService_BookingProductProperty', key: string, isVariant: boolean, value: { __typename?: 'BookingService_BookingProductPropertyValue', value: string, title: string }, descriptor: { __typename?: 'BookingService_BookingProductPropertyDescriptor', title: string } }>, shipping: { __typename?: 'BookingService_BookingShippingDelivery', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, destination: { __typename?: 'BookingService_BookingShippingDestination', id: string, address: { __typename?: 'BookingService_Address', name: string, street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } | { __typename?: 'BookingService_BookingShippingPickup', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } }, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type BookingsPageQueryVariables = Exact<{
  pagination: BookingService_PaginationArgs;
  filter?: InputMaybe<BookingService_BookingsFilter>;
}>;


export type BookingsPageQuery = { __typename?: 'Query', BookingService_getBookings: { __typename?: 'BookingService_BookingsQuery', total: number, bookings: Array<{ __typename?: 'BookingService_Booking', id: string, state: BookingStatusEnum, created: string, deliveryTime?: string | null, note?: string | null, dateRange: { __typename?: 'BookingService_DateRange', start: string, end: string }, price: { __typename?: 'BookingService_Price', amount: number, currency: string }, product: { __typename?: 'BookingService_Product', effectiveNonWorkingDays: Array<string>, minimumRentalPeriodDays: number, minimumRentalPeriodEndDate: string }, productType: { __typename?: 'BookingService_ProductType', id: string, title: string, hasManagedStock: boolean, configuratorPageUrl: string, manufacturer: { __typename?: 'BookingService_Manufacturer', title: string, id: string } }, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, tenant: { __typename?: 'BookingService_Tenant', name: string, key: string, logo: { __typename?: 'BookingService_TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'BookingService_TenantLogoMetaData', width: number, height: number, format: string } } }, project: { __typename?: 'BookingService_Project', id: string, name: string, externalProjectId?: string | null }, renter: { __typename?: 'BookingService_Renter', firstName: string, lastName: string }, actions: { __typename?: 'BookingService_Actions', readOnly: boolean, canBeCanceled: boolean, canBeEnd: boolean, canBeUpdated: { __typename?: 'BookingService_Actions_CanBeUpdated', possible: boolean, startDate: boolean, endDate: boolean } }, billingAddress: { __typename?: 'BookingService_Address', name: string, streetNumber: string, street: string, zipCode: string, city: string, countryCode: string }, priceSnapshot: { __typename?: 'BookingService_BookingPriceSnapshot', productAmount: number, workingDays: number, final: { __typename?: 'BookingService_BookingPrice', amount: number }, insurance: { __typename?: 'BookingService_BookingPrice', amount: number }, discount: { __typename?: 'BookingService_BookingPrice', amount: number }, tax: { __typename?: 'BookingService_BookingPrice', amount: number }, accessoriesPrice: { __typename?: 'BookingService_BookingPrice', amount: number }, shipping: { __typename?: 'BookingService_BookingPrice', amount: number }, serviceFees: Array<{ __typename?: 'BookingService_BookingServiceFee', key: string, value: number }> }, coupons: Array<{ __typename?: 'BookingService_BookingCoupon', code: string, discount: { __typename?: 'BookingService_BookingCouponDiscount', amount: number, percent: number, type: DiscountTypeEnum } }>, accessories: Array<{ __typename?: 'BookingService_BookingAccessory', title: string, identifier: string, quantity: number, totalPrice: number }>, productProperties: Array<{ __typename?: 'BookingService_BookingProductProperty', key: string, isVariant: boolean, value: { __typename?: 'BookingService_BookingProductPropertyValue', value: string, title: string }, descriptor: { __typename?: 'BookingService_BookingProductPropertyDescriptor', title: string } }>, shipping: { __typename?: 'BookingService_BookingShippingDelivery', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } }, destination: { __typename?: 'BookingService_BookingShippingDestination', id: string, address: { __typename?: 'BookingService_Address', name: string, street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } | { __typename?: 'BookingService_BookingShippingPickup', type: ShippingOptionEnum, rentalStation: { __typename?: 'BookingService_RentalStation', identifier: string, name: string, address: { __typename?: 'BookingService_Address', street: string, streetNumber: string, zipCode: string, city: string, countryCode: string } } } }> }, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type ConfiguratorLoginPageQueryVariables = Exact<{
  input: ProductBundleInput;
}>;


export type ConfiguratorLoginPageQuery = { __typename?: 'Query', productBundle?: { __typename?: 'ProductBundleResult', bundle?: { __typename?: 'ProductBundle', type: { __typename?: 'ProductType', productPageUrl: string, title: string, manufacturer?: { __typename?: 'Manufacturer', title: string } | null, mainCategory?: { __typename?: 'Category', title: string, relativeUrl: string, parent?: { __typename?: 'Category', relativeUrl: string, title: string } | null } | null }, properties: Array<{ __typename?: 'ProductBundleProperty', key: string, values?: any | null, isFact: boolean, isVariant: boolean, isEquipment: boolean, isRolloverProperty: boolean, descriptor: { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null } }> } | null } | null };

export type ContentPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentPageQuery = { __typename?: 'Query', categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type SitemapProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapProductTypesQuery = { __typename?: 'Query', productTypes: { __typename?: 'ProductTypesList', data: Array<{ __typename?: 'ProductType', id: string, relativeUrl: string, accessoryOnly: boolean, importAsUriComponent?: string | null }> } };

export type SearchPageDataQueryVariables = Exact<{
  pagination: ProductSearch_PaginationInput;
  dateRange: ProductSearch_DateRangeInput;
  geoPoint?: InputMaybe<ProductSearch_GeoPointInput>;
  enumProperties: Array<ProductSearch_EnumPropertiesInput> | ProductSearch_EnumPropertiesInput;
  rangeProperties: Array<ProductSearch_RangePropertiesInput> | ProductSearch_RangePropertiesInput;
  manufacturers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tenantKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  uriComponent: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  searchSort?: InputMaybe<ProductSearch_SearchSortInput>;
}>;


export type SearchPageDataQuery = { __typename?: 'Query', ProductSearch_searchProducts?: { __typename?: 'ProductSearch_ProductSearchResponseModel', total: number, loadedDate: any, pagination: { __typename?: 'ProductSearch_PaginationModel', hasMore: boolean, currentPage: number }, products: Array<{ __typename?: 'ProductSearch_ProductModel', id: string, groupKey: string, isDeliveryPossible: boolean, hasHiddenPrice: boolean, showPrices: boolean, previewPriceInformation?: { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> } | null, productImages: Array<{ __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } }>, properties: Array<{ __typename?: 'ProductPropertyModel', isEquipment: boolean, isFact: boolean, isRolloverProperty: boolean, isVariant: boolean, key: string, value: any, descriptor: { __typename?: 'PropertyDescriptorModel', id: string, key: string, title: string, type: string, unit: string, enums: Array<{ __typename?: 'PropertyDescriptorEnumModel', key: string, id: string, title: string }> } }>, rentalStation: { __typename?: 'ProductSearch_RentalStationModel', city: string, countryCode: string, distance?: number | null, id: string, name: string, street: string, streetNumber: string, zip: string }, rentalStations: Array<{ __typename?: 'ProductSearch_RentalStationModel', id: string }>, tenant: { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } }, type: { __typename?: 'ProductSearch_ProductTypeModel', configuratorPageUrl: string, id: string, productPageUrl: string, title: string, uriComponent: string, mainCategory: { __typename?: 'CategoryModel', title: string, id: string }, manufacturer: { __typename?: 'ManufacturerModel', title: string, uriComponent: string } }, shippingOptions: { __typename?: 'ProductSearch_ShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean } }>, activeFilters: { __typename?: 'ProductSearch_ActiveFilters', radius?: number | null, sort: { __typename?: 'ProductSearch_ActiveFiltersSort', by: ProductSearch_SortOption } } } | null, ProductSearch_searchFilter?: { __typename?: 'ProductSearch_SearchFilterResponseModel', properties: Array<{ __typename?: 'ProductSearch_SearchFilterItem', id: string, key: string, type: string, title: string, unit: string, enums: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', title: string, key: string }>, range?: { __typename?: 'ProductSearch_SearchFilterItemRange', min: number, max: number } | null }>, manufacturers: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', id: string, key: string, title: string }>, tenants: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', id: string, key: string, title: string }> } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type ProductSearchResponseFragment = { __typename?: 'ProductSearch_ProductSearchResponseModel', total: number, loadedDate: any, pagination: { __typename?: 'ProductSearch_PaginationModel', hasMore: boolean, currentPage: number }, products: Array<{ __typename?: 'ProductSearch_ProductModel', id: string, groupKey: string, isDeliveryPossible: boolean, hasHiddenPrice: boolean, showPrices: boolean, previewPriceInformation?: { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> } | null, productImages: Array<{ __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } }>, properties: Array<{ __typename?: 'ProductPropertyModel', isEquipment: boolean, isFact: boolean, isRolloverProperty: boolean, isVariant: boolean, key: string, value: any, descriptor: { __typename?: 'PropertyDescriptorModel', id: string, key: string, title: string, type: string, unit: string, enums: Array<{ __typename?: 'PropertyDescriptorEnumModel', key: string, id: string, title: string }> } }>, rentalStation: { __typename?: 'ProductSearch_RentalStationModel', city: string, countryCode: string, distance?: number | null, id: string, name: string, street: string, streetNumber: string, zip: string }, rentalStations: Array<{ __typename?: 'ProductSearch_RentalStationModel', id: string }>, tenant: { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } }, type: { __typename?: 'ProductSearch_ProductTypeModel', configuratorPageUrl: string, id: string, productPageUrl: string, title: string, uriComponent: string, mainCategory: { __typename?: 'CategoryModel', title: string, id: string }, manufacturer: { __typename?: 'ManufacturerModel', title: string, uriComponent: string } }, shippingOptions: { __typename?: 'ProductSearch_ShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean } }>, activeFilters: { __typename?: 'ProductSearch_ActiveFilters', radius?: number | null, sort: { __typename?: 'ProductSearch_ActiveFiltersSort', by: ProductSearch_SortOption } } };

export type RecommendedProductsResponseFragment = { __typename?: 'ProductSearch_RecommendedProductsResponseModel', total: number, loadedDate: any, products: Array<{ __typename?: 'ProductSearch_ProductModel', id: string, groupKey: string, isDeliveryPossible: boolean, hasHiddenPrice: boolean, showPrices: boolean, previewPriceInformation?: { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> } | null, productImages: Array<{ __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } }>, properties: Array<{ __typename?: 'ProductPropertyModel', isEquipment: boolean, isFact: boolean, isRolloverProperty: boolean, isVariant: boolean, key: string, value: any, descriptor: { __typename?: 'PropertyDescriptorModel', id: string, key: string, title: string, type: string, unit: string, enums: Array<{ __typename?: 'PropertyDescriptorEnumModel', key: string, id: string, title: string }> } }>, rentalStation: { __typename?: 'ProductSearch_RentalStationModel', city: string, countryCode: string, distance?: number | null, id: string, name: string, street: string, streetNumber: string, zip: string }, rentalStations: Array<{ __typename?: 'ProductSearch_RentalStationModel', id: string }>, tenant: { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } }, type: { __typename?: 'ProductSearch_ProductTypeModel', configuratorPageUrl: string, id: string, productPageUrl: string, title: string, uriComponent: string, mainCategory: { __typename?: 'CategoryModel', title: string, id: string }, manufacturer: { __typename?: 'ManufacturerModel', title: string, uriComponent: string } }, shippingOptions: { __typename?: 'ProductSearch_ShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean } }> };

export type RelatedProductsResponseFragment = { __typename?: 'ProductSearch_RelatedProductsResponseModel', total: number, loadedDate: any, products: Array<{ __typename?: 'ProductSearch_ProductModel', id: string, groupKey: string, isDeliveryPossible: boolean, hasHiddenPrice: boolean, showPrices: boolean, previewPriceInformation?: { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> } | null, productImages: Array<{ __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } }>, properties: Array<{ __typename?: 'ProductPropertyModel', isEquipment: boolean, isFact: boolean, isRolloverProperty: boolean, isVariant: boolean, key: string, value: any, descriptor: { __typename?: 'PropertyDescriptorModel', id: string, key: string, title: string, type: string, unit: string, enums: Array<{ __typename?: 'PropertyDescriptorEnumModel', key: string, id: string, title: string }> } }>, rentalStation: { __typename?: 'ProductSearch_RentalStationModel', city: string, countryCode: string, distance?: number | null, id: string, name: string, street: string, streetNumber: string, zip: string }, rentalStations: Array<{ __typename?: 'ProductSearch_RentalStationModel', id: string }>, tenant: { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } }, type: { __typename?: 'ProductSearch_ProductTypeModel', configuratorPageUrl: string, id: string, productPageUrl: string, title: string, uriComponent: string, mainCategory: { __typename?: 'CategoryModel', title: string, id: string }, manufacturer: { __typename?: 'ManufacturerModel', title: string, uriComponent: string } }, shippingOptions: { __typename?: 'ProductSearch_ShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean } }> };

export type StaticSearchPageQueryVariables = Exact<{ [key: string]: never; }>;


export type StaticSearchPageQuery = { __typename?: 'Query', categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> } };

export type PlaceResponseFragment = { __typename?: 'PlaceModel', id: string, name: string, lng: number, lat: number };

export type PlaceQueryVariables = Exact<{
  params: PlaceInput;
}>;


export type PlaceQuery = { __typename?: 'Query', Geolocation_place?: { __typename?: 'PlaceModel', id: string, name: string, lng: number, lat: number } | null };

export type PlacesQueryVariables = Exact<{
  params: PlacesInput;
}>;


export type PlacesQuery = { __typename?: 'Query', Geolocation_places: { __typename: 'PlacesSuggestionModel', data: Array<{ __typename?: 'PlaceSuggestionModel', id: string, name: string, radius?: number | null }> } };

export type ProductBundleQueryVariables = Exact<{
  location?: InputMaybe<LocationInput>;
  input: ProductBundleInput;
  rentalStationProductBundleInput: ProductBundleInput;
  fullProductBundleInput: ProductBundleInput;
  productPriceInput: ProductPriceInput;
}>;


export type ProductBundleQuery = { __typename?: 'Query', productBundle?: { __typename?: 'ProductBundleResult', bundle?: { __typename?: 'ProductBundle', type: { __typename?: 'ProductType', id: string, title: string, productPageUrl: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, uriComponent: string, relativeUrl: string, title: string, parent?: { __typename?: 'Category', title: string, relativeUrl: string } | null } | null, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> }, prices: Array<{ __typename?: 'GraduatedPrice', minDays: number, price: number }>, properties: Array<{ __typename?: 'ProductBundleProperty', key: string, values?: any | null, isFact: boolean, isVariant: boolean, isEquipment: boolean, isRolloverProperty: boolean, descriptor: { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null } }>, rentalStations: Array<{ __typename?: 'RentalStation', nonWorkingDays: Array<string>, id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }>, selectedRentalStation?: { __typename?: 'RentalStation', nonWorkingDays: Array<string>, minimumRentalPeriodDays?: number | null, minimumRentalPeriodEndDate?: string | null, id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lat: number, lng: number, distance?: number | null }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } | null, selectedProduct?: { __typename?: 'SelectedProduct', includedAccessoriesAmount: number, currentStock?: number | null, productImages?: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> | null } | null, rentInformation: { __typename?: 'RentInformation', earliestStartDate?: string | null, additionHours?: number | null }, deliveryRentalStations: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }> } | null, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, isPreselected?: boolean | null, forcePayment?: boolean | null, priceType: string, wearPartPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', id?: string | null } | null, images?: Array<{ __typename?: 'ProductAccessoryImage', url: string, alt?: string | null, title?: string | null, id: string } | null> | null, tierPrices?: Array<{ __typename?: 'GraduatedPrice', price: number }> | null }>, relatedProducts: Array<{ __typename?: 'ProductBundle', type: { __typename?: 'ProductType', id: string, title: string, uriComponent: string, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> }, priceInformation?: { __typename?: 'ProductBundlePriceInformation', productPricePerDay: { __typename?: 'TypedPrice', type: PriceType, amount: number }, productPriceReducedPerDay: { __typename?: 'TypedPrice', type: PriceType, amount: number } } | null }> } | null, rentalStationProductBundle?: { __typename?: 'ProductBundleResult', bundle?: { __typename?: 'ProductBundle', properties: Array<{ __typename?: 'ProductBundleProperty', key: string, values?: any | null, isFact: boolean, isVariant: boolean, isEquipment: boolean, isRolloverProperty: boolean, descriptor: { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null } }> } | null } | null, fullProductBundle?: { __typename?: 'ProductBundleResult', bundle?: { __typename?: 'ProductBundle', type: { __typename?: 'ProductType', id: string }, shippingOptions: { __typename?: 'ShippingOptions', pickupEnabled: boolean, deliveryEnabled: boolean }, rentalStations: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lat: number, lng: number, distance?: number | null }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }>, pickupRentalStations: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }>, rentalStationsDistances: Array<{ __typename?: 'RentalStationDistance', id: string, distance: number }> } | null } | null, productPrice?: { __typename?: 'ProductPriceData', productPrice?: { __typename?: 'ProductPrice', workingDays: number, productAmount: number, product: { __typename?: 'Price', amountPerDay: number, amountPerDayReduced: number, amount: number }, accessories: Array<{ __typename?: 'AccessoryPrice', identifier: string, isSelected: boolean, quantity: number, title: string, id: string, price: { __typename?: 'Price', amount: number, amountPerDay: number, amountPerDayReduced: number } }>, accessory: { __typename?: 'Price', amount: number, amountPerDay: number, amountPerDayReduced: number }, insurance?: { __typename?: 'InsurancePrice', mode: InsuranceMode, percentage: number, price: { __typename?: 'Price', amountPerDay: number, amount: number } } | null, shipping?: { __typename?: 'Price', amount: number } | null, total: { __typename?: 'Price', amountPerDay: number, amount: number }, final: { __typename?: 'Price', amount: number, amountPerDay: number }, taxes: Array<{ __typename?: 'PercentagePrice', percentage: number, price: { __typename?: 'Price', amountPerDay: number, amount: number } }>, discount?: { __typename?: 'Price', amount: number } | null, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }> } | null, productPriceError?: { __typename?: 'ProductPriceError', code: string, target: string } | null } | null, cart?: { __typename?: 'Cart', id: string, discount: number, totalPrice: number, finalPrice: number, insurance: number, rentalTax: number, isActive: boolean, deposit: number, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, items: Array<{ __typename?: 'CartItem', id: string, accessoriesPrice: number, price: number, insurance: number, note?: string | null, discount: number, deposit: number, errors: Array<string>, workingDays: number, productAmount: number, deliveryTime?: string | null, attachedFileUrl?: string | null, billingAddressInfo?: string | null, projectInfo?: string | null, tradeNumber?: string | null, coupon?: { __typename?: 'DiscountObject', code: string, discount: { __typename?: 'DiscountValue', type: string, amount?: { __typename?: 'DiscountValueData', value: number } | null, percent?: { __typename?: 'DiscountValueData', value: number } | null } } | null, shipping: { __typename?: 'ShippingDelivery', costs: number, destination: { __typename?: 'DeliveryDestination', id: string, name: string, street?: string | null, streetNumber?: string | null, zip: string, city: string, country: string }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } } | { __typename?: 'ShippingPickup', rentalStation: { __typename?: 'RentalStation', id: string, name: string, shortName: string, street: string, streetNumber: string, city: string, zip: string, openingHours: string, location: { __typename?: 'Location', lng: number, lat: number }, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, tenant: { __typename?: 'Tenant', key: string, name: string, tenantInsuranceMode: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }, accessories: Array<{ __typename?: 'ProductAccessory', title?: string | null, quantity?: number | null, totalPrice?: number | null, price?: number | null, accessoryType?: { __typename?: 'ProductAccessoryType', identifier?: string | null } | null }>, serviceFees: Array<{ __typename?: 'ServiceFee', key: string, value: number }>, dateRange: { __typename?: 'DateRange', start: any, end: any }, properties: Array<{ __typename?: 'Property', value: any, key: string, title: string, isVariant: boolean, descriptor: { __typename?: 'PropertyDescriptor', title?: string | null } }>, productType: { __typename?: 'ProductType', id: string, title: string, configuratorPageUrl: string, hasManagedStock: boolean, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, streetNumber: string, street: string, city: string, tenant: { __typename?: 'Tenant', name: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } } }>, actions: { __typename?: 'CartActions', canBeBooked: boolean } } | null, categories: { __typename?: 'CategoriesList', total: number, data: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, children?: Array<{ __typename?: 'Category', id: string, title: string, searchTitle: string, uriComponent: string, originalUriComponent?: string | null, relativeUrl: string, categoryRecommended: boolean, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null } | null> | null, image?: { __typename?: 'Image', alt: string, url: string } | null, parent?: { __typename?: 'Category', id: string, title: string, relativeUrl: string } | null }> }, countries: { __typename?: 'CountriesResult', data: Array<{ __typename?: 'Country', iso2: string, name?: string | null, id: string }> } };

export type ProductSearchFilterQueryVariables = Exact<{
  refresh: Scalars['Boolean']['input'];
  pagination: ProductSearch_PaginationInput;
  dateRange: ProductSearch_DateRangeInput;
  geoPoint?: InputMaybe<ProductSearch_GeoPointInput>;
  enumProperties: Array<ProductSearch_EnumPropertiesInput> | ProductSearch_EnumPropertiesInput;
  rangeProperties: Array<ProductSearch_RangePropertiesInput> | ProductSearch_RangePropertiesInput;
  manufacturers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tenantKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  uriComponent: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  searchSort?: InputMaybe<ProductSearch_SearchSortInput>;
}>;


export type ProductSearchFilterQuery = { __typename?: 'Query', ProductSearch_searchFilter?: { __typename?: 'ProductSearch_SearchFilterResponseModel', properties: Array<{ __typename?: 'ProductSearch_SearchFilterItem', id: string, key: string, type: string, title: string, unit: string, enums: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', title: string, key: string }>, range?: { __typename?: 'ProductSearch_SearchFilterItemRange', min: number, max: number } | null }>, manufacturers: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', id: string, key: string, title: string }>, tenants: Array<{ __typename?: 'ProductSearch_SearchFilterEnum', id: string, key: string, title: string }> } | null };

export type ProductSearchQueryVariables = Exact<{
  refresh: Scalars['Boolean']['input'];
  pagination: ProductSearch_PaginationInput;
  dateRange: ProductSearch_DateRangeInput;
  geoPoint?: InputMaybe<ProductSearch_GeoPointInput>;
  enumProperties: Array<ProductSearch_EnumPropertiesInput> | ProductSearch_EnumPropertiesInput;
  rangeProperties: Array<ProductSearch_RangePropertiesInput> | ProductSearch_RangePropertiesInput;
  manufacturers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tenantKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  uriComponent: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  searchSort?: InputMaybe<ProductSearch_SearchSortInput>;
}>;


export type ProductSearchQuery = { __typename?: 'Query', ProductSearch_searchProducts?: { __typename?: 'ProductSearch_ProductSearchResponseModel', total: number, loadedDate: any, pagination: { __typename?: 'ProductSearch_PaginationModel', hasMore: boolean, currentPage: number }, products: Array<{ __typename?: 'ProductSearch_ProductModel', id: string, groupKey: string, isDeliveryPossible: boolean, hasHiddenPrice: boolean, showPrices: boolean, previewPriceInformation?: { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> } | null, productImages: Array<{ __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } }>, properties: Array<{ __typename?: 'ProductPropertyModel', isEquipment: boolean, isFact: boolean, isRolloverProperty: boolean, isVariant: boolean, key: string, value: any, descriptor: { __typename?: 'PropertyDescriptorModel', id: string, key: string, title: string, type: string, unit: string, enums: Array<{ __typename?: 'PropertyDescriptorEnumModel', key: string, id: string, title: string }> } }>, rentalStation: { __typename?: 'ProductSearch_RentalStationModel', city: string, countryCode: string, distance?: number | null, id: string, name: string, street: string, streetNumber: string, zip: string }, rentalStations: Array<{ __typename?: 'ProductSearch_RentalStationModel', id: string }>, tenant: { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } }, type: { __typename?: 'ProductSearch_ProductTypeModel', configuratorPageUrl: string, id: string, productPageUrl: string, title: string, uriComponent: string, mainCategory: { __typename?: 'CategoryModel', title: string, id: string }, manufacturer: { __typename?: 'ManufacturerModel', title: string, uriComponent: string } }, shippingOptions: { __typename?: 'ProductSearch_ShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean } }>, activeFilters: { __typename?: 'ProductSearch_ActiveFilters', radius?: number | null, sort: { __typename?: 'ProductSearch_ActiveFiltersSort', by: ProductSearch_SortOption } } } | null };

export type ProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductTypesQuery = { __typename?: 'Query', productTypes: { __typename?: 'ProductTypesList', data: Array<{ __typename?: 'ProductType', id: string, title: string, relativeUrl: string, relativeUrls: Array<{ __typename?: 'LocalizedString', locale: string, value: string }> }> } };

export type ProjectsQueryVariables = Exact<{
  pagination: PaginationArgs;
  filter?: InputMaybe<OrganizationService_FilterProjectArgs>;
}>;


export type ProjectsQuery = { __typename?: 'Query', OrganizationService_MeProjects: { __typename?: 'OrganizationService_ProjectsResponse', total: number, projects: Array<{ __typename?: 'OrganizationService_Project', id: string, name: string, externalProjectId?: string | null, addresses?: Array<{ __typename?: 'OrganizationService_Address', id: string, name: string, street: string, streetNumber: string, city: string, zipCode: string, countryCode: string, createdAt: any, geoPoint: { __typename?: 'OrganizationService_GeoPoint', latitude: number, longitude: number } }> | null }> } };

export type PropertyDescriptorsQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyDescriptorsQuery = { __typename?: 'Query', propertyDescriptors: { __typename?: 'PropertyDescriptorsList', data: Array<{ __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null }> } };

export type RelatedProductsQueryVariables = Exact<{
  categoryUriComponent: Scalars['String']['input'];
  dateRange?: InputMaybe<ProductSearch_DateRangeInput>;
  geoPoint?: InputMaybe<ProductSearch_GeoPointInput>;
}>;


export type RelatedProductsQuery = { __typename?: 'Query', ProductSearch_relatedProducts?: { __typename?: 'ProductSearch_RelatedProductsResponseModel', total: number, loadedDate: any, products: Array<{ __typename?: 'ProductSearch_ProductModel', id: string, groupKey: string, isDeliveryPossible: boolean, hasHiddenPrice: boolean, showPrices: boolean, previewPriceInformation?: { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> } | null, productImages: Array<{ __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } }>, properties: Array<{ __typename?: 'ProductPropertyModel', isEquipment: boolean, isFact: boolean, isRolloverProperty: boolean, isVariant: boolean, key: string, value: any, descriptor: { __typename?: 'PropertyDescriptorModel', id: string, key: string, title: string, type: string, unit: string, enums: Array<{ __typename?: 'PropertyDescriptorEnumModel', key: string, id: string, title: string }> } }>, rentalStation: { __typename?: 'ProductSearch_RentalStationModel', city: string, countryCode: string, distance?: number | null, id: string, name: string, street: string, streetNumber: string, zip: string }, rentalStations: Array<{ __typename?: 'ProductSearch_RentalStationModel', id: string }>, tenant: { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } }, type: { __typename?: 'ProductSearch_ProductTypeModel', configuratorPageUrl: string, id: string, productPageUrl: string, title: string, uriComponent: string, mainCategory: { __typename?: 'CategoryModel', title: string, id: string }, manufacturer: { __typename?: 'ManufacturerModel', title: string, uriComponent: string } }, shippingOptions: { __typename?: 'ProductSearch_ShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean } }> } | null };

export type RentalStationByIdQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type RentalStationByIdQuery = { __typename?: 'Query', getRentalStationByIdentifier?: { __typename?: 'CmsRentalStationModel', nonWorkingDays: Array<string>, id: string } | null };

export type RentalStationsQueryVariables = Exact<{
  params?: InputMaybe<RentalStationsParams>;
}>;


export type RentalStationsQuery = { __typename?: 'Query', rentalStations?: { __typename?: 'RentalStationsResponse', data?: Array<{ __typename?: 'RentalStation', id: string, name: string, shortName: string, zip: string, city: string, street: string, streetNumber: string, country: { __typename?: 'Country', iso2: string, name?: string | null }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, location: { __typename?: 'Location', lat: number, lng: number }, tenant: { __typename?: 'Tenant', name: string, key: string, id: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', alt: string, url: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', format: string, height: number, width: number } } } }> | null } | null };

export type ServiceInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceInfoQuery = { __typename?: 'Query', serviceInfo: { __typename?: 'ServiceInfo', name: string, version: string } };

export type RecommendedProductsItemFragment = { __typename?: 'ProductSearchItem', showPrices: boolean, hasHiddenPrices: boolean, id: string, prices: Array<{ __typename?: 'GraduatedPrice', minDays: number, price: number }>, productImage: { __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }, type: { __typename?: 'ProductType', id: string, datoId: string, title: string, text: string, uriComponent: string, productPageUrl: string, configuratorPageUrl: string, manufacturer?: { __typename?: 'Manufacturer', id: string, title: string } | null, mainCategory?: { __typename?: 'Category', id: string, title: string } | null, images: Array<{ __typename?: 'ProductTypeImage', url: string, alt: string, title: string, metadata: { __typename?: 'ProductTypeImageMetaData', format: string, width: number, height: number } }> }, rentalStation: { __typename?: 'RentalStation', id: string, name: string, tenant: { __typename?: 'Tenant', id: string, key: string, name: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } }, properties: Array<{ __typename?: 'ProductSearchProperties', key: string, value?: any | null, isFact: boolean, isVariant: boolean, isRolloverProperty: boolean, descriptor: { __typename?: 'PropertyDescriptor', id: string, key: string, type: PropertyType, title?: string | null, unit?: string | null, enums?: Array<{ __typename?: 'EnumPropertyValue', key: string, title: string, id: string }> | null } }> };

export type ProductPriceResponseFragment = { __typename?: 'PriceService_ProductPriceModel', workingDays: number, productPricePerDay: { __typename?: 'PriceService_ProductPrice', amount: number, type: PriceService_PriceAmountTypeEnum }, productPriceReducedPerDay: { __typename?: 'PriceService_ProductPrice', amount: number, type: PriceService_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'PriceService_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'PriceService_ServiceFee', key: string, value: number }> };

export type ProductCardPriceQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  dateRange: PriceService_DateRangeInput;
}>;


export type ProductCardPriceQuery = { __typename?: 'Query', PriceService_productPrice?: { __typename?: 'PriceService_ProductPriceModel', workingDays: number, productPricePerDay: { __typename?: 'PriceService_ProductPrice', amount: number, type: PriceService_PriceAmountTypeEnum }, productPriceReducedPerDay: { __typename?: 'PriceService_ProductPrice', amount: number, type: PriceService_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'PriceService_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'PriceService_ServiceFee', key: string, value: number }> } | null };

export type RecommendedProductsSliceQueryVariables = Exact<{
  countryCode?: InputMaybe<Scalars['String']['input']>;
  productTypeUriComponents: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tenantKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RecommendedProductsSliceQuery = { __typename?: 'Query', ProductSearch_recommendedProducts?: { __typename?: 'ProductSearch_RecommendedProductsResponseModel', total: number, loadedDate: any, products: Array<{ __typename?: 'ProductSearch_ProductModel', id: string, groupKey: string, isDeliveryPossible: boolean, hasHiddenPrice: boolean, showPrices: boolean, previewPriceInformation?: { __typename?: 'ProductSearch_PreviewPriceInformationModel', productPricePerDay: { __typename?: 'PriceInformationPriceModel', amount: number, type: ProductSearch_PriceAmountTypeEnum }, tierPrices: Array<{ __typename?: 'ProductSearch_TierPrice', minDays: number, price: number }>, serviceFees: Array<{ __typename?: 'ProductSearch_ServiceFee', key: string, value: number }> } | null, productImages: Array<{ __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } }>, properties: Array<{ __typename?: 'ProductPropertyModel', isEquipment: boolean, isFact: boolean, isRolloverProperty: boolean, isVariant: boolean, key: string, value: any, descriptor: { __typename?: 'PropertyDescriptorModel', id: string, key: string, title: string, type: string, unit: string, enums: Array<{ __typename?: 'PropertyDescriptorEnumModel', key: string, id: string, title: string }> } }>, rentalStation: { __typename?: 'ProductSearch_RentalStationModel', city: string, countryCode: string, distance?: number | null, id: string, name: string, street: string, streetNumber: string, zip: string }, rentalStations: Array<{ __typename?: 'ProductSearch_RentalStationModel', id: string }>, tenant: { __typename?: 'ProductSearch_TenantModel', key: string, name: string, logo: { __typename?: 'ProductSearch_ImageModel', alt: string, title: string, url: string, metadata: { __typename?: 'ImageMetaDataModel', format: string, height: number, width: number } } }, type: { __typename?: 'ProductSearch_ProductTypeModel', configuratorPageUrl: string, id: string, productPageUrl: string, title: string, uriComponent: string, mainCategory: { __typename?: 'CategoryModel', title: string, id: string }, manufacturer: { __typename?: 'ManufacturerModel', title: string, uriComponent: string } }, shippingOptions: { __typename?: 'ProductSearch_ShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean } }> } | null };

export type RentalStationsSliceQueryVariables = Exact<{
  params?: InputMaybe<RentalStationsParams>;
}>;


export type RentalStationsSliceQuery = { __typename?: 'Query', rentalStations?: { __typename?: 'RentalStationsResponse', data?: Array<{ __typename?: 'RentalStation', shortName: string, zip: string, city: string, street: string, streetNumber: string, country: { __typename?: 'Country', iso2: string }, shippingOptions: { __typename?: 'RentalStationShippingOptions', deliveryEnabled: boolean, pickupEnabled: boolean }, location: { __typename?: 'Location', lat: number, lng: number } }> | null } | null };

export type TenantByKeyQueryVariables = Exact<{
  tenantKey: Scalars['String']['input'];
}>;


export type TenantByKeyQuery = { __typename?: 'Query', tenant?: { __typename?: 'Tenant', id: string, key: string, name: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } } | null };

export type TenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantsQuery = { __typename?: 'Query', tenants: { __typename?: 'TenantsResult', data?: Array<{ __typename?: 'Tenant', id: string, key: string, name: string, digandoUrl: string, logo: { __typename?: 'TenantLogo', url: string, alt: string, title: string, metadata: { __typename?: 'TenantLogoMetaData', width: number, height: number, format: string } } }> | null } };

export type ValidateAddressesQueryVariables = Exact<{
  params: PlacesInput;
}>;


export type ValidateAddressesQuery = { __typename?: 'Query', Geolocation_validateAddresses: { __typename: 'PlacesSuggestionModel', data: Array<{ __typename?: 'PlaceSuggestionModel', id: string, name: string }> } };

export const StrapiImageFragmentDoc = gql`
    fragment StrapiImage on UploadFile {
  url
  alternativeText
  width
  height
  ext
  formats
}
    `;
export const BlogOverviewArticleFragmentDoc = gql`
    fragment BlogOverviewArticle on BlogArticleEntity {
  id
  attributes {
    title
    teaser
    slug
    publishedAt
    blogCategory {
      data {
        id
        attributes {
          title
        }
      }
    }
    header {
      image {
        data {
          attributes {
            ...StrapiImage
          }
        }
      }
    }
    snippet {
      title
      description
      image {
        data {
          attributes {
            ...StrapiImage
          }
        }
      }
    }
  }
}
    ${StrapiImageFragmentDoc}`;
export const RentalStationTenantItemFragmentDoc = gql`
    fragment RentalStationTenantItem on Tenant {
  name
  key
  id
  digandoUrl
  logo {
    alt
    url
    metadata {
      format
      height
      width
    }
    title
  }
}
    `;
export const RentalStationsItemFragmentDoc = gql`
    fragment RentalStationsItem on RentalStation {
  id
  name
  shortName
  zip
  city
  street
  streetNumber
  country {
    iso2
    name
  }
  shippingOptions {
    deliveryEnabled
    pickupEnabled
  }
  location {
    lat
    lng
  }
  tenant {
    ...RentalStationTenantItem
  }
}
    ${RentalStationTenantItemFragmentDoc}`;
export const ZoneTextWithImageFragmentDoc = gql`
    fragment ZoneTextWithImage on ComponentContentTextWithBlock {
  id
  heading
  text
  factBox(pagination: {pageSize: 100}) {
    description
    title
  }
}
    `;
export const ZoneActionButtonFragmentDoc = gql`
    fragment ZoneActionButton on ComponentContentActionButton {
  id
  buttonText
  actionType
}
    `;
export const ZoneCategoryOverviewFragmentDoc = gql`
    fragment ZoneCategoryOverview on ComponentContentCategoryOverview {
  id
  heading
  description
}
    `;
export const CtaLinkPageTypeFragmentDoc = gql`
    fragment CTALinkPageType on CTALinkEntityType {
  title
  text
  slug
  contentType
}
    `;
export const ZoneCallToActionFragmentDoc = gql`
    fragment ZoneCallToAction on ComponentContentCallToAction {
  id
  cta {
    title
    text
    ctaLinkPage {
      ...CTALinkPageType
    }
  }
  heading
  description
}
    ${CtaLinkPageTypeFragmentDoc}`;
export const ZoneContentFaqFragmentDoc = gql`
    fragment ZoneContentFaq on ComponentContentFaq {
  id
  heading
  faqs(pagination: {pageSize: 100}) {
    data {
      id
      attributes {
        answer
        question
      }
    }
  }
}
    `;
export const ZoneContentQuoteBlockFragmentDoc = gql`
    fragment ZoneContentQuoteBlock on ComponentContentQuoteBlock {
  id
  author
  quote
}
    `;
export const ZoneContentNewsletterSubscriptionFragmentDoc = gql`
    fragment ZoneContentNewsletterSubscription on ComponentContentNewsletterSubscription {
  id
  description
  heading
}
    `;
export const ZoneContentContactSectionFragmentDoc = gql`
    fragment ZoneContentContactSection on ComponentContentContactSection {
  id
  heading
  contacts(sort: [], pagination: {pageSize: 100}) {
    data {
      id
      attributes {
        position
        firstName
        lastName
        position
        email
        phone
        picture {
          data {
            attributes {
              ...StrapiImage
            }
          }
        }
      }
    }
  }
}
    ${StrapiImageFragmentDoc}`;
export const ZoneContentRecommendedCategoriesFragmentDoc = gql`
    fragment ZoneContentRecommendedCategories on ComponentContentRecommendedCategories {
  id
  tenantKey
  recommendedCategoryTitle
  categories(pagination: {pageSize: 100}) {
    id
    title
    products {
      id
      uriComponent
    }
  }
}
    `;
export const ZoneContentHubspotFormFragmentDoc = gql`
    fragment ZoneContentHubspotForm on ComponentContentHubspotForm {
  id
  hubspotFormId
  hubspotPortalId
  heading
}
    `;
export const ZoneContentImagePresentationFragmentDoc = gql`
    fragment ZoneContentImagePresentation on ComponentContentImagePresentation {
  id
  images {
    id
    image {
      data {
        attributes {
          ...StrapiImage
        }
      }
    }
    title
  }
}
    ${StrapiImageFragmentDoc}`;
export const ZoneContentPrivacySettingsFragmentDoc = gql`
    fragment ZoneContentPrivacySettings on ComponentContentPrivacySettings {
  id
}
    `;
export const ZoneContentTenantLogosFragmentDoc = gql`
    fragment ZoneContentTenantLogos on ComponentContentTenantLogos {
  id
  heading
  tenants(pagination: {pageSize: 100}) {
    id
    logo {
      data {
        attributes {
          ...StrapiImage
        }
      }
    }
    tenant {
      data {
        attributes {
          slug
          title
        }
      }
    }
  }
}
    ${StrapiImageFragmentDoc}`;
export const ZoneContentTestimonialsFragmentDoc = gql`
    fragment ZoneContentTestimonials on ComponentContentTestimonials {
  id
  heading
  testimonials(pagination: {pageSize: 100}) {
    authorCompany
    authorName
    authorRole
    text
  }
}
    `;
export const ZoneContentTextWithImageFragmentDoc = gql`
    fragment ZoneContentTextWithImage on ComponentContentTextWithImage {
  id
  transparentBackground
  heading
  transparentBackground
  description
  imagePosition
  image {
    data {
      attributes {
        ...StrapiImage
      }
    }
  }
  cta {
    ctaLinkPage {
      ...CTALinkPageType
    }
    title
    text
  }
}
    ${StrapiImageFragmentDoc}
${CtaLinkPageTypeFragmentDoc}`;
export const ZoneContentUspCardsFragmentDoc = gql`
    fragment ZoneContentUspCards on ComponentContentUspCards {
  id
  heading
  usps(pagination: {pageSize: 100}) {
    title
    description
    icon {
      data {
        attributes {
          ...StrapiImage
        }
      }
    }
  }
}
    ${StrapiImageFragmentDoc}`;
export const ZoneContentUspDigandoFragmentDoc = gql`
    fragment ZoneContentUspDigando on ComponentContentUspDigando {
  id
  usps(pagination: {pageSize: 100}) {
    id
    advantage
  }
}
    `;
export const ZoneContentYoutubeVideoFragmentDoc = gql`
    fragment ZoneContentYoutubeVideo on ComponentContentYoutubeVideo {
  id
  youtubeLink
}
    `;
export const ZoneContentSearchBoxFragmentDoc = gql`
    fragment ZoneContentSearchBox on ComponentContentSearchBox {
  id
  title
  tenantKey
}
    `;
export const InternalLinkPageTypeFragmentDoc = gql`
    fragment InternalLinkPageType on InternalLinkEntityType {
  title
  description
  image {
    attributes {
      ...StrapiImage
    }
  }
  slug
  readMoreLinkText
  readMoreLinkTitle
  contentType
  tenantKey
}
    ${StrapiImageFragmentDoc}`;
export const ZoneContentOnBoardingFragmentDoc = gql`
    fragment ZoneContentOnBoarding on ComponentContentOnBoarding {
  id
  items(pagination: {pageSize: 100}) {
    id
    title
    description
    cta {
      title
      text
      ctaLinkPage {
        ...CTALinkPageType
      }
    }
    internalLinks {
      internalLinkPage {
        ...InternalLinkPageType
      }
    }
  }
}
    ${CtaLinkPageTypeFragmentDoc}
${InternalLinkPageTypeFragmentDoc}`;
export const ZoneContentTextWithLinkFragmentDoc = gql`
    fragment ZoneContentTextWithLink on ComponentContentTextWithLink {
  id
  heading
  description
  linkText
  page {
    data {
      attributes {
        slug
      }
    }
  }
}
    `;
export const ZoneContentUspProductFragmentDoc = gql`
    fragment ZoneContentUspProduct on ComponentContentUspProduct {
  id
  usps(pagination: {pageSize: 100}) {
    id
    advantage
  }
}
    `;
export const ZoneContentRentalStationsFragmentDoc = gql`
    fragment ZoneContentRentalStations on ComponentContentRentalStations {
  id
  tenantKey
  image {
    data {
      attributes {
        ...StrapiImage
      }
    }
  }
}
    ${StrapiImageFragmentDoc}`;
export const ZoneContentInternalLinksFragmentDoc = gql`
    fragment ZoneContentInternalLinks on ComponentContentInternalLinks {
  id
  heading
  internalLinks(pagination: {pageSize: 100}) {
    internalLinkPage {
      ...InternalLinkPageType
    }
  }
}
    ${InternalLinkPageTypeFragmentDoc}`;
export const AllZonesFragmentDoc = gql`
    fragment AllZones on GenericMorph {
  ... on ComponentContentTextWithBlock {
    ...ZoneTextWithImage
  }
  ... on ComponentContentActionButton {
    ...ZoneActionButton
  }
  ... on ComponentContentCategoryOverview {
    ...ZoneCategoryOverview
  }
  ... on ComponentContentCallToAction {
    ...ZoneCallToAction
  }
  ... on ComponentContentFaq {
    ...ZoneContentFaq
  }
  ... on ComponentContentQuoteBlock {
    ...ZoneContentQuoteBlock
  }
  ... on ComponentContentNewsletterSubscription {
    ...ZoneContentNewsletterSubscription
  }
  ... on ComponentContentContactSection {
    ...ZoneContentContactSection
  }
  ... on ComponentContentRecommendedCategories {
    ...ZoneContentRecommendedCategories
  }
  ... on ComponentContentHubspotForm {
    ...ZoneContentHubspotForm
  }
  ... on ComponentContentImagePresentation {
    ...ZoneContentImagePresentation
  }
  ... on ComponentContentPrivacySettings {
    ...ZoneContentPrivacySettings
  }
  ... on ComponentContentTenantLogos {
    ...ZoneContentTenantLogos
  }
  ... on ComponentContentTestimonials {
    ...ZoneContentTestimonials
  }
  ... on ComponentContentTextWithImage {
    ...ZoneContentTextWithImage
  }
  ... on ComponentContentUspCards {
    ...ZoneContentUspCards
  }
  ... on ComponentContentUspDigando {
    ...ZoneContentUspDigando
  }
  ... on ComponentContentYoutubeVideo {
    ...ZoneContentYoutubeVideo
  }
  ... on ComponentContentSearchBox {
    ...ZoneContentSearchBox
  }
  ... on ComponentContentOnBoarding {
    ...ZoneContentOnBoarding
  }
  ... on ComponentContentTextWithLink {
    ...ZoneContentTextWithLink
  }
  ... on ComponentContentUspProduct {
    ...ZoneContentUspProduct
  }
  ... on ComponentContentRentalStations {
    ...ZoneContentRentalStations
  }
  ... on ComponentContentInternalLinks {
    ...ZoneContentInternalLinks
  }
}
    ${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}`;
export const SeoComponentFragmentDoc = gql`
    fragment seoComponent on ComponentHelperSeo {
  title
  description
  image {
    data {
      attributes {
        ...StrapiImage
      }
    }
  }
  hideFromSidebarAndIndex
}
    ${StrapiImageFragmentDoc}`;
export const SnippetComponentFragmentDoc = gql`
    fragment snippetComponent on ComponentHelperSnippet {
  title
  description
  image {
    data {
      attributes {
        ...StrapiImage
      }
    }
  }
}
    ${StrapiImageFragmentDoc}`;
export const BasketPageResponseFragmentDoc = gql`
    fragment BasketPageResponse on BasketPageEntity {
  attributes {
    title
    createdAt
    updatedAt
    seo {
      ...seoComponent
    }
    snippet {
      ...snippetComponent
    }
    content {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentQuoteBlock {
        ...ZoneContentQuoteBlock
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentRecommendedCategories {
        ...ZoneContentRecommendedCategories
      }
      ... on ComponentContentHubspotForm {
        ...ZoneContentHubspotForm
      }
      ... on ComponentContentImagePresentation {
        ...ZoneContentImagePresentation
      }
      ... on ComponentContentPrivacySettings {
        ...ZoneContentPrivacySettings
      }
      ... on ComponentContentTenantLogos {
        ...ZoneContentTenantLogos
      }
      ... on ComponentContentTestimonials {
        ...ZoneContentTestimonials
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentYoutubeVideo {
        ...ZoneContentYoutubeVideo
      }
      ... on ComponentContentSearchBox {
        ...ZoneContentSearchBox
      }
      ... on ComponentContentOnBoarding {
        ...ZoneContentOnBoarding
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentUspProduct {
        ...ZoneContentUspProduct
      }
      ... on ComponentContentRentalStations {
        ...ZoneContentRentalStations
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
  }
}
    ${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}`;
export const BlogArticleResponseFragmentDoc = gql`
    fragment BlogArticleResponse on BlogArticleEntity {
  attributes {
    locale
    localizations {
      data {
        attributes {
          locale
          slug
        }
      }
    }
    title
    slug
    publishedAt
    articleCreatedAt
    createdAt
    updatedAt
    seo {
      ...seoComponent
    }
    snippet {
      ...snippetComponent
    }
    content {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentQuoteBlock {
        ...ZoneContentQuoteBlock
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentRecommendedCategories {
        ...ZoneContentRecommendedCategories
      }
      ... on ComponentContentHubspotForm {
        ...ZoneContentHubspotForm
      }
      ... on ComponentContentImagePresentation {
        ...ZoneContentImagePresentation
      }
      ... on ComponentContentPrivacySettings {
        ...ZoneContentPrivacySettings
      }
      ... on ComponentContentTenantLogos {
        ...ZoneContentTenantLogos
      }
      ... on ComponentContentTestimonials {
        ...ZoneContentTestimonials
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentYoutubeVideo {
        ...ZoneContentYoutubeVideo
      }
      ... on ComponentContentSearchBox {
        ...ZoneContentSearchBox
      }
      ... on ComponentContentOnBoarding {
        ...ZoneContentOnBoarding
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentUspProduct {
        ...ZoneContentUspProduct
      }
      ... on ComponentContentRentalStations {
        ...ZoneContentRentalStations
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
    teaser
    author {
      data {
        attributes {
          name
          jobTitle
          description
          avatar {
            data {
              attributes {
                ...StrapiImage
              }
            }
          }
        }
      }
    }
    header {
      image {
        data {
          attributes {
            ...StrapiImage
          }
        }
      }
    }
  }
}
    ${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}
${StrapiImageFragmentDoc}`;
export const ConfiguratorPageResponseFragmentDoc = gql`
    fragment ConfiguratorPageResponse on ConfiguratorPageEntity {
  attributes {
    createdAt
    updatedAt
    content {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
  }
}
    ${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}`;
export const HelperDigandoCategorySelectorFragmentDoc = gql`
    fragment HelperDigandoCategorySelector on ComponentHelperDigandoCategorySelector {
  id
  slug
}
    `;
export const ZonePopularCategoriesFragmentDoc = gql`
    fragment ZonePopularCategories on ComponentContentPopularCategories {
  id
  title
  categories {
    ...HelperDigandoCategorySelector
  }
}
    ${HelperDigandoCategorySelectorFragmentDoc}`;
export const ErrorPageResponseFragmentDoc = gql`
    fragment ErrorPageResponse on ErrorPageEntity {
  attributes {
    publishedAt
    createdAt
    updatedAt
    popularCategories {
      ...ZonePopularCategories
    }
  }
}
    ${ZonePopularCategoriesFragmentDoc}`;
export const HomepageResponseFragmentDoc = gql`
    fragment HomepageResponse on HomepageEntity {
  attributes {
    locale
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
    createdAt
    updatedAt
    seo {
      ...seoComponent
    }
    snippet {
      ...snippetComponent
    }
    content {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentQuoteBlock {
        ...ZoneContentQuoteBlock
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentRecommendedCategories {
        ...ZoneContentRecommendedCategories
      }
      ... on ComponentContentHubspotForm {
        ...ZoneContentHubspotForm
      }
      ... on ComponentContentImagePresentation {
        ...ZoneContentImagePresentation
      }
      ... on ComponentContentPrivacySettings {
        ...ZoneContentPrivacySettings
      }
      ... on ComponentContentTenantLogos {
        ...ZoneContentTenantLogos
      }
      ... on ComponentContentTestimonials {
        ...ZoneContentTestimonials
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentYoutubeVideo {
        ...ZoneContentYoutubeVideo
      }
      ... on ComponentContentSearchBox {
        ...ZoneContentSearchBox
      }
      ... on ComponentContentOnBoarding {
        ...ZoneContentOnBoarding
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentUspProduct {
        ...ZoneContentUspProduct
      }
      ... on ComponentContentRentalStations {
        ...ZoneContentRentalStations
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
    title
    header {
      maxBrowserWidth
      image {
        data {
          attributes {
            ...StrapiImage
          }
        }
      }
    }
    popularCategories {
      ...ZonePopularCategories
    }
  }
}
    ${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}
${StrapiImageFragmentDoc}
${ZonePopularCategoriesFragmentDoc}`;
export const JobOverviewResponseFragmentDoc = gql`
    fragment JobOverviewResponse on JobOverview {
  locale
  localizations {
    data {
      attributes {
        locale
      }
    }
  }
  title
  createdAt
  updatedAt
  seo {
    ...seoComponent
  }
  snippet {
    ...snippetComponent
  }
  content {
    ... on ComponentContentTextWithBlock {
      ...ZoneTextWithImage
    }
    ... on ComponentContentActionButton {
      ...ZoneActionButton
    }
    ... on ComponentContentCategoryOverview {
      ...ZoneCategoryOverview
    }
    ... on ComponentContentCallToAction {
      ...ZoneCallToAction
    }
    ... on ComponentContentFaq {
      ...ZoneContentFaq
    }
    ... on ComponentContentQuoteBlock {
      ...ZoneContentQuoteBlock
    }
    ... on ComponentContentNewsletterSubscription {
      ...ZoneContentNewsletterSubscription
    }
    ... on ComponentContentContactSection {
      ...ZoneContentContactSection
    }
    ... on ComponentContentRecommendedCategories {
      ...ZoneContentRecommendedCategories
    }
    ... on ComponentContentHubspotForm {
      ...ZoneContentHubspotForm
    }
    ... on ComponentContentImagePresentation {
      ...ZoneContentImagePresentation
    }
    ... on ComponentContentPrivacySettings {
      ...ZoneContentPrivacySettings
    }
    ... on ComponentContentTenantLogos {
      ...ZoneContentTenantLogos
    }
    ... on ComponentContentTestimonials {
      ...ZoneContentTestimonials
    }
    ... on ComponentContentTextWithImage {
      ...ZoneContentTextWithImage
    }
    ... on ComponentContentUspCards {
      ...ZoneContentUspCards
    }
    ... on ComponentContentUspDigando {
      ...ZoneContentUspDigando
    }
    ... on ComponentContentYoutubeVideo {
      ...ZoneContentYoutubeVideo
    }
    ... on ComponentContentSearchBox {
      ...ZoneContentSearchBox
    }
    ... on ComponentContentOnBoarding {
      ...ZoneContentOnBoarding
    }
    ... on ComponentContentTextWithLink {
      ...ZoneContentTextWithLink
    }
    ... on ComponentContentUspProduct {
      ...ZoneContentUspProduct
    }
    ... on ComponentContentRentalStations {
      ...ZoneContentRentalStations
    }
    ... on ComponentContentInternalLinks {
      ...ZoneContentInternalLinks
    }
  }
  header {
    image {
      data {
        attributes {
          ...StrapiImage
        }
      }
    }
  }
}
    ${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}
${StrapiImageFragmentDoc}`;
export const JobResponseFragmentDoc = gql`
    fragment JobResponse on JobEntity {
  attributes {
    locale
    localizations {
      data {
        attributes {
          locale
          slug
        }
      }
    }
    title
    slug
    publishedAt
    createdAt
    updatedAt
    seo {
      ...seoComponent
    }
    snippet {
      ...snippetComponent
    }
    content {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentQuoteBlock {
        ...ZoneContentQuoteBlock
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentRecommendedCategories {
        ...ZoneContentRecommendedCategories
      }
      ... on ComponentContentHubspotForm {
        ...ZoneContentHubspotForm
      }
      ... on ComponentContentImagePresentation {
        ...ZoneContentImagePresentation
      }
      ... on ComponentContentPrivacySettings {
        ...ZoneContentPrivacySettings
      }
      ... on ComponentContentTenantLogos {
        ...ZoneContentTenantLogos
      }
      ... on ComponentContentTestimonials {
        ...ZoneContentTestimonials
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentYoutubeVideo {
        ...ZoneContentYoutubeVideo
      }
      ... on ComponentContentSearchBox {
        ...ZoneContentSearchBox
      }
      ... on ComponentContentOnBoarding {
        ...ZoneContentOnBoarding
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentUspProduct {
        ...ZoneContentUspProduct
      }
      ... on ComponentContentRentalStations {
        ...ZoneContentRentalStations
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
    header {
      image {
        data {
          attributes {
            ...StrapiImage
          }
        }
      }
    }
  }
}
    ${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}
${StrapiImageFragmentDoc}`;
export const NavigationLinkFragmentDoc = gql`
    fragment NavigationLink on ComponentHelperNavigationLink {
  id
  text
  navigationLinkPage {
    text
    slug
    contentType
  }
}
    `;
export const ProductPageResponseFragmentDoc = gql`
    fragment ProductPageResponse on ProductPageEntity {
  attributes {
    locale
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
    createdAt
    updatedAt
    benefits {
      benefit
    }
    seo {
      ...seoComponent
    }
    snippet {
      ...snippetComponent
    }
    content {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentUspProduct {
        ...ZoneContentUspProduct
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
  }
}
    ${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}`;
export const SearchPageResponseFragmentDoc = gql`
    fragment SearchPageResponse on SearchPageEntity {
  attributes {
    locale
    localizations {
      data {
        attributes {
          locale
          slug
        }
      }
    }
    title
    slug
    slugSelector {
      slug
    }
    searchLocation {
      data {
        attributes {
          title
          slug
        }
      }
    }
    publishedAt
    createdAt
    updatedAt
    headerImage {
      data {
        attributes {
          ...StrapiImage
        }
      }
    }
    seo {
      ...seoComponent
    }
    snippet {
      ...snippetComponent
    }
    contentTop {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentQuoteBlock {
        ...ZoneContentQuoteBlock
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentRecommendedCategories {
        ...ZoneContentRecommendedCategories
      }
      ... on ComponentContentHubspotForm {
        ...ZoneContentHubspotForm
      }
      ... on ComponentContentImagePresentation {
        ...ZoneContentImagePresentation
      }
      ... on ComponentContentPrivacySettings {
        ...ZoneContentPrivacySettings
      }
      ... on ComponentContentTenantLogos {
        ...ZoneContentTenantLogos
      }
      ... on ComponentContentTestimonials {
        ...ZoneContentTestimonials
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentYoutubeVideo {
        ...ZoneContentYoutubeVideo
      }
      ... on ComponentContentSearchBox {
        ...ZoneContentSearchBox
      }
      ... on ComponentContentOnBoarding {
        ...ZoneContentOnBoarding
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentUspProduct {
        ...ZoneContentUspProduct
      }
      ... on ComponentContentRentalStations {
        ...ZoneContentRentalStations
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
    contentBottom {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentQuoteBlock {
        ...ZoneContentQuoteBlock
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentSearchBox {
        ...ZoneContentSearchBox
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
  }
}
    ${StrapiImageFragmentDoc}
${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}`;
export const BlogArticleSitemapResponseFragmentDoc = gql`
    fragment BlogArticleSitemapResponse on BlogArticleEntityResponseCollection {
  data {
    attributes {
      slug
      seo {
        hideFromSidebarAndIndex
      }
    }
  }
  meta {
    pagination {
      total
    }
  }
}
    `;
export const JobSitemapResponseFragmentDoc = gql`
    fragment JobSitemapResponse on JobEntityResponseCollection {
  data {
    attributes {
      slug
      seo {
        hideFromSidebarAndIndex
      }
    }
  }
  meta {
    pagination {
      total
    }
  }
}
    `;
export const SearchSitemapResponseFragmentDoc = gql`
    fragment SearchSitemapResponse on SearchPageEntityResponseCollection {
  data {
    attributes {
      slug
      seo {
        hideFromSidebarAndIndex
      }
    }
  }
  meta {
    pagination {
      total
    }
  }
}
    `;
export const StandartSitemapResponseFragmentDoc = gql`
    fragment StandartSitemapResponse on StandardPageEntityResponseCollection {
  data {
    attributes {
      slug
      seo {
        hideFromSidebarAndIndex
      }
    }
  }
  meta {
    pagination {
      total
    }
  }
}
    `;
export const TenantSitemapResponseFragmentDoc = gql`
    fragment TenantSitemapResponse on TenantPageEntityResponseCollection {
  data {
    attributes {
      slug
      seo {
        hideFromSidebarAndIndex
      }
    }
  }
  meta {
    pagination {
      total
    }
  }
}
    `;
export const StandardPageResponseFragmentDoc = gql`
    fragment StandardPageResponse on StandardPageEntity {
  attributes {
    locale
    localizations {
      data {
        attributes {
          locale
          slug
        }
      }
    }
    title
    slug
    publishedAt
    createdAt
    updatedAt
    seo {
      ...seoComponent
    }
    snippet {
      ...snippetComponent
    }
    content {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentQuoteBlock {
        ...ZoneContentQuoteBlock
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentRecommendedCategories {
        ...ZoneContentRecommendedCategories
      }
      ... on ComponentContentHubspotForm {
        ...ZoneContentHubspotForm
      }
      ... on ComponentContentImagePresentation {
        ...ZoneContentImagePresentation
      }
      ... on ComponentContentPrivacySettings {
        ...ZoneContentPrivacySettings
      }
      ... on ComponentContentTenantLogos {
        ...ZoneContentTenantLogos
      }
      ... on ComponentContentTestimonials {
        ...ZoneContentTestimonials
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentYoutubeVideo {
        ...ZoneContentYoutubeVideo
      }
      ... on ComponentContentSearchBox {
        ...ZoneContentSearchBox
      }
      ... on ComponentContentOnBoarding {
        ...ZoneContentOnBoarding
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentUspProduct {
        ...ZoneContentUspProduct
      }
      ... on ComponentContentRentalStations {
        ...ZoneContentRentalStations
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
    header {
      image {
        data {
          attributes {
            ...StrapiImage
          }
        }
      }
    }
  }
}
    ${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}
${StrapiImageFragmentDoc}`;
export const TenantPageResponseFragmentDoc = gql`
    fragment TenantPageResponse on TenantPageEntity {
  attributes {
    locale
    localizations {
      data {
        attributes {
          locale
          slug
        }
      }
    }
    title
    slug
    publishedAt
    createdAt
    updatedAt
    seo {
      ...seoComponent
    }
    snippet {
      ...snippetComponent
    }
    content {
      ... on ComponentContentTextWithBlock {
        ...ZoneTextWithImage
      }
      ... on ComponentContentActionButton {
        ...ZoneActionButton
      }
      ... on ComponentContentCategoryOverview {
        ...ZoneCategoryOverview
      }
      ... on ComponentContentCallToAction {
        ...ZoneCallToAction
      }
      ... on ComponentContentFaq {
        ...ZoneContentFaq
      }
      ... on ComponentContentQuoteBlock {
        ...ZoneContentQuoteBlock
      }
      ... on ComponentContentNewsletterSubscription {
        ...ZoneContentNewsletterSubscription
      }
      ... on ComponentContentContactSection {
        ...ZoneContentContactSection
      }
      ... on ComponentContentRecommendedCategories {
        ...ZoneContentRecommendedCategories
      }
      ... on ComponentContentHubspotForm {
        ...ZoneContentHubspotForm
      }
      ... on ComponentContentImagePresentation {
        ...ZoneContentImagePresentation
      }
      ... on ComponentContentPrivacySettings {
        ...ZoneContentPrivacySettings
      }
      ... on ComponentContentTenantLogos {
        ...ZoneContentTenantLogos
      }
      ... on ComponentContentTestimonials {
        ...ZoneContentTestimonials
      }
      ... on ComponentContentTextWithImage {
        ...ZoneContentTextWithImage
      }
      ... on ComponentContentUspCards {
        ...ZoneContentUspCards
      }
      ... on ComponentContentUspDigando {
        ...ZoneContentUspDigando
      }
      ... on ComponentContentYoutubeVideo {
        ...ZoneContentYoutubeVideo
      }
      ... on ComponentContentSearchBox {
        ...ZoneContentSearchBox
      }
      ... on ComponentContentOnBoarding {
        ...ZoneContentOnBoarding
      }
      ... on ComponentContentTextWithLink {
        ...ZoneContentTextWithLink
      }
      ... on ComponentContentUspProduct {
        ...ZoneContentUspProduct
      }
      ... on ComponentContentRentalStations {
        ...ZoneContentRentalStations
      }
      ... on ComponentContentInternalLinks {
        ...ZoneContentInternalLinks
      }
    }
    tenantKey
    header {
      title
      subtitle
      description
      facts {
        key
        value
      }
      image {
        data {
          attributes {
            ...StrapiImage
          }
        }
      }
    }
    searchBox {
      title
      tenantKey
    }
  }
}
    ${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}
${StrapiImageFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on OrganizationService_Address {
  id
  name
  street
  streetNumber
  zipCode
  city
  countryCode
  createdAt
}
    `;
export const BookingServiceBookingDetailFragmentDoc = gql`
    fragment BookingServiceBookingDetail on BookingService_Booking {
  id
  state
  created
  deliveryTime
  dateRange {
    start
    end
  }
  price {
    amount
    currency
  }
  product {
    effectiveNonWorkingDays
    minimumRentalPeriodDays
    minimumRentalPeriodEndDate
  }
  productType {
    id
    title
    hasManagedStock
    manufacturer {
      title
      id
    }
    configuratorPageUrl
  }
  rentalStation {
    identifier
    name
    address {
      street
      streetNumber
      zipCode
      city
      countryCode
    }
  }
  tenant {
    name
    key
    logo {
      url
      alt
      title
      metadata {
        width
        height
        format
      }
    }
  }
  project {
    id
    name
    externalProjectId
  }
  renter {
    firstName
    lastName
  }
  actions {
    readOnly
    canBeCanceled
    canBeEnd
    canBeUpdated {
      possible
      startDate
      endDate
    }
  }
  note
  billingAddress {
    name
    streetNumber
    street
    zipCode
    city
    countryCode
  }
  priceSnapshot {
    final {
      amount
    }
    insurance {
      amount
    }
    discount {
      amount
    }
    tax {
      amount
    }
    accessoriesPrice {
      amount
    }
    shipping {
      amount
    }
    productAmount
    workingDays
    serviceFees {
      key
      value
    }
  }
  coupons {
    discount {
      amount
      percent
      type
    }
    code
  }
  accessories {
    title
    identifier
    quantity
    totalPrice
  }
  productProperties {
    key
    value {
      value
      title
    }
    descriptor {
      title
    }
    isVariant
  }
  shipping {
    ... on BookingService_BookingShippingDelivery {
      type
      rentalStation {
        identifier
        name
        identifier
        address {
          street
          streetNumber
          zipCode
          city
          countryCode
        }
      }
      destination {
        id
        address {
          name
          street
          streetNumber
          zipCode
          city
          countryCode
        }
      }
    }
    ... on BookingService_BookingShippingPickup {
      type
      rentalStation {
        identifier
        name
        identifier
        address {
          street
          streetNumber
          zipCode
          city
          countryCode
        }
      }
    }
  }
}
    `;
export const CouponFragmentDoc = gql`
    fragment Coupon on DiscountObject {
  code
  discount {
    type
    amount {
      value
    }
    percent {
      value
    }
  }
}
    `;
export const TenantLogoFragmentDoc = gql`
    fragment TenantLogo on TenantLogo {
  url
  alt
  title
  metadata {
    width
    height
    format
  }
}
    `;
export const RentalStationFragmentDoc = gql`
    fragment RentalStation on RentalStation {
  id
  name
  shortName
  location {
    lng
    lat
  }
  street
  streetNumber
  city
  zip
  country {
    iso2
    name
  }
  shippingOptions {
    deliveryEnabled
    pickupEnabled
  }
  openingHours
  tenant {
    key
    name
    tenantInsuranceMode
    logo {
      ...TenantLogo
    }
  }
}
    ${TenantLogoFragmentDoc}`;
export const BasketItemPropertyFragmentDoc = gql`
    fragment BasketItemProperty on Property {
  value
  key
  title
  isVariant
  descriptor {
    title
  }
}
    `;
export const CartItemFragmentDoc = gql`
    fragment CartItem on CartItem {
  id
  accessoriesPrice
  price
  insurance
  note
  discount
  deposit
  coupon {
    ...Coupon
  }
  errors
  shipping {
    ... on ShippingDelivery {
      costs
      destination {
        id
        name
        street
        streetNumber
        zip
        city
        country
      }
      rentalStation {
        ...RentalStation
      }
    }
    ... on ShippingPickup {
      rentalStation {
        ...RentalStation
      }
    }
  }
  workingDays
  productAmount
  accessories {
    title
    quantity
    totalPrice
    price
    quantity
    accessoryType {
      identifier
    }
  }
  serviceFees {
    key
    value
  }
  dateRange {
    start
    end
  }
  deliveryTime
  attachedFileUrl
  properties {
    ...BasketItemProperty
  }
  productType {
    id
    title
    configuratorPageUrl
    hasManagedStock
    manufacturer {
      id
      title
    }
    mainCategory {
      id
      title
    }
  }
  rentalStation {
    id
    name
    streetNumber
    street
    city
    tenant {
      name
      logo {
        ...TenantLogo
      }
    }
  }
  billingAddressInfo
  projectInfo
  tradeNumber
}
    ${CouponFragmentDoc}
${RentalStationFragmentDoc}
${BasketItemPropertyFragmentDoc}
${TenantLogoFragmentDoc}`;
export const CartDetailsFragmentDoc = gql`
    fragment CartDetails on Cart {
  id
  discount
  totalPrice
  finalPrice
  insurance
  rentalTax
  isActive
  deposit
  coupon {
    ...Coupon
  }
  items {
    ...CartItem
  }
  actions {
    canBeBooked
  }
}
    ${CouponFragmentDoc}
${CartItemFragmentDoc}`;
export const DeliveryDestinationFragmentDoc = gql`
    fragment DeliveryDestination on DeliveryDestination {
  id
  street
  streetNumber
  zip
  city
  country
}
    `;
export const CategoryFragmentDoc = gql`
    fragment Category on Category {
  id
  title
  searchTitle
  uriComponent
  originalUriComponent
  relativeUrl
  categoryRecommended
  image {
    alt
    url
  }
  parent {
    id
    title
    relativeUrl
  }
}
    `;
export const CategoryTreeFragmentDoc = gql`
    fragment CategoryTree on Category {
  id
  ...Category
  children {
    ...Category
    children {
      ...Category
    }
  }
}
    ${CategoryFragmentDoc}`;
export const CategoriesResponseFragmentDoc = gql`
    fragment CategoriesResponse on CategoriesList {
  data {
    ...CategoryTree
  }
  total
}
    ${CategoryTreeFragmentDoc}`;
export const MeDetailsFragmentDoc = gql`
    fragment MeDetails on KeycloakUser_GetKeycloakUserResponse {
  id
  lastName
  firstName
  email
  phone
  gender
}
    `;
export const OrganizationResponseFragmentDoc = gql`
    fragment OrganizationResponse on OrganizationService_Organization {
  id
  name
  street
  streetNumber
  city
  zipCode
  streetNumber
  countryCode
  createdAt
}
    `;
export const ProductBundleAccessoriesFragmentDoc = gql`
    fragment ProductBundleAccessories on ProductAccessory {
  accessoryType {
    id: identifier
  }
  title
  isPreselected
  forcePayment
  images {
    id: url
    url
    alt
    title
  }
  priceType
  tierPrices {
    price
  }
  wearPartPrice
  price
}
    `;
export const ProductTypeImageFragmentDoc = gql`
    fragment ProductTypeImage on ProductTypeImage {
  url
  alt
  title
  metadata {
    format
    width
    height
  }
}
    `;
export const PropertyDescriptorFragmentDoc = gql`
    fragment PropertyDescriptor on PropertyDescriptor {
  id
  key
  type
  title
  unit
  enums {
    id: key
    key
    title
  }
}
    `;
export const ProductPropertyFragmentDoc = gql`
    fragment ProductProperty on ProductBundleProperty {
  key
  values
  isFact
  isVariant
  isEquipment
  isRolloverProperty
  descriptor {
    ...PropertyDescriptor
  }
}
    ${PropertyDescriptorFragmentDoc}`;
export const ProductBundleDetailFragmentDoc = gql`
    fragment ProductBundleDetail on ProductBundle {
  type {
    id
    title
    text
    productPageUrl
    configuratorPageUrl
    manufacturer {
      id
      title
    }
    mainCategory {
      id
      relativeUrl
      title
      parent {
        title
        relativeUrl
      }
    }
    images {
      ...ProductTypeImage
    }
  }
  properties {
    ...ProductProperty
  }
  priceInformation {
    productPricePerDay {
      amount
    }
  }
  prices {
    minDays
    price
  }
  availableProducts
}
    ${ProductTypeImageFragmentDoc}
${ProductPropertyFragmentDoc}`;
export const ProductBundleRelatedProductsFragmentDoc = gql`
    fragment ProductBundleRelatedProducts on ProductBundle {
  type {
    id
    title
    uriComponent
    images {
      ...ProductTypeImage
    }
  }
  priceInformation {
    productPricePerDay {
      type
      amount
    }
    productPriceReducedPerDay {
      type
      amount
    }
  }
}
    ${ProductTypeImageFragmentDoc}`;
export const ProductBundleFragmentDoc = gql`
    fragment ProductBundle on ProductBundle {
  type {
    id
    title
    productPageUrl
    configuratorPageUrl
    manufacturer {
      id
      title
    }
    mainCategory {
      id
      uriComponent
      relativeUrl
      title
      parent {
        title
        relativeUrl
      }
    }
    images {
      ...ProductTypeImage
    }
    hasManagedStock
  }
  prices {
    minDays
    price
  }
  properties {
    ...ProductProperty
  }
  rentalStations {
    ...RentalStation
    nonWorkingDays
  }
  selectedRentalStation {
    ...RentalStation
    nonWorkingDays
    minimumRentalPeriodDays
    minimumRentalPeriodEndDate
    location {
      lat
      lng
      distance(referenceLocation: $location)
    }
  }
  selectedProduct {
    includedAccessoriesAmount
    currentStock
    productImages {
      ...ProductTypeImage
    }
  }
  rentInformation {
    earliestStartDate
    additionHours
  }
  deliveryRentalStations {
    ...RentalStation
  }
}
    ${ProductTypeImageFragmentDoc}
${ProductPropertyFragmentDoc}
${RentalStationFragmentDoc}`;
export const FullProductBundleResponseFragmentDoc = gql`
    fragment FullProductBundleResponse on ProductBundle {
  type {
    id
  }
  shippingOptions {
    pickupEnabled
    deliveryEnabled
  }
  rentalStations {
    ...RentalStation
    location {
      lat
      lng
      distance(referenceLocation: $location)
    }
  }
  pickupRentalStations {
    ...RentalStation
  }
  rentalStationsDistances {
    id
    distance
  }
}
    ${RentalStationFragmentDoc}`;
export const ProductTypeFragmentDoc = gql`
    fragment ProductType on ProductType {
  id
  title
  productPageUrl
  configuratorPageUrl
  importAsUriComponent
  manufacturer {
    id
    title
  }
  images {
    ...ProductTypeImage
  }
  mainCategory {
    id
    title
  }
  isTopSuggestion
  hasManagedStock
}
    ${ProductTypeImageFragmentDoc}`;
export const PropertyDescriptorsResponseFragmentDoc = gql`
    fragment PropertyDescriptorsResponse on PropertyDescriptorsList {
  data {
    ...PropertyDescriptor
  }
}
    ${PropertyDescriptorFragmentDoc}`;
export const RentalStationCompactFragmentDoc = gql`
    fragment RentalStationCompact on RentalStation {
  id
  name
  shortName
  location {
    lng
    lat
  }
  street
  streetNumber
  city
  zip
  country {
    iso2
    name
  }
  shippingOptions {
    deliveryEnabled
    pickupEnabled
  }
  openingHours
  tenant {
    key
    name
    tenantInsuranceMode
    digandoUrl
    logo {
      ...TenantLogo
    }
  }
}
    ${TenantLogoFragmentDoc}`;
export const SearchFilterResultFragmentDoc = gql`
    fragment SearchFilterResult on ProductSearch_SearchFilterResponseModel {
  properties {
    id
    key
    type
    title
    unit
    enums {
      title
      key
    }
    range {
      min
      max
    }
  }
  manufacturers {
    id
    key
    title
  }
  tenants {
    id
    key
    title
  }
}
    `;
export const MemberFragmentDoc = gql`
    fragment Member on OrganizationsService_Members {
  firstName
  lastName
  email
  enabled
  role
  id
}
    `;
export const ProductSearchItemPreviewPriceInformationFragmentDoc = gql`
    fragment ProductSearchItemPreviewPriceInformation on ProductSearch_PreviewPriceInformationModel {
  productPricePerDay {
    amount
    type
  }
  tierPrices {
    minDays
    price
  }
  serviceFees {
    key
    value
  }
}
    `;
export const ProductSearchItemTenantFragmentDoc = gql`
    fragment ProductSearchItemTenant on ProductSearch_TenantModel {
  key
  logo {
    alt
    metadata {
      format
      height
      width
    }
    title
    url
  }
  name
}
    `;
export const ProductSearchItemFragmentDoc = gql`
    fragment ProductSearchItem on ProductSearch_ProductModel {
  id
  previewPriceInformation {
    ...ProductSearchItemPreviewPriceInformation
  }
  groupKey
  isDeliveryPossible
  hasHiddenPrice
  showPrices
  productImages {
    alt
    metadata {
      format
      height
      width
    }
    title
    url
  }
  properties {
    descriptor {
      enums {
        key
        id
        title
      }
      id
      key
      title
      type
      unit
    }
    isEquipment
    isFact
    isRolloverProperty
    isVariant
    key
    value
  }
  rentalStation {
    city
    countryCode
    distance
    id
    name
    street
    streetNumber
    zip
  }
  rentalStations {
    id
  }
  tenant {
    ...ProductSearchItemTenant
  }
  type {
    configuratorPageUrl
    id
    mainCategory {
      title
      id
    }
    manufacturer {
      title
      uriComponent
    }
    productPageUrl
    title
    uriComponent
  }
  shippingOptions {
    deliveryEnabled
    pickupEnabled
  }
}
    ${ProductSearchItemPreviewPriceInformationFragmentDoc}
${ProductSearchItemTenantFragmentDoc}`;
export const ProductSearchResponseFragmentDoc = gql`
    fragment ProductSearchResponse on ProductSearch_ProductSearchResponseModel {
  total
  pagination {
    hasMore
    currentPage
  }
  products {
    ...ProductSearchItem
  }
  loadedDate
  activeFilters {
    sort {
      by
    }
    radius
  }
}
    ${ProductSearchItemFragmentDoc}`;
export const RecommendedProductsResponseFragmentDoc = gql`
    fragment RecommendedProductsResponse on ProductSearch_RecommendedProductsResponseModel {
  total
  products {
    ...ProductSearchItem
  }
  loadedDate
}
    ${ProductSearchItemFragmentDoc}`;
export const RelatedProductsResponseFragmentDoc = gql`
    fragment RelatedProductsResponse on ProductSearch_RelatedProductsResponseModel {
  total
  products {
    ...ProductSearchItem
  }
  loadedDate
}
    ${ProductSearchItemFragmentDoc}`;
export const PlaceResponseFragmentDoc = gql`
    fragment PlaceResponse on PlaceModel {
  id
  name
  lng
  lat
}
    `;
export const TenantFragmentDoc = gql`
    fragment Tenant on Tenant {
  id
  key
  name
  digandoUrl
  logo {
    ...TenantLogo
  }
}
    ${TenantLogoFragmentDoc}`;
export const RecommendedProductsItemFragmentDoc = gql`
    fragment RecommendedProductsItem on ProductSearchItem {
  id: groupKey
  showPrices
  hasHiddenPrices
  prices {
    minDays
    price
  }
  productImage {
    ...ProductTypeImage
  }
  type {
    id
    datoId
    title
    text
    uriComponent
    productPageUrl
    configuratorPageUrl
    manufacturer {
      id
      title
    }
    mainCategory {
      id
      title
    }
    images {
      ...ProductTypeImage
    }
  }
  rentalStation {
    id
    name
    tenant {
      ...Tenant
    }
  }
  properties {
    key
    value
    isFact
    isVariant
    isRolloverProperty
    descriptor {
      ...PropertyDescriptor
    }
  }
}
    ${ProductTypeImageFragmentDoc}
${TenantFragmentDoc}
${PropertyDescriptorFragmentDoc}`;
export const ProductPriceResponseFragmentDoc = gql`
    fragment ProductPriceResponse on PriceService_ProductPriceModel {
  productPricePerDay {
    amount
    type
  }
  productPriceReducedPerDay {
    amount
    type
  }
  tierPrices {
    minDays
    price
  }
  serviceFees {
    key
    value
  }
  workingDays
}
    `;
export const BasketPageDocument = gql`
    query BasketPage {
  basketPage {
    data {
      ...BasketPageResponse
    }
  }
  categories {
    ...CategoriesResponse
  }
  cart {
    ...CartDetails
  }
}
    ${BasketPageResponseFragmentDoc}
${CategoriesResponseFragmentDoc}
${CartDetailsFragmentDoc}`;
export type BasketPageQueryResult = Apollo.QueryResult<BasketPageQuery, BasketPageQueryVariables>;
export const BlogCategoriesDocument = gql`
    query BlogCategories {
  blogCategories {
    data {
      id
      attributes {
        title
      }
    }
  }
}
    `;
export type BlogCategoriesQueryResult = Apollo.QueryResult<BlogCategoriesQuery, BlogCategoriesQueryVariables>;
export const BlogOverviewHeaderDocument = gql`
    query BlogOverviewHeader {
  headerPost: blogArticles(
    pagination: {start: 0, limit: 1}
    sort: ["publishedAt:desc"]
  ) {
    data {
      ...BlogOverviewArticle
    }
    meta {
      pagination {
        pageCount
      }
    }
  }
}
    ${BlogOverviewArticleFragmentDoc}`;
export type BlogOverviewHeaderQueryResult = Apollo.QueryResult<BlogOverviewHeaderQuery, BlogOverviewHeaderQueryVariables>;
export const BlogOverviewNewPostsDocument = gql`
    query BlogOverviewNewPosts {
  brandNewPosts: blogArticles(
    pagination: {start: 1, limit: 4}
    sort: ["publishedAt:desc"]
  ) {
    data {
      ...BlogOverviewArticle
    }
    meta {
      pagination {
        pageCount
      }
    }
  }
}
    ${BlogOverviewArticleFragmentDoc}`;
export type BlogOverviewNewPostsQueryResult = Apollo.QueryResult<BlogOverviewNewPostsQuery, BlogOverviewNewPostsQueryVariables>;
export const BlogOverviewDocument = gql`
    query BlogOverview($start: Int = 5, $postsPerPage: Int, $blogCategoryId: ID) {
  headerPost: blogArticles(
    pagination: {start: 0, limit: 1}
    sort: ["publishedAt:desc"]
  ) {
    data {
      ...BlogOverviewArticle
    }
    meta {
      pagination {
        pageCount
      }
    }
  }
  brandNewPosts: blogArticles(
    pagination: {start: 1, limit: 4}
    sort: ["publishedAt:desc"]
  ) {
    data {
      ...BlogOverviewArticle
    }
    meta {
      pagination {
        pageCount
      }
    }
  }
  posts: blogArticles(
    pagination: {start: $start, limit: $postsPerPage}
    filters: {blogCategory: {id: {eq: $blogCategoryId}}}
    sort: ["publishedAt:desc"]
  ) {
    data {
      ...BlogOverviewArticle
    }
    meta {
      pagination {
        pageCount
      }
    }
  }
  blogCategories {
    data {
      id
      attributes {
        title
      }
    }
  }
  blogOverview {
    data {
      attributes {
        createdAt
        updatedAt
        title
        seo {
          ...seoComponent
        }
        snippet {
          ...snippetComponent
        }
      }
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${BlogOverviewArticleFragmentDoc}
${SeoComponentFragmentDoc}
${SnippetComponentFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type BlogOverviewQueryResult = Apollo.QueryResult<BlogOverviewQuery, BlogOverviewQueryVariables>;
export const BlogPageDocument = gql`
    query BlogPage($slug: String!, $publicationState: PublicationState!) {
  blogArticles(filters: {slug: {eq: $slug}}, publicationState: $publicationState) {
    data {
      ...BlogArticleResponse
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${BlogArticleResponseFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type BlogPageQueryResult = Apollo.QueryResult<BlogPageQuery, BlogPageQueryVariables>;
export const ConfiguratorPageDocument = gql`
    query ConfiguratorPage {
  configuratorPage {
    data {
      ...ConfiguratorPageResponse
    }
  }
}
    ${ConfiguratorPageResponseFragmentDoc}`;
export type ConfiguratorPageQueryResult = Apollo.QueryResult<ConfiguratorPageQuery, ConfiguratorPageQueryVariables>;
export const ErrorPageDocument = gql`
    query ErrorPage {
  errorPage {
    data {
      ...ErrorPageResponse
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${ErrorPageResponseFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type ErrorPageQueryResult = Apollo.QueryResult<ErrorPageQuery, ErrorPageQueryVariables>;
export const HomepageDocument = gql`
    query Homepage {
  homepage {
    data {
      ...HomepageResponse
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${HomepageResponseFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type HomepageQueryResult = Apollo.QueryResult<HomepageQuery, HomepageQueryVariables>;
export const GetJobOverviewDocument = gql`
    query GetJobOverview {
  jobOverview {
    data {
      attributes {
        ...JobOverviewResponse
      }
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${JobOverviewResponseFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type GetJobOverviewQueryResult = Apollo.QueryResult<GetJobOverviewQuery, GetJobOverviewQueryVariables>;
export const JobDocument = gql`
    query Job($slug: String!, $publicationState: PublicationState!) {
  jobs(filters: {slug: {eq: $slug}}, publicationState: $publicationState) {
    data {
      ...JobResponse
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${JobResponseFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type JobQueryResult = Apollo.QueryResult<JobQuery, JobQueryVariables>;
export const GetLoginPageDocument = gql`
    query GetLoginPage {
  authProcess {
    data {
      attributes {
        emailVerifiedMessage
        signInIntroText
        signUpSuccessMessage
        loginPageTitle
        content {
          ... on ComponentContentTextWithBlock {
            ...ZoneTextWithImage
          }
          ... on ComponentContentActionButton {
            ...ZoneActionButton
          }
          ... on ComponentContentCategoryOverview {
            ...ZoneCategoryOverview
          }
          ... on ComponentContentCallToAction {
            ...ZoneCallToAction
          }
          ... on ComponentContentFaq {
            ...ZoneContentFaq
          }
          ... on ComponentContentQuoteBlock {
            ...ZoneContentQuoteBlock
          }
          ... on ComponentContentNewsletterSubscription {
            ...ZoneContentNewsletterSubscription
          }
          ... on ComponentContentContactSection {
            ...ZoneContentContactSection
          }
          ... on ComponentContentRecommendedCategories {
            ...ZoneContentRecommendedCategories
          }
          ... on ComponentContentHubspotForm {
            ...ZoneContentHubspotForm
          }
          ... on ComponentContentImagePresentation {
            ...ZoneContentImagePresentation
          }
          ... on ComponentContentPrivacySettings {
            ...ZoneContentPrivacySettings
          }
          ... on ComponentContentTenantLogos {
            ...ZoneContentTenantLogos
          }
          ... on ComponentContentTestimonials {
            ...ZoneContentTestimonials
          }
          ... on ComponentContentTextWithImage {
            ...ZoneContentTextWithImage
          }
          ... on ComponentContentUspCards {
            ...ZoneContentUspCards
          }
          ... on ComponentContentUspDigando {
            ...ZoneContentUspDigando
          }
          ... on ComponentContentYoutubeVideo {
            ...ZoneContentYoutubeVideo
          }
          ... on ComponentContentSearchBox {
            ...ZoneContentSearchBox
          }
          ... on ComponentContentOnBoarding {
            ...ZoneContentOnBoarding
          }
          ... on ComponentContentTextWithLink {
            ...ZoneContentTextWithLink
          }
          ... on ComponentContentUspProduct {
            ...ZoneContentUspProduct
          }
          ... on ComponentContentRentalStations {
            ...ZoneContentRentalStations
          }
          ... on ComponentContentInternalLinks {
            ...ZoneContentInternalLinks
          }
        }
      }
    }
  }
}
    ${ZoneTextWithImageFragmentDoc}
${ZoneActionButtonFragmentDoc}
${ZoneCategoryOverviewFragmentDoc}
${ZoneCallToActionFragmentDoc}
${ZoneContentFaqFragmentDoc}
${ZoneContentQuoteBlockFragmentDoc}
${ZoneContentNewsletterSubscriptionFragmentDoc}
${ZoneContentContactSectionFragmentDoc}
${ZoneContentRecommendedCategoriesFragmentDoc}
${ZoneContentHubspotFormFragmentDoc}
${ZoneContentImagePresentationFragmentDoc}
${ZoneContentPrivacySettingsFragmentDoc}
${ZoneContentTenantLogosFragmentDoc}
${ZoneContentTestimonialsFragmentDoc}
${ZoneContentTextWithImageFragmentDoc}
${ZoneContentUspCardsFragmentDoc}
${ZoneContentUspDigandoFragmentDoc}
${ZoneContentYoutubeVideoFragmentDoc}
${ZoneContentSearchBoxFragmentDoc}
${ZoneContentOnBoardingFragmentDoc}
${ZoneContentTextWithLinkFragmentDoc}
${ZoneContentUspProductFragmentDoc}
${ZoneContentRentalStationsFragmentDoc}
${ZoneContentInternalLinksFragmentDoc}`;
export type GetLoginPageQueryResult = Apollo.QueryResult<GetLoginPageQuery, GetLoginPageQueryVariables>;
export const GetNavigationDocument = gql`
    query GetNavigation {
  navigation {
    data {
      id
      attributes {
        header {
          id
          text
          navigationLinks {
            ...NavigationLink
          }
        }
        footerLeft {
          id
          ...NavigationLink
        }
        footerRight {
          id
          ...NavigationLink
        }
      }
    }
  }
}
    ${NavigationLinkFragmentDoc}`;
export type GetNavigationQueryResult = Apollo.QueryResult<GetNavigationQuery, GetNavigationQueryVariables>;
export const ProductPageDocument = gql`
    query ProductPage($location: LocationInput, $input: ProductBundleInput!, $productPriceInput: ProductPriceInput!) {
  productPage {
    data {
      ...ProductPageResponse
    }
  }
  productBundle(input: $input) {
    bundle {
      type {
        id
        title
        text
        productPageUrl
        configuratorPageUrl
        importAsUriComponent
        manufacturer {
          id
          title
        }
        mainCategory {
          id
          uriComponent
          relativeUrl
          title
          searchTitle
          parent {
            title
            relativeUrl
          }
        }
        images {
          ...ProductTypeImage
        }
        firstPublicationDate
      }
      selectedProduct {
        productImages {
          ...ProductTypeImage
        }
        hasHiddenPrices
        showPrices
      }
      properties {
        ...ProductProperty
      }
      priceInformation {
        productPricePerDay {
          amount
        }
        serviceFees {
          key
          value
        }
      }
      prices {
        minDays
        price
      }
      availableRentalStations {
        id
        name
        shortName
        street
        streetNumber
        city
        zip
        shippingOptions {
          deliveryEnabled
          pickupEnabled
        }
        country {
          iso2
          name
        }
      }
      selectedRentalStation {
        ...RentalStationCompact
        minimumRentalPeriodDays
        location {
          lat
          lng
          distance(referenceLocation: $location)
        }
      }
      availableProducts
    }
  }
  productPrice(input: $productPriceInput) {
    productPrice {
      product {
        amountPerDay
        amountPerDayReduced
        amount
      }
      total {
        amountPerDay
        amount
      }
      final {
        amount
        amountPerDay
      }
      discount {
        amount
      }
      discounts {
        amount
        discount {
          discount {
            type
            percent {
              value
            }
            amount {
              value
            }
          }
          code
        }
      }
      workingDays
    }
    productPriceError {
      code
      target
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${ProductPageResponseFragmentDoc}
${ProductTypeImageFragmentDoc}
${ProductPropertyFragmentDoc}
${RentalStationCompactFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type ProductPageQueryResult = Apollo.QueryResult<ProductPageQuery, ProductPageQueryVariables>;
export const SearchPageDocument = gql`
    query SearchPage($slug: String!, $location: String, $publicationState: PublicationState!) {
  searchPages(
    filters: {and: {slugSelector: {slug: {eq: $slug}}, searchLocation: {slug: {eq: $location}}}}
    publicationState: $publicationState
  ) {
    data {
      ...SearchPageResponse
    }
  }
}
    ${SearchPageResponseFragmentDoc}`;
export type SearchPageQueryResult = Apollo.QueryResult<SearchPageQuery, SearchPageQueryVariables>;
export const SitemapPageDocument = gql`
    query SitemapPage($start: Int, $limit: Int) {
  blogArticles(pagination: {start: $start, limit: $limit}) {
    ...BlogArticleSitemapResponse
  }
  jobs(pagination: {start: $start, limit: $limit}) {
    ...JobSitemapResponse
  }
  searchPages(pagination: {start: $start, limit: $limit}) {
    ...SearchSitemapResponse
  }
  standardPages(pagination: {start: $start, limit: $limit}) {
    ...StandartSitemapResponse
  }
  tenantPages(pagination: {start: $start, limit: $limit}) {
    ...TenantSitemapResponse
  }
}
    ${BlogArticleSitemapResponseFragmentDoc}
${JobSitemapResponseFragmentDoc}
${SearchSitemapResponseFragmentDoc}
${StandartSitemapResponseFragmentDoc}
${TenantSitemapResponseFragmentDoc}`;
export type SitemapPageQueryResult = Apollo.QueryResult<SitemapPageQuery, SitemapPageQueryVariables>;
export const StandardPageDocument = gql`
    query StandardPage($slug: String!, $publicationState: PublicationState!) {
  standardPages(filters: {slug: {eq: $slug}}, publicationState: $publicationState) {
    data {
      ...StandardPageResponse
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${StandardPageResponseFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type StandardPageQueryResult = Apollo.QueryResult<StandardPageQuery, StandardPageQueryVariables>;
export const TenantMapPageDocument = gql`
    query TenantMapPage($tenantKey: String!, $params: RentalStationsParams) {
  tenant(key: $tenantKey) {
    ...Tenant
  }
  rentalStations(params: $params) {
    data {
      ...RentalStationsItem
    }
  }
}
    ${TenantFragmentDoc}
${RentalStationsItemFragmentDoc}`;
export type TenantMapPageQueryResult = Apollo.QueryResult<TenantMapPageQuery, TenantMapPageQueryVariables>;
export const TenantPageDocument = gql`
    query TenantPage($slug: String!, $publicationState: PublicationState!) {
  tenantPages(filters: {slug: {eq: $slug}}, publicationState: $publicationState) {
    data {
      ...TenantPageResponse
    }
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${TenantPageResponseFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type TenantPageQueryResult = Apollo.QueryResult<TenantPageQuery, TenantPageQueryVariables>;
export const SearchPageByIdDocument = gql`
    query SearchPageById($id: ID!) {
  searchPage(id: $id) {
    data {
      id
      attributes {
        searchLocation {
          data {
            id
            attributes {
              slug
            }
          }
        }
        slugSelector {
          id
          slug
        }
      }
    }
  }
}
    `;
export type SearchPageByIdQueryResult = Apollo.QueryResult<SearchPageByIdQuery, SearchPageByIdQueryVariables>;
export const AddOrUpdateCartItemDocument = gql`
    mutation AddOrUpdateCartItem($input: AddOrUpdateCartItemInput!) {
  addOrUpdateCartItem(input: $input) {
    ...CartDetails
  }
}
    ${CartDetailsFragmentDoc}`;
export type AddOrUpdateCartItemMutationFn = Apollo.MutationFunction<AddOrUpdateCartItemMutation, AddOrUpdateCartItemMutationVariables>;
export type AddOrUpdateCartItemMutationResult = Apollo.MutationResult<AddOrUpdateCartItemMutation>;
export type AddOrUpdateCartItemMutationOptions = Apollo.BaseMutationOptions<AddOrUpdateCartItemMutation, AddOrUpdateCartItemMutationVariables>;
export const AddOrganizationAddressDocument = gql`
    mutation AddOrganizationAddress($address: OrganizationService_CreateAddress!) {
  OrganizationService_CreateAddress(address: $address) {
    id
  }
}
    `;
export type AddOrganizationAddressMutationFn = Apollo.MutationFunction<AddOrganizationAddressMutation, AddOrganizationAddressMutationVariables>;
export type AddOrganizationAddressMutationResult = Apollo.MutationResult<AddOrganizationAddressMutation>;
export type AddOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<AddOrganizationAddressMutation, AddOrganizationAddressMutationVariables>;
export const ApplyCouponDocument = gql`
    mutation ApplyCoupon($input: ApplyCouponInput!) {
  applyCoupon(input: $input) {
    ...CartDetails
  }
}
    ${CartDetailsFragmentDoc}`;
export type ApplyCouponMutationFn = Apollo.MutationFunction<ApplyCouponMutation, ApplyCouponMutationVariables>;
export type ApplyCouponMutationResult = Apollo.MutationResult<ApplyCouponMutation>;
export type ApplyCouponMutationOptions = Apollo.BaseMutationOptions<ApplyCouponMutation, ApplyCouponMutationVariables>;
export const AuthenticateDocument = gql`
    mutation Authenticate($input: AuthenticateInput!) {
  authenticate(input: $input) {
    migrated
  }
}
    `;
export type AuthenticateMutationFn = Apollo.MutationFunction<AuthenticateMutation, AuthenticateMutationVariables>;
export type AuthenticateMutationResult = Apollo.MutationResult<AuthenticateMutation>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<AuthenticateMutation, AuthenticateMutationVariables>;
export const BookCartDocument = gql`
    mutation bookCart($input: BookCartInput!) {
  bookCart(input: $input) {
    bookings
  }
}
    `;
export type BookCartMutationFn = Apollo.MutationFunction<BookCartMutation, BookCartMutationVariables>;
export type BookCartMutationResult = Apollo.MutationResult<BookCartMutation>;
export type BookCartMutationOptions = Apollo.BaseMutationOptions<BookCartMutation, BookCartMutationVariables>;
export const CancelBookingDocument = gql`
    mutation CancelBooking($input: CancelBookingInput!) {
  cancelBooking(input: $input) {
    id
  }
}
    `;
export type CancelBookingMutationFn = Apollo.MutationFunction<CancelBookingMutation, CancelBookingMutationVariables>;
export type CancelBookingMutationResult = Apollo.MutationResult<CancelBookingMutation>;
export type CancelBookingMutationOptions = Apollo.BaseMutationOptions<CancelBookingMutation, CancelBookingMutationVariables>;
export const DeleteOrganizationAddressDocument = gql`
    mutation DeleteOrganizationAddress($id: String!) {
  OrganizationService_DeleteAddress(id: $id) {
    deleted
  }
}
    `;
export type DeleteOrganizationAddressMutationFn = Apollo.MutationFunction<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>;
export type DeleteOrganizationAddressMutationResult = Apollo.MutationResult<DeleteOrganizationAddressMutation>;
export type DeleteOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>;
export const EndBookingDocument = gql`
    mutation EndBooking($input: EndBookingInput!) {
  endBooking(input: $input) {
    id
    price {
      amount
      currency
    }
  }
}
    `;
export type EndBookingMutationFn = Apollo.MutationFunction<EndBookingMutation, EndBookingMutationVariables>;
export type EndBookingMutationResult = Apollo.MutationResult<EndBookingMutation>;
export type EndBookingMutationOptions = Apollo.BaseMutationOptions<EndBookingMutation, EndBookingMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  RegisterService_ResetPassword(email: $email) {
    success
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($user: RegisterService_RegisterUser!, $organization: RegisterService_RegisterOrganization!, $affiliateId: String!, $crsAffiliateId: String!) {
  RegisterService_Register(
    user: $user
    organization: $organization
    affiliateId: $affiliateId
    crsAffiliateId: $crsAffiliateId
  ) {
    success
    errorMessage
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RemoveCartItemDocument = gql`
    mutation RemoveCartItem($input: RemoveCartItemInput!) {
  removeCartItem(input: $input) {
    ...CartDetails
  }
}
    ${CartDetailsFragmentDoc}`;
export type RemoveCartItemMutationFn = Apollo.MutationFunction<RemoveCartItemMutation, RemoveCartItemMutationVariables>;
export type RemoveCartItemMutationResult = Apollo.MutationResult<RemoveCartItemMutation>;
export type RemoveCartItemMutationOptions = Apollo.BaseMutationOptions<RemoveCartItemMutation, RemoveCartItemMutationVariables>;
export const SubscribeNewsletterDocument = gql`
    mutation SubscribeNewsletter($input: SubscribeInput!) {
  subscribe(input: $input) {
    email
  }
}
    `;
export type SubscribeNewsletterMutationFn = Apollo.MutationFunction<SubscribeNewsletterMutation, SubscribeNewsletterMutationVariables>;
export type SubscribeNewsletterMutationResult = Apollo.MutationResult<SubscribeNewsletterMutation>;
export type SubscribeNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribeNewsletterMutation, SubscribeNewsletterMutationVariables>;
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($input: UpdateBookingInput!) {
  updateBooking(input: $input) {
    id
    price {
      amount
      currency
    }
  }
}
    `;
export type UpdateBookingMutationFn = Apollo.MutationFunction<UpdateBookingMutation, UpdateBookingMutationVariables>;
export type UpdateBookingMutationResult = Apollo.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = Apollo.BaseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const UpdateOrganizationAddressDocument = gql`
    mutation UpdateOrganizationAddress($address: OrganizationService_UpdateAddress!) {
  OrganizationService_UpdateAddress(address: $address) {
    id
  }
}
    `;
export type UpdateOrganizationAddressMutationFn = Apollo.MutationFunction<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>;
export type UpdateOrganizationAddressMutationResult = Apollo.MutationResult<UpdateOrganizationAddressMutation>;
export type UpdateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($email: String!, $oldPassword: String!, $newPassword: String!) {
  RegisterService_UpdatePassword(
    email: $email
    oldPassword: $oldPassword
    newPassword: $newPassword
  ) {
    success
  }
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($profile: KeycloakUserService_UpdateUserInput!) {
  KeycloakUserService_UpdateUser(profile: $profile) {
    updated
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const AddressAutocompleteDocument = gql`
    query AddressAutocomplete($input: AutocompleteInput!, $field: AutocompleteFieldEnum!) {
  Geolocation_addressAutocomplete(params: $input, field: $field) {
    label
    addressData {
      street
      city
      zip
    }
  }
}
    `;
export type AddressAutocompleteQueryResult = Apollo.QueryResult<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>;
export const AuthProcessContentDocument = gql`
    query AuthProcessContent {
  authProcess {
    data {
      attributes {
        emailVerifiedMessage
        signInIntroText
        signUpSuccessMessage
      }
    }
  }
}
    `;
export type AuthProcessContentQueryResult = Apollo.QueryResult<AuthProcessContentQuery, AuthProcessContentQueryVariables>;
export const BasketDataDocument = gql`
    query BasketData {
  cart {
    ...CartDetails
  }
  tenants {
    data {
      ...Tenant
    }
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${CartDetailsFragmentDoc}
${TenantFragmentDoc}`;
export type BasketDataQueryResult = Apollo.QueryResult<BasketDataQuery, BasketDataQueryVariables>;
export const BookedBookingsDocument = gql`
    query BookedBookings($bookingNumbers: [String!]!) {
  BookingService_getBookingsByBookingNumbers(bookingNumbers: $bookingNumbers) {
    ...BookingServiceBookingDetail
  }
}
    ${BookingServiceBookingDetailFragmentDoc}`;
export type BookedBookingsQueryResult = Apollo.QueryResult<BookedBookingsQuery, BookedBookingsQueryVariables>;
export const BookingFilterOptionsDocument = gql`
    query BookingFilterOptions {
  BookingService_getUniqueBookingFilterOptions {
    bookingStatus
    productTypes {
      key
      value
    }
    tenantKeys {
      key
      value
    }
    projects {
      key
      value
    }
  }
}
    `;
export type BookingFilterOptionsQueryResult = Apollo.QueryResult<BookingFilterOptionsQuery, BookingFilterOptionsQueryVariables>;
export const GetBookingDocument = gql`
    query GetBooking($bookingNumber: String!) {
  BookingService_getBooking(bookingNumber: $bookingNumber) {
    ...BookingServiceBookingDetail
  }
}
    ${BookingServiceBookingDetailFragmentDoc}`;
export type GetBookingQueryResult = Apollo.QueryResult<GetBookingQuery, GetBookingQueryVariables>;
export const BookingsAsCsvDocument = gql`
    query BookingsAsCsv($filter: BookingService_BookingsFilter!) {
  BookingService_getBookingsAsCSV(filter: $filter)
}
    `;
export type BookingsAsCsvQueryResult = Apollo.QueryResult<BookingsAsCsvQuery, BookingsAsCsvQueryVariables>;
export const CartDocument = gql`
    query cart {
  cart {
    ...CartDetails
  }
}
    ${CartDetailsFragmentDoc}`;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const CatalogSearchDocument = gql`
    query CatalogSearch($keyword: String!, $tenantKey: String) {
  results: catalogSearch(text: $keyword, tenantKey: $tenantKey) {
    ...ProductType
    ...CategoryTree
    ...Tenant
  }
}
    ${ProductTypeFragmentDoc}
${CategoryTreeFragmentDoc}
${TenantFragmentDoc}`;
export type CatalogSearchQueryResult = Apollo.QueryResult<CatalogSearchQuery, CatalogSearchQueryVariables>;
export const CategoriesDocument = gql`
    query Categories {
  categories {
    data {
      ...CategoryTree
    }
  }
}
    ${CategoryTreeFragmentDoc}`;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const CategoryByTextDocument = gql`
    query CategoryByText($text: String!) {
  categoryByText(text: $text) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export type CategoryByTextQueryResult = Apollo.QueryResult<CategoryByTextQuery, CategoryByTextQueryVariables>;
export const CategoryByUriComponentDocument = gql`
    query CategoryByUriComponent($uriComponent: String!) {
  categoryByUriComponent(uriComponent: $uriComponent) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export type CategoryByUriComponentQueryResult = Apollo.QueryResult<CategoryByUriComponentQuery, CategoryByUriComponentQueryVariables>;
export const CategorySitemapVirtualDocument = gql`
    query CategorySitemapVirtual {
  searchPages(pagination: {limit: 10000}) {
    data {
      id
      attributes {
        slugSelector {
          id
          slug
        }
        searchLocation {
          data {
            id
            attributes {
              slug
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type CategorySitemapVirtualQueryResult = Apollo.QueryResult<CategorySitemapVirtualQuery, CategorySitemapVirtualQueryVariables>;
export const CategorySitemapDocument = gql`
    query CategorySitemap {
  categories {
    data {
      id
      relativeUrl
      children {
        id
        relativeUrl
        children {
          id
          relativeUrl
        }
      }
    }
    total
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
  tenants {
    data {
      ...Tenant
    }
  }
}
    ${TenantFragmentDoc}`;
export type CategorySitemapQueryResult = Apollo.QueryResult<CategorySitemapQuery, CategorySitemapQueryVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    `;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const DatoDocumentRelationsDocument = gql`
    query DatoDocumentRelations($input: DatoDocumentRelationsInput!) {
  datoDocumentRelations(input: $input) {
    urls
  }
}
    `;
export type DatoDocumentRelationsQueryResult = Apollo.QueryResult<DatoDocumentRelationsQuery, DatoDocumentRelationsQueryVariables>;
export const GeolocationDocument = gql`
    query Geolocation($input: GeolocationInput!) {
  Geolocation_geolocation(params: $input) {
    address {
      city
      country
      street
      streetNumber
      zip
    }
    lat
    lng
    locationQuality {
      score
      sourceService
    }
    radius
    correctedFields {
      fieldName
      originalValue
      correctedValue
    }
    normalizedAddress {
      city
      country
      street
      streetNumber
      zip
    }
  }
}
    `;
export type GeolocationQueryResult = Apollo.QueryResult<GeolocationQuery, GeolocationQueryVariables>;
export const GetAddressesDocument = gql`
    query GetAddresses {
  OrganizationService_MeAddresses(sort: {by: NAME, order: ASC}) {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export type GetAddressesQueryResult = Apollo.QueryResult<GetAddressesQuery, GetAddressesQueryVariables>;
export const HasUserBeenMigratedDocument = gql`
    query HasUserBeenMigrated($email: String!) {
  RegisterService_HasUserBeenMigrated(email: $email)
}
    `;
export type HasUserBeenMigratedQueryResult = Apollo.QueryResult<HasUserBeenMigratedQuery, HasUserBeenMigratedQueryVariables>;
export const LocationAutocompleteDocument = gql`
    query locationAutocomplete($params: GetLocationsInput!) {
  Geolocation_getLocations(params: $params) {
    locations {
      label
      data {
        x
        y
      }
    }
  }
}
    `;
export type LocationAutocompleteQueryResult = Apollo.QueryResult<LocationAutocompleteQuery, LocationAutocompleteQueryVariables>;
export const LocationByPlaceIdDocument = gql`
    query LocationByPlaceId($id: String!) {
  Geolocation_locationByPlace(id: $id) {
    id
    name
    lat
    lng
    radius
    address {
      street
      streetNumber
      zip
      city
      country
    }
  }
}
    `;
export type LocationByPlaceIdQueryResult = Apollo.QueryResult<LocationByPlaceIdQuery, LocationByPlaceIdQueryVariables>;
export const LocationByUriComponentDocument = gql`
    query LocationByUriComponent($uriComponent: String!) {
  Geolocation_getLocationInformation(uriComponent: $uriComponent) {
    id
    name
    radius
    lat
    lng
  }
}
    `;
export type LocationByUriComponentQueryResult = Apollo.QueryResult<LocationByUriComponentQuery, LocationByUriComponentQueryVariables>;
export const MeDocument = gql`
    query Me {
  KeycloakUserService_me {
    ...MeDetails
  }
  OrganizationService_OrganizationForUser {
    ...OrganizationResponse
  }
}
    ${MeDetailsFragmentDoc}
${OrganizationResponseFragmentDoc}`;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CheckVatIdDocument = gql`
    query CheckVatId($vatId: String!) {
  OrganizationService_CheckVatId(vatId: $vatId) {
    vatId
    valid
    name
    address {
      zip
      streetNumber
      street
      countryCode
      city
    }
  }
}
    `;
export type CheckVatIdQueryResult = Apollo.QueryResult<CheckVatIdQuery, CheckVatIdQueryVariables>;
export const GetorganizationMembersDocument = gql`
    query GetorganizationMembers {
  OrganizationService_MembersForUserOrganization {
    members {
      ...Member
    }
    total
  }
}
    ${MemberFragmentDoc}`;
export type GetorganizationMembersQueryResult = Apollo.QueryResult<GetorganizationMembersQuery, GetorganizationMembersQueryVariables>;
export const BookingPageDocument = gql`
    query BookingPage($bookingNumber: String!) {
  BookingService_getBooking(bookingNumber: $bookingNumber) {
    ...BookingServiceBookingDetail
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${BookingServiceBookingDetailFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type BookingPageQueryResult = Apollo.QueryResult<BookingPageQuery, BookingPageQueryVariables>;
export const BookingsPageDocument = gql`
    query BookingsPage($pagination: BookingService_PaginationArgs!, $filter: BookingService_BookingsFilter) {
  BookingService_getBookings(pagination: $pagination, filter: $filter) {
    bookings {
      ...BookingServiceBookingDetail
    }
    total
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${BookingServiceBookingDetailFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type BookingsPageQueryResult = Apollo.QueryResult<BookingsPageQuery, BookingsPageQueryVariables>;
export const ConfiguratorLoginPageDocument = gql`
    query ConfiguratorLoginPage($input: ProductBundleInput!) {
  productBundle(input: $input) {
    bundle {
      type {
        productPageUrl
        title
        manufacturer {
          title
        }
        mainCategory {
          title
          relativeUrl
          parent {
            relativeUrl
            title
          }
        }
      }
      properties {
        ...ProductProperty
      }
    }
  }
}
    ${ProductPropertyFragmentDoc}`;
export type ConfiguratorLoginPageQueryResult = Apollo.QueryResult<ConfiguratorLoginPageQuery, ConfiguratorLoginPageQueryVariables>;
export const ContentPageDocument = gql`
    query ContentPage {
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${CategoriesResponseFragmentDoc}`;
export type ContentPageQueryResult = Apollo.QueryResult<ContentPageQuery, ContentPageQueryVariables>;
export const SitemapProductTypesDocument = gql`
    query SitemapProductTypes {
  productTypes {
    data {
      id
      relativeUrl
      accessoryOnly
      importAsUriComponent
    }
  }
}
    `;
export type SitemapProductTypesQueryResult = Apollo.QueryResult<SitemapProductTypesQuery, SitemapProductTypesQueryVariables>;
export const SearchPageDataDocument = gql`
    query SearchPageData($pagination: ProductSearch_PaginationInput!, $dateRange: ProductSearch_DateRangeInput!, $geoPoint: ProductSearch_GeoPointInput, $enumProperties: [ProductSearch_EnumPropertiesInput!]!, $rangeProperties: [ProductSearch_RangePropertiesInput!]!, $manufacturers: [String!]!, $tenantKeys: [String!]!, $uriComponent: String!, $countryCode: String, $text: String, $searchSort: ProductSearch_SearchSortInput) {
  ProductSearch_searchProducts(
    pagination: $pagination
    dateRange: $dateRange
    geoPoint: $geoPoint
    enumProperties: $enumProperties
    rangeProperties: $rangeProperties
    manufacturers: $manufacturers
    tenantKeys: $tenantKeys
    uriComponent: $uriComponent
    countryCode: $countryCode
    text: $text
    searchSort: $searchSort
  ) {
    ...ProductSearchResponse
  }
  ProductSearch_searchFilter(
    pagination: $pagination
    dateRange: $dateRange
    geoPoint: $geoPoint
    enumProperties: $enumProperties
    rangeProperties: $rangeProperties
    manufacturers: $manufacturers
    tenantKeys: $tenantKeys
    uriComponent: $uriComponent
    countryCode: $countryCode
    text: $text
    searchSort: $searchSort
  ) {
    ...SearchFilterResult
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${ProductSearchResponseFragmentDoc}
${SearchFilterResultFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type SearchPageDataQueryResult = Apollo.QueryResult<SearchPageDataQuery, SearchPageDataQueryVariables>;
export const StaticSearchPageDocument = gql`
    query StaticSearchPage {
  categories {
    ...CategoriesResponse
  }
}
    ${CategoriesResponseFragmentDoc}`;
export type StaticSearchPageQueryResult = Apollo.QueryResult<StaticSearchPageQuery, StaticSearchPageQueryVariables>;
export const PlaceDocument = gql`
    query Place($params: PlaceInput!) {
  Geolocation_place(params: $params) {
    ...PlaceResponse
  }
}
    ${PlaceResponseFragmentDoc}`;
export type PlaceQueryResult = Apollo.QueryResult<PlaceQuery, PlaceQueryVariables>;
export const PlacesDocument = gql`
    query Places($params: PlacesInput!) {
  Geolocation_places(params: $params) {
    __typename
    data {
      id
      name
      radius
    }
  }
}
    `;
export type PlacesQueryResult = Apollo.QueryResult<PlacesQuery, PlacesQueryVariables>;
export const ProductBundleDocument = gql`
    query ProductBundle($location: LocationInput, $input: ProductBundleInput!, $rentalStationProductBundleInput: ProductBundleInput!, $fullProductBundleInput: ProductBundleInput!, $productPriceInput: ProductPriceInput!) {
  productBundle(input: $input) {
    bundle {
      ...ProductBundle
    }
    accessories {
      ...ProductBundleAccessories
    }
    relatedProducts {
      ...ProductBundleRelatedProducts
    }
  }
  rentalStationProductBundle: productBundle(
    input: $rentalStationProductBundleInput
  ) {
    bundle {
      properties {
        ...ProductProperty
      }
    }
  }
  fullProductBundle: productBundle(input: $fullProductBundleInput) {
    bundle {
      ...FullProductBundleResponse
    }
  }
  productPrice(input: $productPriceInput) {
    productPrice {
      product {
        amountPerDay
        amountPerDayReduced
        amount
      }
      accessories {
        id: identifier
        identifier
        isSelected
        quantity
        title
        price {
          amount
          amountPerDay
          amountPerDayReduced
        }
      }
      accessory {
        amount
        amountPerDay
        amountPerDayReduced
      }
      insurance {
        mode
        percentage
        price {
          amountPerDay
          amount
        }
      }
      shipping {
        amount
      }
      total {
        amountPerDay
        amount
      }
      final {
        amount
        amountPerDay
      }
      taxes {
        percentage
        price {
          amountPerDay
          amount
        }
      }
      discount {
        amount
      }
      workingDays
      productAmount
      serviceFees {
        key
        value
      }
    }
    productPriceError {
      code
      target
    }
  }
  cart {
    ...CartDetails
  }
  categories {
    ...CategoriesResponse
  }
  countries {
    data {
      id: iso2
      iso2
      name
    }
  }
}
    ${ProductBundleFragmentDoc}
${ProductBundleAccessoriesFragmentDoc}
${ProductBundleRelatedProductsFragmentDoc}
${ProductPropertyFragmentDoc}
${FullProductBundleResponseFragmentDoc}
${CartDetailsFragmentDoc}
${CategoriesResponseFragmentDoc}`;
export type ProductBundleQueryResult = Apollo.QueryResult<ProductBundleQuery, ProductBundleQueryVariables>;
export const ProductSearchFilterDocument = gql`
    query ProductSearchFilter($refresh: Boolean!, $pagination: ProductSearch_PaginationInput!, $dateRange: ProductSearch_DateRangeInput!, $geoPoint: ProductSearch_GeoPointInput, $enumProperties: [ProductSearch_EnumPropertiesInput!]!, $rangeProperties: [ProductSearch_RangePropertiesInput!]!, $manufacturers: [String!]!, $tenantKeys: [String!]!, $uriComponent: String!, $countryCode: String, $text: String, $searchSort: ProductSearch_SearchSortInput) {
  ProductSearch_searchFilter(
    refresh: $refresh
    pagination: $pagination
    dateRange: $dateRange
    geoPoint: $geoPoint
    enumProperties: $enumProperties
    rangeProperties: $rangeProperties
    manufacturers: $manufacturers
    tenantKeys: $tenantKeys
    uriComponent: $uriComponent
    countryCode: $countryCode
    text: $text
    searchSort: $searchSort
  ) {
    ...SearchFilterResult
  }
}
    ${SearchFilterResultFragmentDoc}`;
export type ProductSearchFilterQueryResult = Apollo.QueryResult<ProductSearchFilterQuery, ProductSearchFilterQueryVariables>;
export const ProductSearchDocument = gql`
    query ProductSearch($refresh: Boolean!, $pagination: ProductSearch_PaginationInput!, $dateRange: ProductSearch_DateRangeInput!, $geoPoint: ProductSearch_GeoPointInput, $enumProperties: [ProductSearch_EnumPropertiesInput!]!, $rangeProperties: [ProductSearch_RangePropertiesInput!]!, $manufacturers: [String!]!, $tenantKeys: [String!]!, $uriComponent: String!, $countryCode: String, $text: String, $searchSort: ProductSearch_SearchSortInput) {
  ProductSearch_searchProducts(
    refresh: $refresh
    pagination: $pagination
    dateRange: $dateRange
    geoPoint: $geoPoint
    enumProperties: $enumProperties
    rangeProperties: $rangeProperties
    manufacturers: $manufacturers
    tenantKeys: $tenantKeys
    uriComponent: $uriComponent
    countryCode: $countryCode
    text: $text
    searchSort: $searchSort
  ) {
    ...ProductSearchResponse
  }
}
    ${ProductSearchResponseFragmentDoc}`;
export type ProductSearchQueryResult = Apollo.QueryResult<ProductSearchQuery, ProductSearchQueryVariables>;
export const ProductTypesDocument = gql`
    query ProductTypes {
  productTypes {
    data {
      id
      title
      relativeUrl
      relativeUrls {
        locale
        value
      }
    }
  }
}
    `;
export type ProductTypesQueryResult = Apollo.QueryResult<ProductTypesQuery, ProductTypesQueryVariables>;
export const ProjectsDocument = gql`
    query Projects($pagination: PaginationArgs!, $filter: OrganizationService_FilterProjectArgs) {
  OrganizationService_MeProjects(
    pagination: $pagination
    filter: $filter
    sort: {by: NAME, order: ASC}
  ) {
    projects {
      id
      name
      externalProjectId
      addresses {
        id
        name
        street
        streetNumber
        city
        zipCode
        countryCode
        createdAt
        geoPoint {
          latitude
          longitude
        }
      }
    }
    total
  }
}
    `;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const PropertyDescriptorsDocument = gql`
    query PropertyDescriptors {
  propertyDescriptors {
    data {
      ...PropertyDescriptor
    }
  }
}
    ${PropertyDescriptorFragmentDoc}`;
export type PropertyDescriptorsQueryResult = Apollo.QueryResult<PropertyDescriptorsQuery, PropertyDescriptorsQueryVariables>;
export const RelatedProductsDocument = gql`
    query relatedProducts($categoryUriComponent: String!, $dateRange: ProductSearch_DateRangeInput, $geoPoint: ProductSearch_GeoPointInput) {
  ProductSearch_relatedProducts(
    categoryUriComponent: $categoryUriComponent
    dateRange: $dateRange
    geoPoint: $geoPoint
  ) {
    ...RelatedProductsResponse
  }
}
    ${RelatedProductsResponseFragmentDoc}`;
export type RelatedProductsQueryResult = Apollo.QueryResult<RelatedProductsQuery, RelatedProductsQueryVariables>;
export const RentalStationByIdDocument = gql`
    query RentalStationById($identifier: String!) {
  getRentalStationByIdentifier(identifier: $identifier) {
    id: identifier
    nonWorkingDays
  }
}
    `;
export type RentalStationByIdQueryResult = Apollo.QueryResult<RentalStationByIdQuery, RentalStationByIdQueryVariables>;
export const RentalStationsDocument = gql`
    query RentalStations($params: RentalStationsParams) {
  rentalStations(params: $params) {
    data {
      ...RentalStationsItem
    }
  }
}
    ${RentalStationsItemFragmentDoc}`;
export type RentalStationsQueryResult = Apollo.QueryResult<RentalStationsQuery, RentalStationsQueryVariables>;
export const ServiceInfoDocument = gql`
    query ServiceInfo {
  serviceInfo {
    name
    version
  }
}
    `;
export type ServiceInfoQueryResult = Apollo.QueryResult<ServiceInfoQuery, ServiceInfoQueryVariables>;
export const ProductCardPriceDocument = gql`
    query ProductCardPrice($productId: ID!, $dateRange: PriceService_DateRangeInput!) {
  PriceService_productPrice(productId: $productId, dateRange: $dateRange) {
    ...ProductPriceResponse
  }
}
    ${ProductPriceResponseFragmentDoc}`;
export type ProductCardPriceQueryResult = Apollo.QueryResult<ProductCardPriceQuery, ProductCardPriceQueryVariables>;
export const RecommendedProductsSliceDocument = gql`
    query RecommendedProductsSlice($countryCode: String, $productTypeUriComponents: [String!]!, $tenantKeys: [String!]) {
  ProductSearch_recommendedProducts(
    countryCode: $countryCode
    productTypeUriComponents: $productTypeUriComponents
    tenantKeys: $tenantKeys
  ) {
    ...RecommendedProductsResponse
  }
}
    ${RecommendedProductsResponseFragmentDoc}`;
export type RecommendedProductsSliceQueryResult = Apollo.QueryResult<RecommendedProductsSliceQuery, RecommendedProductsSliceQueryVariables>;
export const RentalStationsSliceDocument = gql`
    query RentalStationsSlice($params: RentalStationsParams) {
  rentalStations(params: $params) {
    data {
      shortName
      zip
      city
      street
      streetNumber
      country {
        iso2
      }
      shippingOptions {
        deliveryEnabled
        pickupEnabled
      }
      location {
        lat
        lng
      }
    }
  }
}
    `;
export type RentalStationsSliceQueryResult = Apollo.QueryResult<RentalStationsSliceQuery, RentalStationsSliceQueryVariables>;
export const TenantByKeyDocument = gql`
    query TenantByKey($tenantKey: String!) {
  tenant(key: $tenantKey) {
    ...Tenant
  }
}
    ${TenantFragmentDoc}`;
export type TenantByKeyQueryResult = Apollo.QueryResult<TenantByKeyQuery, TenantByKeyQueryVariables>;
export const TenantsDocument = gql`
    query Tenants {
  tenants {
    data {
      ...Tenant
    }
  }
}
    ${TenantFragmentDoc}`;
export type TenantsQueryResult = Apollo.QueryResult<TenantsQuery, TenantsQueryVariables>;
export const ValidateAddressesDocument = gql`
    query ValidateAddresses($params: PlacesInput!) {
  Geolocation_validateAddresses(params: $params) {
    __typename
    data {
      id
      name
    }
  }
}
    `;
export type ValidateAddressesQueryResult = Apollo.QueryResult<ValidateAddressesQuery, ValidateAddressesQueryVariables>;